// import React, { useState, useEffect } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faTimes } from '@fortawesome/free-solid-svg-icons';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import './signupstyle.css';

// const ServitorSignup = ({ onClose }) => {
//     const [firstName, setFirstName] = useState('');
//     const [lastName, setLastName] = useState('');
//     const [email, setEmail] = useState('');
//     const [mobile, setMobile] = useState('');
//     const [password, setPassword] = useState('');
//     const [nidPassport, setNidPassport] = useState('');
//     const [dob, setDob] = useState('');
//     const [selectedGender, setSelectedGender] = useState(null);
//     const [selectedCity, setSelectedCity] = useState('');
//     const [selectedService, setSelectedService] = useState('');
//     const [address, setAddress] = useState('');
//     const [experience, setExperience] = useState('');
//     const [image, setImage] = useState(null);
//     const [certificate, setCertificate] = useState(null);
//     const [services, setServices] = useState([]);
//     const navigate = useNavigate();

//     // Fetch services from backend
//     useEffect(() => {
//         const fetchServices = async () => {
//             try {
//                 const response = await axios.get('http://localhost:4001/services');
//                 setServices(response.data);
//             } catch (error) {
//                 console.error('Error fetching services:', error);
//             }
//         };
//         fetchServices();
//     }, []);

//     const handleGenderSelection = (gender) => {
//         setSelectedGender(gender);
//     };

//     const handleFileUpload = (e, setFile) => {
//         setFile(e.target.files[0]); // Handles file input for both image and certificate
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
        
//         if (!firstName || !lastName || !email || !mobile || !password || !nidPassport || !dob || !selectedGender || !selectedService || !selectedCity || !address) {
//             alert('Please fill out all required fields.');
//             return;
//         }

//         const formData = new FormData();
//         formData.append('firstName', firstName);
//         formData.append('lastName', lastName);
//         formData.append('email', email);
//         formData.append('mobile', mobile);
//         formData.append('password', password);
//         formData.append('NID', nidPassport);
//         formData.append('dob', dob);
//         formData.append('gender', selectedGender);
//         formData.append('service', selectedService);
//         formData.append('city', selectedCity);
//         formData.append('Address', address);
//         formData.append('experience', experience);

//         if (image) formData.append('image', image);
//         if (certificate) formData.append('certificate', certificate);

//         try {
//             await axios.post('http://localhost:4001/servitors', formData, {
//                 headers: {
//                     'Content-Type': 'multipart/form-data',
//                 },
//             });

//             // Redirect to homepage on successful signup
//             navigate('/');
//         } catch (error) {
//             console.error('Error during sign up:', error);
//         }
//     };

//     return (
//         <div className="signup-modal">
//             <div className="signup-modal-content">
//                 <div className="close-icon" onClick={onClose}>
//                     <FontAwesomeIcon icon={faTimes} />
//                 </div>
//                 <div className='signup-header'>
//                     <h1>Servitor</h1>
//                     <div className='signup-underline'></div>
//                 </div>
//                 <div className="form-container">
//                     <form className="signup-form" onSubmit={handleSubmit}>
//                         {/* Personal Info Section */}
//                         <div className="form-row">
//                             <div className="col">
//                                 <input
//                                     type="text"
//                                     placeholder='First Name'
//                                     value={firstName}
//                                     onChange={(e) => setFirstName(e.target.value)}
//                                     required
//                                 />
//                             </div>
//                             <div className="col">
//                                 <input
//                                     type="text"
//                                     placeholder='Last Name'
//                                     value={lastName}
//                                     onChange={(e) => setLastName(e.target.value)}
//                                     required
//                                 />
//                             </div>
//                         </div>
//                         <div className="form-row">
//                             <div className="col">
//                                 <input
//                                     type="email"
//                                     placeholder='Email'
//                                     value={email}
//                                     onChange={(e) => setEmail(e.target.value)}
//                                     required
//                                 />
//                             </div>
//                             <div className="col">
//                                 <input
//                                     type="tel"
//                                     placeholder='Mobile No'
//                                     value={mobile}
//                                     onChange={(e) => setMobile(e.target.value)}
//                                     required
//                                 />
//                             </div>
//                         </div>
//                         {/* Password and NID/Passport */}
//                         <div className="form-row">
//                             <div className="col">
//                                 <input
//                                     type="password"
//                                     placeholder='Password'
//                                     value={password}
//                                     onChange={(e) => setPassword(e.target.value)}
//                                     required
//                                 />
//                             </div>
//                             <div className="col">
//                                 <input
//                                     type="text"
//                                     placeholder='NID/Passport No'
//                                     value={nidPassport}
//                                     onChange={(e) => setNidPassport(e.target.value)}
//                                     required
//                                 />
//                             </div>
//                         </div>
//                         {/* Date of Birth and Gender */}
//                         <div className="form-row">
//                             <div className="col">
//                                 <label htmlFor="dob">Date of Birth</label>
//                                 <input
//                                     type="date"
//                                     id="dob"
//                                     value={dob}
//                                     onChange={(e) => setDob(e.target.value)}
//                                     required
//                                 />
//                             </div>
//                             <div className="col">
//                                 <label>Gender</label>
//                                 <div className="checkbox-box">
//                                     <label>
//                                         <input
//                                             type="radio"
//                                             name="gender"
//                                             value="male"
//                                             checked={selectedGender === 'male'}
//                                             onChange={() => handleGenderSelection('male')}
//                                         />
//                                         Male
//                                     </label>
//                                     <label>
//                                         <input
//                                             type="radio"
//                                             name="gender"
//                                             value="female"
//                                             checked={selectedGender === 'female'}
//                                             onChange={() => handleGenderSelection('female')}
//                                         />
//                                         Female
//                                     </label>
//                                 </div>
//                             </div>
//                         </div>
//                         {/* Service Selection */}
//                         <div className="form-row">
//                             <div className="col">
//                                 <select value={selectedService} onChange={(e) => setSelectedService(e.target.value)} required>
//                                     <option value="">Select your service</option>
//                                     {services.map((service) => (
//                                         <option key={service.Id} value={service.services_name}>
//                                             {service.services_name}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div>
//                         </div>
//                         {/* City and Address */}
//                         <div className="form-row">
//                             <div className="col">
//                                 <select value={selectedCity} onChange={(e) => setSelectedCity(e.target.value)} required>
//                                     <option value="">Select your City</option>
//                                     <option value="Dhaka">Dhaka</option>
//                                     <option value="Chattogram">Chattogram</option>
//                                     <option value="Barishal">Barishal</option>
//                                     <option value="Sylhet">Sylhet</option>
//                                     <option value="Rajshahi">Rajshahi</option>
//                                     <option value="Khulna">Khulna</option>
//                                     <option value="Rangpur">Rangpur</option>
//                                     <option value="Maymensingh">Maymensingh</option>
//                                 </select>
//                             </div>
//                             <div className="col">
//                                 <input
//                                     type="text"
//                                     placeholder='Address'
//                                     value={address}
//                                     onChange={(e) => setAddress(e.target.value)}
//                                     required
//                                 />
//                             </div>
//                         </div>
//                         {/* Experience */}
//                         <div className="form-row">
//                             <div className="col">
//                                 <input
//                                     type="number"
//                                     placeholder='Experience (Years)'
//                                     value={experience}
//                                     onChange={(e) => setExperience(e.target.value)}
//                                     min="0"
//                                     required
//                                 />
//                             </div>
//                         </div>
//                         {/* Image Upload */}
//                         <div className="form-row">
//                             <div className="col upload-box">
//                                 <label>Upload your passport size photo</label>
//                                 <input type="file" accept="image/*" onChange={(e) => handleFileUpload(e, setImage)} />
//                             </div>
//                         </div>
//                         {/* Certificate Upload */}
//                         <div className="form-row">
//                             <div className="col upload-box">
//                                 <label>Upload Certificate/Documents</label>
//                                 <input type="file" onChange={(e) => handleFileUpload(e, setCertificate)} />
//                             </div>
//                         </div>
//                         <div className="form-note">
//                             *Please provide accurate and true information. If the information is incorrect, your registration will be canceled.
//                         </div>
//                         <button className="submit-btn" type="submit">Sign Up</button>
//                         {/* Submit Button */}
//                         {/* <div className="form-row">
//                             <div className="col">
//                                 <button type="submit" className="signup-btn">Sign Up</button>
//                             </div>
//                         </div> */}
//                     </form>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ServitorSignup;


// ***** Upper All codes is okay and checked (22-6-25) ***** //
















// // ***** Add Translate and update EN-BN (22-6-25) ***** //
// import React, { useState, useEffect, useMemo } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import "./signupstyle.css";

// const ServitorSignup = ({ onClose }) => {
//   const { t, i18n } = useTranslation();

//   const [firstName, setFirstName] = useState("");
//   const [lastName, setLastName] = useState("");
//   const [email, setEmail] = useState("");
//   const [mobile, setMobile] = useState("");
//   const [password, setPassword] = useState("");
//   const [nidPassport, setNidPassport] = useState("");
//   const [dob, setDob] = useState("");
//   const [selectedGender, setSelectedGender] = useState(null);
//   const [selectedCity, setSelectedCity] = useState("");
//   const [selectedService, setSelectedService] = useState("");
//   const [address, setAddress] = useState("");
//   const [experience, setExperience] = useState("");
//   const [image, setImage] = useState(null);
//   const [certificate, setCertificate] = useState(null);
//   const [services, setServices] = useState([]);
//   const navigate = useNavigate();

//   // New added for Tutor Servitor
//   const [universityType, setUniversityType] = useState("");
//   const [universityName, setUniversityName] = useState("");
//   const [major, setMajor] = useState("");
//   const [studentIdCard, setStudentIdCard] = useState(null);

//   // Decide when to show the Tutor fields
//   const isTutor = useMemo(
//     () => (selectedService || "").toLowerCase().includes("tutor"),
//     [selectedService]
//   );

//   // Optional: clear tutor fields if user moves away from Tutor service
//   useEffect(() => {
//     if (!isTutor) {
//       setUniversityType("");
//       setUniversityName("");
//       setMajor("");
//       setStudentIdCard(null);
//     }
//   }, [isTutor]);

//   // Fetch services from backend
//   useEffect(() => {
//     const fetchServices = async () => {
//       try {
//         const response = await axios.get("http://localhost:4001/services");
//         setServices(response.data);
//       } catch (error) {
//         console.error("Error fetching services:", error);
//       }
//     };
//     fetchServices();
//   }, []);

//   const handleGenderSelection = (gender) => {
//     setSelectedGender(gender);
//   };

//   const handleFileUpload = (e, setFile) => {
//     setFile(e.target.files[0]); // Handles file input for both image and certificate
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (
//       !firstName ||
//       !lastName ||
//       !email ||
//       !mobile ||
//       !password ||
//       !nidPassport ||
//       !dob ||
//       !selectedGender ||
//       !selectedService ||
//       !selectedCity ||
//       !address
//     ) {
//       alert("Please fill out all required fields.");
//       return;
//     }

//     // For new added Tutor Servitor
//     // extra validations for Tutor only
//     if (isTutor) {
//       if (!universityType) return alert("Please select your university type.");
//       if (!universityName.trim()) return alert("Please enter your university name.");
//       if (!major.trim()) return alert("Please enter your major/department.");
//       if (!studentIdCard) return alert("Please upload your Student ID card.");
//     }

//     const formData = new FormData();
//     formData.append("firstName", firstName);
//     formData.append("lastName", lastName);
//     formData.append("email", email);
//     formData.append("mobile", mobile);
//     formData.append("password", password);
//     formData.append("NID", nidPassport);
//     formData.append("dob", dob);
//     formData.append("gender", selectedGender);
//     formData.append("service", selectedService);
//     formData.append("city", selectedCity);
//     formData.append("Address", address);
//     formData.append("experience", experience);

//     if (image) formData.append("image", image);
//     if (certificate) formData.append("certificate", certificate);

//     if (isTutor) {
//       formData.append("universityType", universityType.toLowerCase()); // "buet" | "medical" | "public" | "private" | "other"
//       formData.append("universityName", universityName.trim());
//       formData.append("major", major.trim());
//       if (studentIdCard) formData.append("studentIdCard", studentIdCard);
//     }

//     try {
//       await axios.post("http://localhost:4001/servitors", formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       // Redirect to homepage on successful signup
//       navigate("/");
//     } catch (error) {
//       console.error("Error during sign up:", error);
//     }
//   };

//   // Normalize service name for translation key
//   const getServiceKey = (serviceName) => {
//     return serviceName.trim().toLowerCase().replace(/\s+/g, "_");
//   };

//   return (
//     <div className="signup-modal">
//       <div className="signup-modal-content">
//         <div className="close-icon" onClick={onClose}>
//           <FontAwesomeIcon icon={faTimes} />
//         </div>
//         <div className="signup-header">
//           <h1>{t("servitor_signup.header")}</h1>
//           <div className="signup-underline"></div>
//         </div>
//         <div className="form-container">
//           <form className="signup-form" onSubmit={handleSubmit}>
//             {/* Personal Info Section */}
//             <div className="form-row">
//               <div className="col">
//                 <input
//                   type="text"
//                   placeholder={t("servitor_signup.first_name")}
//                   value={firstName}
//                   onChange={(e) => setFirstName(e.target.value)}
//                   required
//                 />
//               </div>
//               <div className="col">
//                 <input
//                   type="text"
//                   placeholder={t("servitor_signup.last_name")}
//                   value={lastName}
//                   onChange={(e) => setLastName(e.target.value)}
//                   required
//                 />
//               </div>
//             </div>
//             <div className="form-row">
//               <div className="col">
//                 <input
//                   type="email"
//                   placeholder={t("servitor_signup.email")}
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   required
//                 />
//               </div>
//               <div className="col">
//                 <input
//                   type="tel"
//                   placeholder={t("servitor_signup.mobile")}
//                   value={mobile}
//                   onChange={(e) => setMobile(e.target.value)}
//                   required
//                 />
//               </div>
//             </div>
//             {/* Password and NID/Passport */}
//             <div className="form-row">
//               <div className="col">
//                 <input
//                   type="password"
//                   placeholder={t("servitor_signup.password")}
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   required
//                 />
//               </div>
//               <div className="col">
//                 <input
//                   type="text"
//                   placeholder={t("servitor_signup.nid_passport")}
//                   value={nidPassport}
//                   onChange={(e) => setNidPassport(e.target.value)}
//                   required
//                 />
//               </div>
//             </div>
//             {/* Date of Birth and Gender */}
//             <div className="form-row">
//               <div className="col">
//                 <label htmlFor="dob">{t("servitor_signup.dob")}</label>
//                 <input
//                   type="date"
//                   id="dob"
//                   value={dob}
//                   onChange={(e) => setDob(e.target.value)}
//                   required
//                 />
//               </div>
//               <div className="col">
//                 <label>{t("servitor_signup.gender.label")}</label>
//                 <div className="checkbox-box">
//                   <label>
//                     <input
//                       type="radio"
//                       name="gender"
//                       value="male"
//                       checked={selectedGender === "male"}
//                       onChange={() => handleGenderSelection("male")}
//                       required
//                     />
//                     {t("servitor_signup.gender.male")}
//                   </label>
//                   <label>
//                     <input
//                       type="radio"
//                       name="gender"
//                       value="female"
//                       checked={selectedGender === "female"}
//                       onChange={() => handleGenderSelection("female")}
//                     />
//                     {t("servitor_signup.gender.female")}
//                   </label>
//                 </div>
//               </div>
//             </div>
//             {/* Service Selection */}
//             <div className="form-row">
//               <div className="col">
//                 <select
//                   value={selectedService}
//                   onChange={(e) => setSelectedService(e.target.value)}
//                   required
//                 >
//                   <option value="">
//                     {t("servitor_signup.select_service")}
//                   </option>
//                   {services.map((service) => {
//                     const serviceKey = getServiceKey(service.services_name);
//                     const translatedName =
//                       i18n.language === "bn"
//                         ? t(`home.services.${serviceKey}.name`, {
//                             defaultValue: service.services_name,
//                           })
//                         : service.services_name;
//                     return (
//                       <option key={service.Id} value={service.services_name}>
//                         {translatedName}
//                       </option>
//                     );
//                   })}
//                 </select>
//               </div>
//             </div>


//             {/* City and Address */}
//             <div className="form-row">
//               <div className="col">
//                 <select
//                   value={selectedCity}
//                   onChange={(e) => setSelectedCity(e.target.value)}
//                   required
//                 >
//                   <option value="">{t("servitor_signup.select_city")}</option>
//                   {[
//                     { value: "Dhaka", key: "dhaka" },
//                     { value: "Chattogram", key: "chattogram" },
//                     { value: "Barishal", key: "barishal" },
//                     { value: "Sylhet", key: "sylhet" },
//                     { value: "Rajshahi", key: "rajshahi" },
//                     { value: "Khulna", key: "khulna" },
//                     { value: "Rangpur", key: "rangpur" },
//                     { value: "Maymensingh", key: "maymensingh" },
//                   ].map((city) => (
//                     <option key={city.value} value={city.value}>
//                       {t(`servitor_signup.cities.${city.key}`)}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               <div className="col">
//                 <input
//                   type="text"
//                   placeholder={t("servitor_signup.address")}
//                   value={address}
//                   onChange={(e) => setAddress(e.target.value)}
//                   required
//                 />
//               </div>
//             </div>
//             {/* Experience */}
//             <div className="form-row">
//               <div className="col">
//                 <input
//                   type="number"
//                   placeholder={t("servitor_signup.experience")}
//                   value={experience}
//                   onChange={(e) => setExperience(e.target.value)}
//                   min="0"
//                   required
//                 />
//               </div>
//             </div>


//             {/* TUTOR-ONLY FIELDS */}
//             {isTutor && (
//               <>
//                 <div className="form-row">
//                   <div className="col">
//                     <label>
//                       {t("tutor.university_type", { defaultValue: "University Type" })}
//                     </label>
//                     <select
//                       value={universityType}
//                       onChange={(e) => setUniversityType(e.target.value)}
//                       required
//                     >
//                       <option value="">
//                         {t("tutor.select_university_type", { defaultValue: "Select university type" })}
//                       </option>
//                       <option value="buet">BUET</option>
//                       <option value="medical">{t("tutor.medical", { defaultValue: "Medical" })}</option>
//                       <option value="Quran">{t("tutor.madrasa", { defaultValue: "Quran/Islamic Education" })}</option>
//                       <option value="du">{t("tutor.du", { defaultValue: "Dhaka University" })}</option>
//                       <option value="public">{t("tutor.public_university", { defaultValue: "Public University" })}</option>
//                       <option value="private">{t("tutor.private_university", { defaultValue: "Private University" })}</option>
//                       <option value="other">{t("tutor.other", { defaultValue: "Other" })}</option>
//                     </select>
//                   </div>
//                 </div>

//                 <div className="form-row">
//                   <div className="col">
//                     <label>
//                       {t("tutor.university_name", { defaultValue: "University Name" })}
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("tutor.university_name_ph", { defaultValue: "e.g., BUET / DU / AUST / NSU" })}
//                       value={universityName}
//                       onChange={(e) => setUniversityName(e.target.value)}
//                       required
//                     />
//                   </div>
//                 </div>

//                 <div className="form-row">
//                   <div className="col">
//                     <label>
//                       {t("tutor.major", { defaultValue: "Major / Department" })}
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("tutor.major_ph", { defaultValue: "e.g., CSE / EEE / BBA" })}
//                       value={major}
//                       onChange={(e) => setMajor(e.target.value)}
//                       required
//                     />
//                   </div>
//                 </div>

//                 <div className="form-row">
//                   <div className="col upload-box">
//                     <label>
//                       {t("tutor.student_id_card", { defaultValue: "Student ID Card" })}
//                     </label>
//                     <input
//                       type="file"
//                       accept="image/*,application/pdf"
//                       onChange={(e) => handleFileUpload(e, setStudentIdCard)}
//                       required
//                     />
//                   </div>

//                 </div>
//               </>
//             )}

//             {/* Image Upload */}
//             <div className="form-row">
//               <div className="col upload-box">
//                 <label>{t("servitor_signup.upload_photo")}</label>
//                 <input
//                   type="file"
//                   accept="image/*"
//                   onChange={(e) => handleFileUpload(e, setImage)}
//                 />
//               </div>
//             </div>
//             {/* Certificate Upload */}
//             <div className="form-row">
//               <div className="col upload-box">
//                 <label>{t("servitor_signup.upload_certificate")}</label>
//                 <input
//                   type="file"
//                   onChange={(e) => handleFileUpload(e, setCertificate)}
//                 />
//               </div>
//             </div>
//             <div className="form-note">{t("servitor_signup.note")}</div>
//             <button className="submit-btn" type="submit">
//               {t("servitor_signup.submit")}
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ServitorSignup;






// ***** New Updated (8-sep-25) ***** //

// import React, { useState, useEffect, useMemo, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import axios from "axios";
// import Navbar from "../../Components/Navbar";
// import "./servitorsignupstyle.css";

// const ServitorSignup = () => {
//   const { t, i18n } = useTranslation();
//   const navigate = useNavigate();
//   const [firstName, setFirstName] = useState("");
//   const [lastName, setLastName] = useState("");
//   const [mobile, setMobile] = useState("");
//   const [password, setPassword] = useState("");
//   const [nidPassport, setNidPassport] = useState("");
//   const [dob, setDob] = useState("");
//   const [selectedGender, setSelectedGender] = useState("");
//   const [selectedCity, setSelectedCity] = useState("");
//   const [selectedService, setSelectedService] = useState("");
//   const [address, setAddress] = useState("");
//   const [area, setArea] = useState("");
//   const [experience, setExperience] = useState("");
//   const [bio, setBio] = useState("");
//   const [image, setImage] = useState(null);
//   const [previewImage, setPreviewImage] = useState(null);
//   const [services, setServices] = useState([]);
//   const [universityType, setUniversityType] = useState("");
//   const [universityName, setUniversityName] = useState("");
//   const [major, setMajor] = useState("");
//   const [studentIdCard, setStudentIdCard] = useState(null);
//   const [errMsg, setErrMsg] = useState("");
//   const photoInputRef = useRef(null);
//   const isTutor = useMemo(
//     () => (selectedService || "").toLowerCase().includes("tutor"),
//     [selectedService]
//   );

//   useEffect(() => {
//     const fetchServices = async () => {
//       try {
//         const response = await axios.get("http://localhost:4001/services");
//         setServices(response.data);
//       } catch (error) {
//         console.error("Error fetching services:", error);
//         setErrMsg(t("servitor_signup.error_messages.service_fetch_error"));
//       }
//     };
//     fetchServices();
//   }, [t]);

//   useEffect(() => {
//     if (!isTutor) {
//       setUniversityType("");
//       setUniversityName("");
//       setMajor("");
//       setStudentIdCard(null);
//     }
//   }, [isTutor]);

//   const handleFileUpload = (e, setFile, isImageOnly = false) => {
//     const file = e.target.files[0];
//     if (file) {
//       if (isImageOnly && !file.type.startsWith("image/")) {
//         setErrMsg(t("servitor_signup.error_image_only"));
//         return;
//       }
//       setFile(file);
//       if (file.type.startsWith("image/")) {
//         const reader = new FileReader();
//         reader.onload = (e) => setPreviewImage(e.target.result);
//         reader.readAsDataURL(file);
//       }
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (
//       !firstName ||
//       !lastName ||
//       !mobile ||
//       !password ||
//       !nidPassport ||
//       !dob ||
//       !selectedGender ||
//       !selectedService ||
//       !selectedCity ||
//       !address ||
//       !area ||
//       !experience ||
//       !bio
//     ) {
//       setErrMsg(t("servitor_signup.error_messages.missing_fields"));
//       return;
//     }
//     const mobileRegex = /^01[3-9]\d{8}$/;
//     if (!mobileRegex.test(mobile)) {
//       setErrMsg(t("servitor_signup.error_mobile"));
//       return;
//     }
//     if (isTutor) {
//       if (
//         !universityType ||
//         !universityName.trim() ||
//         !major.trim() ||
//         !studentIdCard
//       ) {
//         setErrMsg(t("servitor_signup.error_messages.missing_fields"));
//         return;
//       }
//     }
//     const formData = new FormData();
//     formData.append("firstName", firstName);
//     formData.append("lastName", lastName);
//     formData.append("mobile", mobile);
//     formData.append("password", password);
//     formData.append("NID", nidPassport);
//     formData.append("dob", dob);
//     formData.append("gender", selectedGender);
//     formData.append("service", selectedService);
//     formData.append("city", selectedCity);
//     formData.append("Address", address);
//     formData.append("area", area);
//     formData.append("experience", experience);
//     formData.append("bio", bio);
//     if (image) formData.append("image", image);
//     if (studentIdCard) formData.append("studentIdCard", studentIdCard);
//     try {
//       await axios.post("http://localhost:4001/servitors", formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       navigate("/login");
//     } catch (error) {
//       console.error("Error during sign up:", error);
//       const errorMessage =
//         error.response?.data?.error || "Internal server error";
//       const errorKey = errorMessage.toLowerCase().replace(/\s+/g, "_");
//       const translatedError =
//         i18n.language === "bn"
//           ? t(`servitor_signup.error_messages.${errorKey}`, {
//               defaultValue: errorMessage,
//             })
//           : errorMessage;
//       setErrMsg(translatedError);
//     }
//   };

//   const getServiceKey = (serviceName) =>
//     serviceName.trim().toLowerCase().replace(/\s+/g, "_");

//   const handleDragOver = (e) => {
//     e.preventDefault();
//     e.currentTarget.classList.add("servitorsignup-dragover");
//   };

//   const handleDragLeave = (e) =>
//     e.currentTarget.classList.remove("servitorsignup-dragover");

//   const handleDrop = (e, setFile, isImageOnly = false) => {
//     e.preventDefault();
//     e.currentTarget.classList.remove("servitorsignup-dragover");
//     if (e.dataTransfer.files.length > 0)
//       handleFileUpload(
//         { target: { files: e.dataTransfer.files } },
//         setFile,
//         isImageOnly
//       );
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="servitorsignup-container">
//         <div className="servitorsignup-content">
//           <div className="servitorsignup-header">
//             <h1 className="servitorsignup-title">
//               {t("servitor_signup.header")}
//             </h1>
//             <div className="servitorsignup-underline"></div>

//           </div>
//           <div className="servitorsignup-card">
//             <form className="servitorsignup-form" onSubmit={handleSubmit}>
//               <div className="servitorsignup-section">
//                 <h2 className="servitorsignup-section-title">
//                   {i18n.language === "bn" ? "১." : "1."}{" "}
//                   {t("servitor_signup.personal_info")}
//                 </h2>
//                 <div className="servitorsignup-personal-grid">
//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {" "}
//                       {t("servitor_signup.first_name")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.first_name")}
//                       value={firstName}
//                       onChange={(e) => setFirstName(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>
//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {" "}
//                       {t("servitor_signup.last_name")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.last_name")}
//                       value={lastName}
//                       onChange={(e) => setLastName(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>
//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {" "}
//                       {t("servitor_signup.mobile")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="tel"
//                       placeholder={t("servitor_signup.mobile_ph")}
//                       value={mobile}
//                       onChange={(e) => setMobile(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>


//                    <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {" "}
//                       {t("servitor_signup.gender.label")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <select
//                       value={selectedGender}
//                       onChange={(e) => setSelectedGender(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     >
//                       <option value="">
//                         {t("servitor_signup.select_gender")}
//                       </option>
//                       <option value="male">
//                         {t("servitor_signup.gender.male")}
//                       </option>
//                       <option value="female">
//                         {t("servitor_signup.gender.female")}
//                       </option>
//                     </select>
//                   </div>

//                    <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {" "}
//                       {t("servitor_signup.nid_passport")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.nid_ph")}
//                       value={nidPassport}
//                       onChange={(e) => setNidPassport(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {" "}
//                       {t("servitor_signup.dob")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="date"
//                       value={dob}
//                       onChange={(e) => setDob(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field servitorsignup-full-width">
//                     <label className="servitorsignup-label">
//                       {" "}
//                       {t("servitor_signup.password")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="password"
//                       placeholder={t("servitor_signup.password_ph")}
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>   
//                 </div>
//               </div>
//               <div className="servitorsignup-section">
//                 <h2 className="servitorsignup-section-title">
//                   {i18n.language === "bn" ? "২." : "2."}{" "}
//                   {t("servitor_signup.service_info")}
//                 </h2>
//                 <div className="servitorsignup-grid">
//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {" "}
//                       {t("servitor_signup.service")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <select
//                       value={selectedService}
//                       onChange={(e) => setSelectedService(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     >
//                       <option value="">
//                         {t("servitor_signup.select_service")}
//                       </option>
//                       {services.map((service) => {
//                         const serviceKey = getServiceKey(service.services_name);
//                         const translatedName =
//                           i18n.language === "bn"
//                             ? t(`home.services.${serviceKey}.name`, {
//                                 defaultValue: service.services_name,
//                               })
//                             : service.services_name;
//                         return (
//                           <option
//                             key={service.Id}
//                             value={service.services_name}
//                           >
//                             {translatedName}
//                           </option>
//                         );
//                       })}
//                     </select>
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {" "}
//                       {t("servitor_signup.experience")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="number"
//                       placeholder={t("servitor_signup.experience_ph")}
//                       value={experience}
//                       onChange={(e) => setExperience(e.target.value)}
//                       min="0"
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {" "}
//                       {t("servitor_signup.city")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <select
//                       value={selectedCity}
//                       onChange={(e) => setSelectedCity(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     >
//                       <option value="">
//                         {t("servitor_signup.select_city")}
//                       </option>
//                       {[
//                         "Dhaka",
//                         "Chattogram",
//                         "Barishal",
//                         "Sylhet",
//                         "Rajshahi",
//                         "Khulna",
//                         "Rangpur",
//                         "Maymensingh",
//                       ].map((city) => (
//                         <option key={city} value={city}>
//                           {t(`cities.${city.toLowerCase()}`)}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {" "}
//                       {t("servitor_signup.area")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.area_ph")}
//                       value={area}
//                       onChange={(e) => setArea(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {" "}
//                       {t("servitor_signup.address")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.address_ph")}
//                       value={address}
//                       onChange={(e) => setAddress(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>
                  
//                 </div>
//               </div>
//               {isTutor && (
//                 <div className="servitorsignup-section">
//                   <h2 className="servitorsignup-section-title">
//                     {i18n.language === "bn" ? "৩." : "3."}{" "}
//                     {t("tutorservice.tutor_info")}
//                   </h2>
//                   <div className="servitorsignup-grid">
//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {" "}
//                         {t("tutorservice.university_type")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <select
//                         value={universityType}
//                         onChange={(e) => setUniversityType(e.target.value)}
//                         required
//                         className="servitorsignup-input"
//                       >
//                         <option value="">
//                           {t("tutorservice.select_university_type")}
//                         </option>
//                         <option value="buet">BUET</option>
//                         <option value="medical">{t("tutorservice.medical")}</option>
//                         <option value="quran">{t("tutorservice.madrasa")}</option>
//                         <option value="du">{t("tutorservice.du")}</option>
//                         <option value="public">
//                           {t("tutorservice.public_university")}
//                         </option>
//                         <option value="private">
//                           {t("tutorservice.private_university")}
//                         </option>
//                         <option value="other">{t("tutorservice.other")}</option>
//                       </select>
//                     </div>
//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {" "}
//                         {t("tutorservice.university_name")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         placeholder={t("tutorservice.university_name_ph")}
//                         value={universityName}
//                         onChange={(e) => setUniversityName(e.target.value)}
//                         required
//                         className="servitorsignup-input"
//                       />
//                     </div>
//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {" "}
//                         {t("tutorservice.major")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         placeholder={t("tutorservice.major_ph")}
//                         value={major}
//                         onChange={(e) => setMajor(e.target.value)}
//                         required
//                         className="servitorsignup-input"
//                       />
//                     </div>
//                   </div>
//                 </div>
//               )}
//               <div className="servitorsignup-section">
//                 <h2 className="servitorsignup-section-title">
//                   {i18n.language === "bn"
//                     ? isTutor
//                       ? "৪."
//                       : "৩."
//                     : isTutor
//                     ? "4."
//                     : "3."}{" "}
//                   {t("servitor_signup.profile_photo")}
//                 </h2>
//                 <div className="servitorsignup-photo-section">
//                   <div className="servitorsignup-upload-container">
//                     <div
//                       className="servitorsignup-upload-area"
//                       onClick={() => photoInputRef.current.click()}
//                       onDragOver={handleDragOver}
//                       onDragLeave={handleDragLeave}
//                       onDrop={(e) => handleDrop(e, setImage, true)}
//                     >
//                       {!image && (
//                         <div className="servitorsignup-upload-content">
//                           <svg
//                             className="servitorsignup-upload-icon"
//                             fill="none"
//                             stroke="currentColor"
//                             viewBox="0 0 24 24"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth="2"
//                               d="M12 6v6m0 0v6m0-6h6m-6 0H6"
//                             />
//                           </svg>
//                           <p className="servitorsignup-upload-text">
//                             <span className="font-semibold">
//                               {t("servitor_signup.upload_photo")}
//                             </span>
//                           </p>
//                           <p className="servitorsignup-upload-subtext">
//                             {t("servitor_signup.recent_photo")}
//                           </p>
//                           <p className="servitorsignup-upload-note">
//                             {t("servitor_signup.jpg_png_max")}
//                           </p>
//                         </div>
//                       )}
//                       {image && (
//                         <div className="servitorsignup-uploaded-file">
//                           <p className="servitorsignup-file-name">
//                             {image.name}
//                           </p>
//                           <button
//                             className="servitorsignup-change-btn"
//                             onClick={() => {
//                               setImage(null);
//                               setPreviewImage(null);
//                               photoInputRef.current.value = null;
//                             }}
//                           >
//                             {/* Change */}
//                             {t("servitor_signup.change_photo")}
//                           </button>
//                         </div>
//                       )}
//                       <input
//                         type="file"
//                         ref={photoInputRef}
//                         accept="image/*"
//                         onChange={(e) => handleFileUpload(e, setImage, true)}
//                         className="servitorsignup-hidden"
//                       />
//                     </div>
//                   </div>
//                   {previewImage && (
//                     <div className="servitorsignup-photo-preview">
//                       <img
//                         src={previewImage}
//                         alt="Preview"
//                         className="servitorsignup-preview-image"
//                       />
//                     </div>
//                   )}
//                 </div>
//               </div>
//               <div className="servitorsignup-section">
//                 <h2 className="servitorsignup-section-title">
//                   {i18n.language === "bn"
//                     ? isTutor
//                       ? "৫."
//                       : "৪."
//                     : isTutor
//                     ? "5."
//                     : "4."}{" "}
//                   {t("servitor_signup.bio_skills")}
//                 </h2>
//                 <div className="servitorsignup-field servitorsignup-full-width">
//                   <label className="servitorsignup-label">
//                     {" "}
//                     {t("servitor_signup.bio")}{" "}
//                     <span className="required-asterisk">*</span>
//                   </label>
//                   <textarea
//                     rows="5"
//                     placeholder={t("servitor_signup.bio_ph")}
//                     value={bio}
//                     onChange={(e) => setBio(e.target.value)}
//                     required
//                     className="servitorsignup-textarea"
//                   ></textarea>
//                 </div>
//               </div>
//               {errMsg && (
//                 <div className="servitorsignup-error-message">{errMsg}</div>
//               )}
//               <div className="servitorsignup-form-note">
//                 {t("servitor_signup.note")}
//               </div>
//               <div className="servitorsignup-submit-container">
//                 <button type="submit" className="servitorsignup-submit-btn">
//                   {t("servitor_signup.submit")}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ServitorSignup;





// ***** New Update Properly (9-sep-25) ***** //

// import React, { useState, useEffect, useMemo, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import axios from "axios";
// import Navbar from "../../Components/Navbar";
// import "./servitorsignupstyle.css";

// const MAX_MB = 2;

// const ServitorSignup = () => {
//   const { t, i18n } = useTranslation();
//   const navigate = useNavigate();

//   // Core fields
//   const [firstName, setFirstName] = useState("");
//   const [lastName, setLastName] = useState("");
//   const [mobile, setMobile] = useState("");
//   const [password, setPassword] = useState("");
//   const [nidPassport, setNidPassport] = useState("");
//   const [dob, setDob] = useState("");
//   const [selectedGender, setSelectedGender] = useState("");
//   const [selectedCity, setSelectedCity] = useState("");
//   const [selectedService, setSelectedService] = useState("");
//   const [address, setAddress] = useState("");
//   const [area, setArea] = useState("");
//   const [experience, setExperience] = useState("");
//   const [bio, setBio] = useState("");

//   // Files
//   const [image, setImage] = useState(null);
//   const [previewImage, setPreviewImage] = useState(null);

//   // Tutor-only files
//   const [resume, setResume] = useState(null);
//   const [resumeUrl, setResumeUrl] = useState(null);
//   const [studentIdCard, setStudentIdCard] = useState(null);
//   const [studentIdPreview, setStudentIdPreview] = useState(null); // object URL for preview

//   // Field-level errors (uploads)
//   const [photoErr, setPhotoErr] = useState("");
//   const [resumeErr, setResumeErr] = useState("");
//   const [idErr, setIdErr] = useState("");

//   // Misc
//   const [services, setServices] = useState([]);
//   const [universityType, setUniversityType] = useState("");
//   const [universityName, setUniversityName] = useState("");
//   const [major, setMajor] = useState("");
//   const [errMsg, setErrMsg] = useState("");

//   // Refs
//   const photoInputRef = useRef(null);
//   const resumeInputRef = useRef(null);
//   const idCardInputRef = useRef(null);

//   const isTutor = useMemo(
//     () => (selectedService || "").toLowerCase().includes("tutor"),
//     [selectedService]
//   );

//   useEffect(() => {
//     const fetchServices = async () => {
//       try {
//         const response = await axios.get("http://localhost:4001/services");
//         setServices(response.data);
//       } catch (error) {
//         console.error("Error fetching services:", error);
//         setErrMsg(t("servitor_signup.error_messages.service_fetch_error"));
//       }
//     };
//     fetchServices();
//   }, [t]);

//   useEffect(() => {
//     // Reset tutor-only fields if service changes away from tutor
//     if (!isTutor) {
//       setUniversityType("");
//       setUniversityName("");
//       setMajor("");
//       setStudentIdCard(null);
//       setStudentIdPreview(null);
//       setResume(null);
//       if (resumeUrl) URL.revokeObjectURL(resumeUrl);
//       setResumeUrl(null);
//       setPhotoErr("");
//       setResumeErr("");
//       setIdErr("");
//     }
//   }, [isTutor]); // eslint-disable-line

//   // cleanup object URLs
//   useEffect(
//     () => () => {
//       if (resumeUrl) URL.revokeObjectURL(resumeUrl);
//     },
//     [resumeUrl]
//   );
//   useEffect(
//     () => () => {
//       if (studentIdPreview) URL.revokeObjectURL(studentIdPreview);
//     },
//     [studentIdPreview]
//   );

//   // Generic file handler (image/pdf + size + optional preview + field-error)
//   const handleFileUpload = (e, setFile, optionsOrBoolean = false) => {
//     const options =
//       typeof optionsOrBoolean === "boolean"
//         ? { isImageOnly: optionsOrBoolean }
//         : optionsOrBoolean || {};
//     const {
//       isImageOnly = false,
//       isPdfOnly = false,
//       maxMB = MAX_MB,
//       setPreview,
//       setError,
//     } = options;

//     const file = e.target.files?.[0];
//     if (!file) return;

//     // clear previous error
//     if (setError) setError("");

//     // type checks
//     if (isImageOnly && !file.type.startsWith("image/")) {
//       setError && setError(t("servitor_signup.error_image_only"));
//       return;
//     }
//     if (isPdfOnly && file.type !== "application/pdf") {
//       setError && setError(t("servitor_signup.error_pdf_only"));
//       return;
//     }

//     // size check
//     if (file.size > maxMB * 1024 * 1024) {
//       setError && setError(t("servitor_signup.error_file_too_large"));
//       return;
//     }

//     setFile(file);

//     // object URL preview for resume / id card
//     if (setPreview) {
//       const objectUrl = URL.createObjectURL(file);
//       setPreview(objectUrl);
//     }

//     // FileReader preview only for main profile photo
//     if (!setPreview && file.type.startsWith("image/")) {
//       const reader = new FileReader();
//       reader.onload = (ev) => setPreviewImage(ev.target.result);
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // requireds
//     if (
//       !firstName ||
//       !lastName ||
//       !mobile ||
//       !password ||
//       !nidPassport ||
//       !dob ||
//       !selectedGender ||
//       !selectedService ||
//       !selectedCity ||
//       !address ||
//       !area ||
//       !experience ||
//       !bio
//     ) {
//       setErrMsg(t("servitor_signup.error_messages.missing_fields"));
//       return;
//     }

//     const mobileRegex = /^01[3-9]\d{8}$/;
//     if (!mobileRegex.test(mobile)) {
//       setErrMsg(t("servitor_signup.error_mobile"));
//       return;
//     }

//     if (isTutor) {
//       if (
//         !universityType ||
//         !universityName.trim() ||
//         !major.trim() ||
//         !resume ||
//         !studentIdCard
//       ) {
//         setErrMsg(t("servitor_signup.error_messages.missing_fields"));
//         return;
//       }
//     }

//     const formData = new FormData();
//     formData.append("firstName", firstName);
//     formData.append("lastName", lastName);
//     formData.append("mobile", mobile);
//     formData.append("password", password);
//     formData.append("NID", nidPassport);
//     formData.append("dob", dob);
//     formData.append("gender", selectedGender);
//     formData.append("service", selectedService);
//     formData.append("city", selectedCity);
//     formData.append("Address", address);
//     formData.append("area", area);
//     formData.append("experience", experience);
//     formData.append("bio", bio);
//     if (image) formData.append("image", image);

//     if (isTutor) {
//       formData.append("universityType", universityType.toLowerCase());
//       formData.append("universityName", universityName.trim());
//       formData.append("major", major.trim());
//       if (resume) formData.append("resume", resume);
//       if (studentIdCard) formData.append("studentIdCard", studentIdCard);
//     }

//     try {
//       await axios.post("http://localhost:4001/servitors", formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       navigate("/login");
//     } catch (error) {
//       console.error("Error during sign up:", error);
//       const errorMessage =
//         error.response?.data?.error || "Internal server error";
//       const errorKey = errorMessage.toLowerCase().replace(/\s+/g, "_");
//       const translatedError =
//         i18n.language === "bn"
//           ? t(`servitor_signup.error_messages.${errorKey}`, {
//               defaultValue: errorMessage,
//             })
//           : errorMessage;
//       setErrMsg(translatedError);
//     }
//   };

//   const getServiceKey = (serviceName) =>
//     serviceName.trim().toLowerCase().replace(/\s+/g, "_");

//   const handleDragOver = (e) => {
//     e.preventDefault();
//     e.currentTarget.classList.add("servitorsignup-dragover");
//   };
//   const handleDragLeave = (e) =>
//     e.currentTarget.classList.remove("servitorsignup-dragover");
//   const handleDrop = (e, setFile, optionsOrBoolean = false) => {
//     e.preventDefault();
//     e.currentTarget.classList.remove("servitorsignup-dragover");
//     if (e.dataTransfer.files.length > 0) {
//       handleFileUpload(
//         { target: { files: e.dataTransfer.files } },
//         setFile,
//         optionsOrBoolean
//       );
//     }
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="servitorsignup-container">
//         <div className="servitorsignup-content">
//           <div className="servitorsignup-header">
//             <h1 className="servitorsignup-title">
//               {t("servitor_signup.header")}
//             </h1>
//             <div className="servitorsignup-underline"></div>
//           </div>

//           <div className="servitorsignup-card">
//             <form className="servitorsignup-form" onSubmit={handleSubmit}>
//               {/* 1. Personal */}
//               <div className="servitorsignup-section">
//                 <h2 className="servitorsignup-section-title">
//                   {i18n.language === "bn" ? "১." : "1."}{" "}
//                   {t("servitor_signup.personal_info")}
//                 </h2>

//                 <div className="servitorsignup-personal-grid">
//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.first_name")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.first_name")}
//                       value={firstName}
//                       onChange={(e) => setFirstName(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.last_name")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.last_name")}
//                       value={lastName}
//                       onChange={(e) => setLastName(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.mobile")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="tel"
//                       placeholder={t("servitor_signup.mobile_ph")}
//                       value={mobile}
//                       onChange={(e) => setMobile(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.gender.label")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <select
//                       value={selectedGender}
//                       onChange={(e) => setSelectedGender(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     >
//                       <option value="">
//                         {t("servitor_signup.select_gender")}
//                       </option>
//                       <option value="male">
//                         {t("servitor_signup.gender.male")}
//                       </option>
//                       <option value="female">
//                         {t("servitor_signup.gender.female")}
//                       </option>
//                     </select>
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.nid_passport")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.nid_ph")}
//                       value={nidPassport}
//                       onChange={(e) => setNidPassport(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.dob")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="date"
//                       value={dob}
//                       onChange={(e) => setDob(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field servitorsignup-full-width">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.password")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="password"
//                       placeholder={t("servitor_signup.password_ph")}
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* 2. Service */}
//               <div className="servitorsignup-section">
//                 <h2 className="servitorsignup-section-title">
//                   {i18n.language === "bn" ? "২." : "2."}{" "}
//                   {t("servitor_signup.service_info")}
//                 </h2>

//                 <div className="servitorsignup-grid">
//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.service")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <select
//                       value={selectedService}
//                       onChange={(e) => setSelectedService(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     >
//                       <option value="">
//                         {t("servitor_signup.select_service")}
//                       </option>
//                       {services.map((service) => {
//                         const serviceKey = getServiceKey(service.services_name);
//                         const translatedName =
//                           i18n.language === "bn"
//                             ? t(`home.services.${serviceKey}.name`, {
//                                 defaultValue: service.services_name,
//                               })
//                             : service.services_name;
//                         return (
//                           <option
//                             key={service.Id}
//                             value={service.services_name}
//                           >
//                             {translatedName}
//                           </option>
//                         );
//                       })}
//                     </select>
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.experience")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="number"
//                       placeholder={t("servitor_signup.experience_ph")}
//                       value={experience}
//                       onChange={(e) => setExperience(e.target.value)}
//                       min="0"
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.city")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <select
//                       value={selectedCity}
//                       onChange={(e) => setSelectedCity(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     >
//                       <option value="">
//                         {t("servitor_signup.select_city")}
//                       </option>
//                       {[
//                         "Dhaka",
//                         "Chattogram",
//                         "Barishal",
//                         "Sylhet",
//                         "Rajshahi",
//                         "Khulna",
//                         "Rangpur",
//                         "Maymensingh",
//                       ].map((city) => (
//                         <option key={city} value={city}>
//                           {t(`cities.${city.toLowerCase()}`)}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.area")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.area_ph")}
//                       value={area}
//                       onChange={(e) => setArea(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.address")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.address_ph")}
//                       value={address}
//                       onChange={(e) => setAddress(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* 3. Tutor info */}
//               {isTutor && (
//                 <div className="servitorsignup-section">
//                   <h2 className="servitorsignup-section-title">
//                     {i18n.language === "bn" ? "৩." : "3."}{" "}
//                     {t("tutorservice.tutor_info")}
//                   </h2>

//                   <div className="servitorsignup-grid">
//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {t("tutorservice.university_type")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <select
//                         value={universityType}
//                         onChange={(e) => setUniversityType(e.target.value)}
//                         required
//                         className="servitorsignup-input"
//                       >
//                         <option value="">
//                           {t("tutorservice.select_university_type")}
//                         </option>
//                         <option value="buet">BUET</option>
//                         <option value="medical">
//                           {t("tutorservice.medical")}
//                         </option>
//                         <option value="quran">
//                           {t("tutorservice.madrasa")}
//                         </option>
//                         <option value="du">{t("tutorservice.du")}</option>
//                         <option value="public">
//                           {t("tutorservice.public_university")}
//                         </option>
//                         <option value="private">
//                           {t("tutorservice.private_university")}
//                         </option>
//                         <option value="other">{t("tutorservice.other")}</option>
//                       </select>
//                     </div>

//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {t("tutorservice.university_name")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         placeholder={t("tutorservice.university_name_ph")}
//                         value={universityName}
//                         onChange={(e) => setUniversityName(e.target.value)}
//                         required
//                         className="servitorsignup-input"
//                       />
//                     </div>

//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {t("tutorservice.major")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         placeholder={t("tutorservice.major_ph")}
//                         value={major}
//                         onChange={(e) => setMajor(e.target.value)}
//                         required
//                         className="servitorsignup-input"
//                       />
//                     </div>
//                   </div>

//                   {/* Tutor docs */}
//                   <h3
//                     className="servitorsignup-section-title"
//                     style={{ marginTop: "1rem" }}
//                   >
//                     {t("tutorservice.student_docs")}
//                   </h3>

//                   <div className="servitorsignup-grid">
//                     {/* Resume (PDF) */}
//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {t("tutorservice.upload_resume")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <div
//                         className="servitorsignup-upload-area"
//                         onClick={() => resumeInputRef.current?.click()}
//                         onDragOver={handleDragOver}
//                         onDragLeave={handleDragLeave}
//                         onDrop={(e) =>
//                           handleDrop(e, setResume, {
//                             isPdfOnly: true,
//                             maxMB: MAX_MB,
//                             setPreview: setResumeUrl,
//                             setError: setResumeErr,
//                           })
//                         }
//                       >
//                         {!resume ? (
//                           <div className="servitorsignup-upload-content">
//                             <svg
//                               className="servitorsignup-upload-icon"
//                               fill="none"
//                               stroke="currentColor"
//                               viewBox="0 0 24 24"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth="2"
//                                 d="M12 6v6m0 0v6m0-6h6m-6 0H6"
//                               />
//                             </svg>
//                             <p className="servitorsignup-upload-text">
//                               <span className="font-semibold">
//                                 {t("tutorservice.upload_resume")}
//                               </span>
//                             </p>
//                             <p className="servitorsignup-upload-note">
//                               {t("tutorservice.pdf_max")}
//                             </p>
//                             {resumeErr && (
//                               <div className="servitorsignup-inline-error">
//                                 {resumeErr}
//                               </div>
//                             )}
//                           </div>
//                         ) : (
//                           <div className="servitorsignup-uploaded-file">
//                             <p className="servitorsignup-file-name">
//                               {resume.name}
//                             </p>
//                             <div className="servitorsignup-doc-actions">
//                               <button
//                                 type="button"
//                                 className="servitorsignup-preview-btn"
//                                 onClick={(ev) => {
//                                   ev.stopPropagation();
//                                   if (resumeUrl)
//                                     window.open(resumeUrl, "_blank");
//                                 }}
//                               >
//                                 {t("tutorservice.preview")}
//                               </button>
//                               <button
//                                 type="button"
//                                 className="servitorsignup-change-btn"
//                                 onClick={(ev) => {
//                                   ev.stopPropagation();
//                                   setResume(null);
//                                   if (resumeUrl) URL.revokeObjectURL(resumeUrl);
//                                   setResumeUrl(null);
//                                   if (resumeInputRef.current)
//                                     resumeInputRef.current.value = null;
//                                 }}
//                               >
//                                 {t("tutorservice.change_file")}
//                               </button>
//                             </div>
//                           </div>
//                         )}
//                         <input
//                           type="file"
//                           ref={resumeInputRef}
//                           accept="application/pdf"
//                           onChange={(e) =>
//                             handleFileUpload(e, setResume, {
//                               isPdfOnly: true,
//                               maxMB: MAX_MB,
//                               setPreview: setResumeUrl,
//                               setError: setResumeErr,
//                             })
//                           }
//                           className="servitorsignup-hidden"
//                         />
//                       </div>
//                       {resumeErr && (
//                         <div className="servitorsignup-inline-error">
//                           {resumeErr}
//                         </div>
//                       )}
//                     </div>

//                     {/* Student ID Card (image) — now like resume (no inline image preview) */}
//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {t("tutorservice.student_id_card")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <div
//                         className="servitorsignup-upload-area"
//                         onClick={() => idCardInputRef.current?.click()}
//                         onDragOver={handleDragOver}
//                         onDragLeave={handleDragLeave}
//                         onDrop={(e) =>
//                           handleDrop(e, setStudentIdCard, {
//                             isImageOnly: true,
//                             maxMB: MAX_MB,
//                             setPreview: setStudentIdPreview, // for new-tab preview
//                             setError: setIdErr,
//                           })
//                         }
//                       >
//                         {!studentIdCard ? (
//                           <div className="servitorsignup-upload-content">
//                             <svg
//                               className="servitorsignup-upload-icon"
//                               fill="none"
//                               stroke="currentColor"
//                               viewBox="0 0 24 24"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth="2"
//                                 d="M12 6v6m0 0v6m0-6h6m-6 0H6"
//                               />
//                             </svg>
//                             <p className="servitorsignup-upload-text">
//                               <span className="font-semibold">
//                                 {t("tutorservice.upload_id_card")}
//                               </span>
//                             </p>
//                             <p className="servitorsignup-upload-note">
//                               {t("servitor_signup.jpg_png_max")}
//                             </p>
//                             {idErr && (
//                               <div className="servitorsignup-inline-error">
//                                 {idErr}
//                               </div>
//                             )}
//                           </div>
//                         ) : (
//                           <div className="servitorsignup-uploaded-file">
//                             <p className="servitorsignup-file-name">
//                               {studentIdCard.name}
//                             </p>
//                             <div className="servitorsignup-doc-actions">
//                               <button
//                                 type="button"
//                                 className="servitorsignup-preview-btn"
//                                 onClick={(ev) => {
//                                   ev.stopPropagation();
//                                   if (studentIdPreview)
//                                     window.open(studentIdPreview, "_blank");
//                                 }}
//                               >
//                                 {t("tutorservice.preview")}
//                               </button>
//                               <button
//                                 type="button"
//                                 className="servitorsignup-change-btn"
//                                 onClick={(ev) => {
//                                   ev.stopPropagation();
//                                   setStudentIdCard(null);
//                                   if (studentIdPreview)
//                                     URL.revokeObjectURL(studentIdPreview);
//                                   setStudentIdPreview(null);
//                                   if (idCardInputRef.current)
//                                     idCardInputRef.current.value = null;
//                                 }}
//                               >
//                                 {t("tutorservice.change_file")}
//                               </button>
//                             </div>
//                           </div>
//                         )}
//                         <input
//                           type="file"
//                           ref={idCardInputRef}
//                           accept="image/*"
//                           onChange={(e) =>
//                             handleFileUpload(e, setStudentIdCard, {
//                               isImageOnly: true,
//                               maxMB: MAX_MB,
//                               setPreview: setStudentIdPreview,
//                               setError: setIdErr,
//                             })
//                           }
//                           className="servitorsignup-hidden"
//                         />
//                       </div>
//                       {idErr && (
//                         <div className="servitorsignup-inline-error">
//                           {idErr}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* 4. Profile photo */}
//               <div className="servitorsignup-section">
//                 <h2 className="servitorsignup-section-title">
//                   {i18n.language === "bn"
//                     ? isTutor
//                       ? "৪."
//                       : "৩."
//                     : isTutor
//                     ? "4."
//                     : "3."}{" "}
//                   {t("servitor_signup.profile_photo")}
//                 </h2>

//                 <div className="servitorsignup-photo-section">
//                   <div className="servitorsignup-upload-container">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.upload_recent_profile_photo")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>

//                     <div
//                       className="servitorsignup-upload-area"
//                       onClick={() => photoInputRef.current.click()}
//                       onDragOver={handleDragOver}
//                       onDragLeave={handleDragLeave}
//                       onDrop={(e) =>
//                         handleDrop(e, setImage, {
//                           isImageOnly: true,
//                           maxMB: MAX_MB,
//                           setError: setPhotoErr,
//                         })
//                       }
//                     >
//                       {!image ? (
//                         <div className="servitorsignup-upload-content">
//                           <svg
//                             className="servitorsignup-upload-icon"
//                             fill="none"
//                             stroke="currentColor"
//                             viewBox="0 0 24 24"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth="2"
//                               d="M12 6v6m0 0v6m0-6h6m-6 0H6"
//                             />
//                           </svg>
//                           <p className="servitorsignup-upload-text">
//                             <span className="font-semibold">
//                               {t("servitor_signup.upload_photo")}
//                             </span>
//                           </p>
//                           <p className="servitorsignup-upload-subtext">
//                             {t("servitor_signup.recent_photo")}
//                           </p>
//                           <p className="servitorsignup-upload-note">
//                             {t("servitor_signup.jpg_png_max")}
//                           </p>
//                           {photoErr && (
//                             <div className="servitorsignup-inline-error">
//                               {photoErr}
//                             </div>
//                           )}
//                         </div>
//                       ) : (
//                         <div className="servitorsignup-uploaded-file">
//                           <p className="servitorsignup-file-name">
//                             {image.name}
//                           </p>
//                           <button
//                             type="button"
//                             className="servitorsignup-change-btn"
//                             onClick={(ev) => {
//                               ev.stopPropagation();
//                               setImage(null);
//                               setPreviewImage(null);
//                               photoInputRef.current.value = null;
//                             }}
//                           >
//                             {t("servitor_signup.change_photo")}
//                           </button>
//                         </div>
//                       )}
//                       <input
//                         type="file"
//                         ref={photoInputRef}
//                         accept="image/*"
//                         onChange={(e) =>
//                           handleFileUpload(e, setImage, {
//                             isImageOnly: true,
//                             maxMB: MAX_MB,
//                             setError: setPhotoErr,
//                           })
//                         }
//                         className="servitorsignup-hidden"
//                       />
//                     </div>
//                   </div>

//                   {previewImage && (
//                     <div className="servitorsignup-photo-preview">
//                       <img
//                         src={previewImage}
//                         alt="Preview"
//                         className="servitorsignup-preview-image"
//                       />
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {/* 5. Bio */}
//               {/* <div className="servitorsignup-section">
//                 <h2 className="servitorsignup-section-title">
//                   {i18n.language === "bn"
//                     ? isTutor
//                       ? "৫."
//                       : "৪."
//                     : isTutor
//                     ? "5."
//                     : "4."}{" "}
//                   {t("servitor_signup.bio_skills")}
//                 </h2>
//                 <div className="servitorsignup-field servitorsignup-full-width">
//                   <label className="servitorsignup-label">
//                     {t("servitor_signup.bio")}{" "}
//                     <span className="required-asterisk">*</span>
//                   </label>
//                   <textarea
//                     rows="5"
//                     placeholder={t("servitor_signup.bio_ph")}
//                     value={bio}
//                     onChange={(e) => setBio(e.target.value)}
//                     required
//                     className="servitorsignup-textarea"
//                   ></textarea>
//                 </div>
//               </div> */}

//               {errMsg && (
//                 <div className="servitorsignup-error-message">{errMsg}</div>
//               )}

//               <div className="servitorsignup-form-note">
//                 {t("servitor_signup.note")}
//               </div>

//               <div className="servitorsignup-submit-container">
//                 <button type="submit" className="servitorsignup-submit-btn">
//                   {t("servitor_signup.submit")}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ServitorSignup;






// ***** New upldate Add City & Area (Bio filed removed) (9-seep-25) ***** //

// import React, { useState, useEffect, useMemo, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import axios from "axios";
// import Navbar from "../../Components/Navbar";
// import "./servitorsignupstyle.css";

// const MAX_MB = 2;

// const ServitorSignup = () => {
//   const { t, i18n } = useTranslation();
//   const navigate = useNavigate();

//   // Core fields
//   const [firstName, setFirstName] = useState("");
//   const [lastName, setLastName] = useState("");
//   const [mobile, setMobile] = useState("");
//   const [password, setPassword] = useState("");
//   const [nidPassport, setNidPassport] = useState("");
//   const [dob, setDob] = useState("");
//   const [selectedGender, setSelectedGender] = useState("");

//   // CITY / AREA now come from DB
//   const [divisions, setDivisions] = useState([]);      // [{Id, name, code}]
//   const [areas, setAreas] = useState([]);              // [{Id, name}]
//   const [selectedCity, setSelectedCity] = useState(""); // holds division Id as string
//   const [area, setArea] = useState("");                 // holds area name (string)

//   const [selectedService, setSelectedService] = useState("");
//   const [address, setAddress] = useState("");
//   const [experience, setExperience] = useState("");

//   // Files
//   const [image, setImage] = useState(null);
//   const [previewImage, setPreviewImage] = useState(null);

//   // Tutor-only files
//   const [resume, setResume] = useState(null);
//   const [resumeUrl, setResumeUrl] = useState(null);
//   const [studentIdCard, setStudentIdCard] = useState(null);
//   const [studentIdPreview, setStudentIdPreview] = useState(null); // object URL for preview

//   // Field-level errors (uploads)
//   const [photoErr, setPhotoErr] = useState("");
//   const [resumeErr, setResumeErr] = useState("");
//   const [idErr, setIdErr] = useState("");

//   // Misc
//   const [services, setServices] = useState([]);
//   const [universityType, setUniversityType] = useState("");
//   const [universityName, setUniversityName] = useState("");
//   const [major, setMajor] = useState("");
//   const [errMsg, setErrMsg] = useState("");

//   // Refs
//   const photoInputRef = useRef(null);
//   const resumeInputRef = useRef(null);
//   const idCardInputRef = useRef(null);

//   const isTutor = useMemo(
//     () => (selectedService || "").toLowerCase().includes("tutor"),
//     [selectedService]
//   );
  

//   // Load services (unchanged)
//   useEffect(() => {
//     const fetchServices = async () => {
//       try {
//         const response = await axios.get("http://localhost:4001/services");
//         setServices(response.data);
//       } catch (error) {
//         console.error("Error fetching services:", error);
//         setErrMsg(t("servitor_signup.error_messages.service_fetch_error"));
//       }
//     };
//     fetchServices();
//   }, [t]);

//   // Load active divisions ("cities") from DB
//   useEffect(() => {
//     const loadDivisions = async () => {
//       try {
//         const { data } = await axios.get("http://localhost:4001/locations/divisions"); // defaults to countryCode=BD
//         setDivisions(Array.isArray(data) ? data : []);
//       } catch (e) {
//         console.error("Error loading divisions:", e);
//         setDivisions([]);
//       }
//     };
//     loadDivisions();
//   }, []);

//   // When city changes, reset + load areas
//   const loadAreas = async (divisionId) => {
//     if (!divisionId) {
//       setAreas([]);
//       return;
//     }
//     try {
//       const { data } = await axios.get("http://localhost:4001/locations/areas", {
//         params: { divisionId },
//       });
//       setAreas(Array.isArray(data) ? data : []);
//     } catch (e) {
//       console.error("Error loading areas:", e);
//       setAreas([]);
//     }
//   };

//   useEffect(() => {
//     // Reset tutor-only fields if service changes away from tutor
//     if (!isTutor) {
//       setUniversityType("");
//       setUniversityName("");
//       setMajor("");
//       setStudentIdCard(null);
//       setStudentIdPreview(null);
//       setResume(null);
//       if (resumeUrl) URL.revokeObjectURL(resumeUrl);
//       setResumeUrl(null);
//       setPhotoErr("");
//       setResumeErr("");
//       setIdErr("");
//     }
//   }, [isTutor]); // eslint-disable-line

//   // cleanup object URLs
//   useEffect(
//     () => () => {
//       if (resumeUrl) URL.revokeObjectURL(resumeUrl);
//     },
//     [resumeUrl]
//   );
//   useEffect(
//     () => () => {
//       if (studentIdPreview) URL.revokeObjectURL(studentIdPreview);
//     },
//     [studentIdPreview]
//   );

//   // Generic file handler
//   const handleFileUpload = (e, setFile, optionsOrBoolean = false) => {
//     const options =
//       typeof optionsOrBoolean === "boolean"
//         ? { isImageOnly: optionsOrBoolean }
//         : optionsOrBoolean || {};
//     const {
//       isImageOnly = false,
//       isPdfOnly = false,
//       maxMB = MAX_MB,
//       setPreview,
//       setError,
//     } = options;

//     const file = e.target.files?.[0];
//     if (!file) return;

//     if (setError) setError("");

//     if (isImageOnly && !file.type.startsWith("image/")) {
//       setError && setError(t("servitor_signup.error_image_only"));
//       return;
//     }
//     if (isPdfOnly && file.type !== "application/pdf") {
//       setError && setError(t("servitor_signup.error_pdf_only"));
//       return;
//     }

//     if (file.size > maxMB * 1024 * 1024) {
//       setError && setError(t("servitor_signup.error_file_too_large"));
//       return;
//     }

//     setFile(file);

//     if (setPreview) {
//       const objectUrl = URL.createObjectURL(file);
//       setPreview(objectUrl);
//     }

//     if (!setPreview && file.type.startsWith("image/")) {
//       const reader = new FileReader();
//       reader.onload = (ev) => setPreviewImage(ev.target.result);
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Requireds (Profile photo is REQUIRED)
//     if (
//       !firstName ||
//       !lastName ||
//       !mobile ||
//       !password ||
//       !nidPassport ||
//       !dob ||
//       !selectedGender ||
//       !selectedService ||
//       !selectedCity ||       // division Id required
//       !address ||
//       !area ||               // area name required
//       !experience
//     ) {
//       setErrMsg(t("servitor_signup.error_messages.missing_fields"));
//       return;
//     }

//     if (!image) {
//       setErrMsg(
//         i18n.language === "bn"
//           ? "প্রোফাইল ছবি বাধ্যতামূলক"
//           : "Profile photo is required"
//       );
//       return;
//     }

//     const mobileRegex = /^01[3-9]\d{8}$/;
//     if (!mobileRegex.test(mobile)) {
//       setErrMsg(t("servitor_signup.error_mobile"));
//       return;
//     }

//     if (isTutor) {
//       if (
//         !universityType ||
//         !universityName.trim() ||
//         !major.trim() ||
//         !resume ||
//         !studentIdCard
//       ) {
//         setErrMsg(t("servitor_signup.error_messages.missing_fields"));
//         return;
//       }
//     }

//     // Map division Id -> name to store readable city name in DB
//     const divisionObj = divisions.find((d) => String(d.Id) === String(selectedCity));
//     const cityName = divisionObj?.name || "";

//     const formData = new FormData();
//     formData.append("firstName", firstName);
//     formData.append("lastName", lastName);
//     formData.append("mobile", mobile);
//     formData.append("password", password);
//     formData.append("NID", nidPassport);
//     formData.append("dob", dob);
//     formData.append("gender", selectedGender);
//     formData.append("service", selectedService);
//     formData.append("city", cityName);  // store division name
//     formData.append("Address", address);
//     formData.append("area", area);      // store area name
//     formData.append("experience", experience);

//     if (image) formData.append("image", image);

//     if (isTutor) {
//       formData.append("universityType", universityType.toLowerCase());
//       formData.append("universityName", universityName.trim());
//       formData.append("major", major.trim());
//       // resume goes as "certificate" (backend expects certificate)
//       if (resume) formData.append("certificate", resume);
//       if (studentIdCard) formData.append("studentIdCard", studentIdCard);
//     }

//     try {
//       await axios.post("http://localhost:4001/servitors", formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       navigate("/login");
//     } catch (error) {
//       console.error("Error during sign up:", error);
//       const errorMessage =
//         error.response?.data?.error || "Internal server error";
//       const errorKey = errorMessage.toLowerCase().replace(/\s+/g, "_");
//       const translatedError =
//         i18n.language === "bn"
//           ? t(`servitor_signup.error_messages.${errorKey}`, {
//               defaultValue: errorMessage,
//             })
//           : errorMessage;
//       setErrMsg(translatedError);
//     }
//   };

//   const getServiceKey = (serviceName) =>
//     serviceName.trim().toLowerCase().replace(/\s+/g, "_");

//   const handleDragOver = (e) => {
//     e.preventDefault();
//     e.currentTarget.classList.add("servitorsignup-dragover");
//   };
//   const handleDragLeave = (e) =>
//     e.currentTarget.classList.remove("servitorsignup-dragover");
//   const handleDrop = (e, setFile, optionsOrBoolean = false) => {
//     e.preventDefault();
//     e.currentTarget.classList.remove("servitorsignup-dragover");
//     if (e.dataTransfer.files.length > 0) {
//       handleFileUpload(
//         { target: { files: e.dataTransfer.files } },
//         setFile,
//         optionsOrBoolean
//       );
//     }
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="servitorsignup-container">
//         <div className="servitorsignup-content">
//           <div className="servitorsignup-header">
//             <h1 className="servitorsignup-title">
//               {t("servitor_signup.header")}
//             </h1>
//             <div className="servitorsignup-underline"></div>
//           </div>

//           <div className="servitorsignup-card">
//             <form className="servitorsignup-form" onSubmit={handleSubmit}>
//               {/* 1. Personal */}
//               <div className="servitorsignup-section">
//                 <h2 className="servitorsignup-section-title">
//                   {i18n.language === "bn" ? "১." : "1."}{" "}
//                   {t("servitor_signup.personal_info")}
//                 </h2>

//                 <div className="servitorsignup-personal-grid">
//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.first_name")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.first_name")}
//                       value={firstName}
//                       onChange={(e) => setFirstName(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.last_name")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.last_name")}
//                       value={lastName}
//                       onChange={(e) => setLastName(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.mobile")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="tel"
//                       placeholder={t("servitor_signup.mobile_ph")}
//                       value={mobile}
//                       onChange={(e) => setMobile(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.gender.label")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <select
//                       value={selectedGender}
//                       onChange={(e) => setSelectedGender(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     >
//                       <option value="">
//                         {t("servitor_signup.select_gender")}
//                       </option>
//                       <option value="male">
//                         {t("servitor_signup.gender.male")}
//                       </option>
//                       <option value="female">
//                         {t("servitor_signup.gender.female")}
//                       </option>
//                     </select>
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.nid_passport")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.nid_ph")}
//                       value={nidPassport}
//                       onChange={(e) => setNidPassport(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.dob")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="date"
//                       value={dob}
//                       onChange={(e) => setDob(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field servitorsignup-full-width">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.password")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="password"
//                       placeholder={t("servitor_signup.password_ph")}
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* 2. Service */}
//               <div className="servitorsignup-section">
//                 <h2 className="servitorsignup-section-title">
//                   {i18n.language === "bn" ? "২." : "2."}{" "}
//                   {t("servitor_signup.service_info")}
//                 </h2>

//                 <div className="servitorsignup-grid">
//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.service")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <select
//                       value={selectedService}
//                       onChange={(e) => setSelectedService(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     >
//                       <option value="">
//                         {t("servitor_signup.select_service")}
//                       </option>
//                       {services.map((service) => {
//                         const serviceKey = getServiceKey(service.services_name);
//                         const translatedName =
//                           i18n.language === "bn"
//                             ? t(`home.services.${serviceKey}.name`, {
//                                 defaultValue: service.services_name,
//                               })
//                             : service.services_name;
//                         return (
//                           <option
//                             key={service.Id}
//                             value={service.services_name}
//                           >
//                             {translatedName}
//                           </option>
//                         );
//                       })}
//                     </select>
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.experience")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="number"
//                       placeholder={t("servitor_signup.experience_ph")}
//                       value={experience}
//                       onChange={(e) => setExperience(e.target.value)}
//                       min="0"
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   {/* CITY from DB (divisions) */}
//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.city")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <select
//                       value={selectedCity}
//                       onChange={async (e) => {
//                         const id = e.target.value;
//                         setSelectedCity(id);
//                         setArea("");
//                         setAreas([]);
//                         await loadAreas(id);
//                       }}
//                       required
//                       className="servitorsignup-input"
//                     >
//                       <option value="">
//                         {t("servitor_signup.select_city")}
//                       </option>
//                       {divisions.map((d) => (
//                         <option key={d.Id} value={String(d.Id)}>
//                           {d.name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   {/* AREA from DB (areas under division) */}
//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.area")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <select
//                       value={area}
//                       onChange={(e) => setArea(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                       disabled={!selectedCity || areas.length === 0}
//                     >
//                       <option value="">
//                         {t("servitor_signup.select_area") || "Select area"}
//                       </option>
//                       {areas.map((a) => (
//                         <option key={a.Id} value={a.name}>
//                           {a.name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.address")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.address_ph")}
//                       value={address}
//                       onChange={(e) => setAddress(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* 3. Tutor info */}
//               {isTutor && (
//                 <div className="servitorsignup-section">
//                   <h2 className="servitorsignup-section-title">
//                     {i18n.language === "bn" ? "৩." : "3."}{" "}
//                     {t("tutorservice.tutor_info")}
//                   </h2>

//                   <div className="servitorsignup-grid">
//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {t("tutorservice.university_type")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <select
//                         value={universityType}
//                         onChange={(e) => setUniversityType(e.target.value)}
//                         required
//                         className="servitorsignup-input"
//                       >
//                         <option value="">
//                           {t("tutorservice.select_university_type")}
//                         </option>
//                         <option value="buet">BUET</option>
//                         <option value="medical">
//                           {t("tutorservice.medical")}
//                         </option>
//                         <option value="quran">
//                           {t("tutorservice.madrasa")}
//                         </option>
//                         <option value="du">{t("tutorservice.du")}</option>
//                         <option value="public">
//                           {t("tutorservice.public_university")}
//                         </option>
//                         <option value="private">
//                           {t("tutorservice.private_university")}
//                         </option>
//                         <option value="other">{t("tutorservice.other")}</option>
//                       </select>
//                     </div>

//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {t("tutorservice.university_name")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         placeholder={t("tutorservice.university_name_ph")}
//                         value={universityName}
//                         onChange={(e) => setUniversityName(e.target.value)}
//                         required
//                         className="servitorsignup-input"
//                       />
//                     </div>

//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {t("tutorservice.major")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         placeholder={t("tutorservice.major_ph")}
//                         value={major}
//                         onChange={(e) => setMajor(e.target.value)}
//                         required
//                         className="servitorsignup-input"
//                       />
//                     </div>
//                   </div>

//                   {/* Tutor docs */}
//                   <h3
//                     className="servitorsignup-section-title"
//                     style={{ marginTop: "1rem" }}
//                   >
//                     {t("tutorservice.student_docs")}
//                   </h3>

//                   <div className="servitorsignup-grid">
//                     {/* Resume (PDF -> certificate) */}
//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {t("tutorservice.upload_resume")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <div
//                         className="servitorsignup-upload-area"
//                         onClick={() => resumeInputRef.current?.click()}
//                         onDragOver={handleDragOver}
//                         onDragLeave={handleDragLeave}
//                         onDrop={(e) =>
//                           handleDrop(e, setResume, {
//                             isPdfOnly: true,
//                             maxMB: MAX_MB,
//                             setPreview: setResumeUrl,
//                             setError: setResumeErr,
//                           })
//                         }
//                       >
//                         {!resume ? (
//                           <div className="servitorsignup-upload-content">
//                             <svg
//                               className="servitorsignup-upload-icon"
//                               fill="none"
//                               stroke="currentColor"
//                               viewBox="0 0 24 24"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth="2"
//                                 d="M12 6v6m0 0v6m0-6h6m-6 0H6"
//                               />
//                             </svg>
//                             <p className="servitorsignup-upload-text">
//                               <span className="font-semibold">
//                                 {t("tutorservice.upload_resume")}
//                               </span>
//                             </p>
//                             <p className="servitorsignup-upload-note">
//                               {t("tutorservice.pdf_max")}
//                             </p>
//                             {resumeErr && (
//                               <div className="servitorsignup-inline-error">
//                                 {resumeErr}
//                               </div>
//                             )}
//                           </div>
//                         ) : (
//                           <div className="servitorsignup-uploaded-file">
//                             <p className="servitorsignup-file-name">
//                               {resume.name}
//                             </p>
//                             <div className="servitorsignup-doc-actions">
//                               <button
//                                 type="button"
//                                 className="servitorsignup-preview-btn"
//                                 onClick={(ev) => {
//                                   ev.stopPropagation();
//                                   if (resumeUrl)
//                                     window.open(resumeUrl, "_blank");
//                                 }}
//                               >
//                                 {t("tutorservice.preview")}
//                               </button>
//                               <button
//                                 type="button"
//                                 className="servitorsignup-change-btn"
//                                 onClick={(ev) => {
//                                   ev.stopPropagation();
//                                   setResume(null);
//                                   if (resumeUrl) URL.revokeObjectURL(resumeUrl);
//                                   setResumeUrl(null);
//                                   if (resumeInputRef.current)
//                                     resumeInputRef.current.value = null;
//                                 }}
//                               >
//                                 {t("tutorservice.change_file")}
//                               </button>
//                             </div>
//                           </div>
//                         )}
//                         <input
//                           type="file"
//                           ref={resumeInputRef}
//                           accept="application/pdf"
//                           onChange={(e) =>
//                             handleFileUpload(e, setResume, {
//                               isPdfOnly: true,
//                               maxMB: MAX_MB,
//                               setPreview: setResumeUrl,
//                               setError: setResumeErr,
//                             })
//                           }
//                           className="servitorsignup-hidden"
//                         />
//                       </div>
//                       {resumeErr && (
//                         <div className="servitorsignup-inline-error">
//                           {resumeErr}
//                         </div>
//                       )}
//                     </div>

//                     {/* Student ID Card (image) */}
//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {t("tutorservice.student_id_card")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <div
//                         className="servitorsignup-upload-area"
//                         onClick={() => idCardInputRef.current?.click()}
//                         onDragOver={handleDragOver}
//                         onDragLeave={handleDragLeave}
//                         onDrop={(e) =>
//                           handleDrop(e, setStudentIdCard, {
//                             isImageOnly: true,
//                             maxMB: MAX_MB,
//                             setPreview: setStudentIdPreview,
//                             setError: setIdErr,
//                           })
//                         }
//                       >
//                         {!studentIdCard ? (
//                           <div className="servitorsignup-upload-content">
//                             <svg
//                               className="servitorsignup-upload-icon"
//                               fill="none"
//                               stroke="currentColor"
//                               viewBox="0 0 24 24"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth="2"
//                                 d="M12 6v6m0 0v6m0-6h6m-6 0H6"
//                               />
//                             </svg>
//                             <p className="servitorsignup-upload-text">
//                               <span className="font-semibold">
//                                 {t("tutorservice.upload_id_card")}
//                               </span>
//                             </p>
//                             <p className="servitorsignup-upload-note">
//                               {t("servitor_signup.jpg_png_max")}
//                             </p>
//                             {idErr && (
//                               <div className="servitorsignup-inline-error">
//                                 {idErr}
//                               </div>
//                             )}
//                           </div>
//                         ) : (
//                           <div className="servitorsignup-uploaded-file">
//                             <p className="servitorsignup-file-name">
//                               {studentIdCard.name}
//                             </p>
//                             <div className="servitorsignup-doc-actions">
//                               <button
//                                 type="button"
//                                 className="servitorsignup-preview-btn"
//                                 onClick={(ev) => {
//                                   ev.stopPropagation();
//                                   if (studentIdPreview)
//                                     window.open(studentIdPreview, "_blank");
//                                 }}
//                               >
//                                 {t("tutorservice.preview")}
//                               </button>
//                               <button
//                                 type="button"
//                                 className="servitorsignup-change-btn"
//                                 onClick={(ev) => {
//                                   ev.stopPropagation();
//                                   setStudentIdCard(null);
//                                   if (studentIdPreview)
//                                     URL.revokeObjectURL(studentIdPreview);
//                                   setStudentIdPreview(null);
//                                   if (idCardInputRef.current)
//                                     idCardInputRef.current.value = null;
//                                 }}
//                               >
//                                 {t("tutorservice.change_file")}
//                               </button>
//                             </div>
//                           </div>
//                         )}
//                         <input
//                           type="file"
//                           ref={idCardInputRef}
//                           accept="image/*"
//                           onChange={(e) =>
//                             handleFileUpload(e, setStudentIdCard, {
//                               isImageOnly: true,
//                               maxMB: MAX_MB,
//                               setPreview: setStudentIdPreview,
//                               setError: setIdErr,
//                             })
//                           }
//                           className="servitorsignup-hidden"
//                         />
//                       </div>
//                       {idErr && (
//                         <div className="servitorsignup-inline-error">
//                           {idErr}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* 4. Profile photo */}
//               <div className="servitorsignup-section">
//                 <h2 className="servitorsignup-section-title">
//                   {i18n.language === "bn"
//                     ? isTutor
//                       ? "৪."
//                       : "৩."
//                     : isTutor
//                     ? "4."
//                     : "3."}{" "}
//                   {t("servitor_signup.profile_photo")}
//                 </h2>

//                 <div className="servitorsignup-photo-section">
//                   <div className="servitorsignup-upload-container">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.upload_recent_profile_photo")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>

//                     <div
//                       className="servitorsignup-upload-area"
//                       onClick={() => photoInputRef.current.click()}
//                       onDragOver={handleDragOver}
//                       onDragLeave={handleDragLeave}
//                       onDrop={(e) =>
//                         handleDrop(e, setImage, {
//                           isImageOnly: true,
//                           maxMB: MAX_MB,
//                           setError: setPhotoErr,
//                         })
//                       }
//                     >
//                       {!image ? (
//                         <div className="servitorsignup-upload-content">
//                           <svg
//                             className="servitorsignup-upload-icon"
//                             fill="none"
//                             stroke="currentColor"
//                             viewBox="0 0 24 24"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth="2"
//                               d="M12 6v6m0 0v6m0-6h6m-6 0H6"
//                             />
//                           </svg>
//                           <p className="servitorsignup-upload-text">
//                             <span className="font-semibold">
//                               {t("servitor_signup.upload_photo")}
//                             </span>
//                           </p>
//                           <p className="servitorsignup-upload-subtext">
//                             {t("servitor_signup.recent_photo")}
//                           </p>
//                           <p className="servitorsignup-upload-note">
//                             {t("servitor_signup.jpg_png_max")}
//                           </p>
//                           {photoErr && (
//                             <div className="servitorsignup-inline-error">
//                               {photoErr}
//                             </div>
//                           )}
//                         </div>
//                       ) : (
//                         <div className="servitorsignup-uploaded-file">
//                           <p className="servitorsignup-file-name">
//                             {image.name}
//                           </p>
//                           <button
//                             type="button"
//                             className="servitorsignup-change-btn"
//                             onClick={(ev) => {
//                               ev.stopPropagation();
//                               setImage(null);
//                               setPreviewImage(null);
//                               photoInputRef.current.value = null;
//                             }}
//                           >
//                             {t("servitor_signup.change_photo")}
//                           </button>
//                         </div>
//                       )}
//                       <input
//                         type="file"
//                         ref={photoInputRef}
//                         accept="image/*"
//                         onChange={(e) =>
//                           handleFileUpload(e, setImage, {
//                             isImageOnly: true,
//                             maxMB: MAX_MB,
//                             setError: setPhotoErr,
//                           })
//                         }
//                         className="servitorsignup-hidden"
//                       />
//                     </div>
//                   </div>

//                   {previewImage && (
//                     <div className="servitorsignup-photo-preview">
//                       <img
//                         src={previewImage}
//                         alt="Preview"
//                         className="servitorsignup-preview-image"
//                       />
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {errMsg && (
//                 <div className="servitorsignup-error-message">{errMsg}</div>
//               )}

//               <div className="servitorsignup-form-note">
//                 {t("servitor_signup.note")}
//               </div>

//               <div className="servitorsignup-submit-container">
//                 <button type="submit" className="servitorsignup-submit-btn">
//                   {t("servitor_signup.submit")}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ServitorSignup;







// ***** Add Otp Modal (Area & City dropdown from Api) (9-sep-25) ***** //

// import React, { useState, useEffect, useMemo, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import axios from "axios";
// import Navbar from "../../Components/Navbar";
// import "./servitorsignupstyle.css";

// const MAX_MB = 2;

// const ServitorSignup = () => {
//   const { t, i18n } = useTranslation();
//   const navigate = useNavigate();

//   // Core fields
//   const [firstName, setFirstName] = useState("");
//   const [lastName, setLastName] = useState("");
//   const [mobile, setMobile] = useState("");
//   const [password, setPassword] = useState("");
//   const [nidPassport, setNidPassport] = useState("");
//   const [dob, setDob] = useState("");
//   const [selectedGender, setSelectedGender] = useState("");

//   // CITY / AREA from DB
//   const [divisions, setDivisions] = useState([]);      // [{Id, name, code}]
//   const [areas, setAreas] = useState([]);              // [{Id, name}]
//   const [selectedCity, setSelectedCity] = useState(""); // holds division Id as string
//   const [area, setArea] = useState("");                 // holds area name (string)

//   const [selectedService, setSelectedService] = useState("");
//   const [address, setAddress] = useState("");
//   const [experience, setExperience] = useState("");

//   // Files
//   const [image, setImage] = useState(null);
//   const [previewImage, setPreviewImage] = useState(null);

//   // Tutor-only files
//   const [resume, setResume] = useState(null);
//   const [resumeUrl, setResumeUrl] = useState(null);
//   const [studentIdCard, setStudentIdCard] = useState(null);
//   const [studentIdPreview, setStudentIdPreview] = useState(null);

//   // Upload errors
//   const [photoErr, setPhotoErr] = useState("");
//   const [resumeErr, setResumeErr] = useState("");
//   const [idErr, setIdErr] = useState("");

//   // Misc
//   const [services, setServices] = useState([]);
//   const [universityType, setUniversityType] = useState("");
//   const [universityName, setUniversityName] = useState("");
//   const [major, setMajor] = useState("");
//   const [errMsg, setErrMsg] = useState("");

//   // Refs
//   const photoInputRef = useRef(null);
//   const resumeInputRef = useRef(null);
//   const idCardInputRef = useRef(null);

//   const isTutor = useMemo(
//     () => (selectedService || "").toLowerCase().includes("tutor"),
//     [selectedService]
//   );

//   // ================
//   // NEW: OTP modal state
//   // ================
//   const [showOtp, setShowOtp] = useState(false);
//   const [otpId, setOtpId] = useState(null);
//   const [otp, setOtp] = useState("");
//   const [otpErr, setOtpErr] = useState("");
//   const [otpSeconds, setOtpSeconds] = useState(60);
//   const [sendingOtp, setSendingOtp] = useState(false);
//   const [verifyingOtp, setVerifyingOtp] = useState(false);

//   // Keep a ready-to-send payload after OTP (so you don’t rebuild it twice)
//   const pendingPayloadRef = useRef(null);

//   // NEW: simple countdown for resend button
//   useEffect(() => {
//     if (!showOtp) return;
//     setOtpSeconds(60);
//     const timer = setInterval(() => {
//       setOtpSeconds((s) => (s > 0 ? s - 1 : 0));
//     }, 1000);
//     return () => clearInterval(timer);
//   }, [showOtp]);

//   // Load services
//   useEffect(() => {
//     const fetchServices = async () => {
//       try {
//         const response = await axios.get("http://localhost:4001/services");
//         setServices(response.data);
//       } catch (error) {
//         console.error("Error fetching services:", error);
//         setErrMsg(t("servitor_signup.error_messages.service_fetch_error"));
//       }
//     };
//     fetchServices();
//   }, [t]);

//   // Load active divisions ("cities")
//   useEffect(() => {
//     const loadDivisions = async () => {
//       try {
//         const { data } = await axios.get("http://localhost:4001/locations/divisions");
//         setDivisions(Array.isArray(data) ? data : []);
//       } catch (e) {
//         console.error("Error loading divisions:", e);
//         setDivisions([]);
//       }
//     };
//     loadDivisions();
//   }, []);

//   // Load areas for a division
//   const loadAreas = async (divisionId) => {
//     if (!divisionId) {
//       setAreas([]);
//       return;
//     }
//     try {
//       const { data } = await axios.get("http://localhost:4001/locations/areas", {
//         params: { divisionId },
//       });
//       setAreas(Array.isArray(data) ? data : []);
//     } catch (e) {
//       console.error("Error loading areas:", e);
//       setAreas([]);
//     }
//   };

//   useEffect(() => {
//     if (!isTutor) {
//       setUniversityType("");
//       setUniversityName("");
//       setMajor("");
//       setStudentIdCard(null);
//       setStudentIdPreview(null);
//       setResume(null);
//       if (resumeUrl) URL.revokeObjectURL(resumeUrl);
//       setResumeUrl(null);
//       setPhotoErr("");
//       setResumeErr("");
//       setIdErr("");
//     }
//   }, [isTutor]); // eslint-disable-line

//   // cleanup object URLs
//   useEffect(
//     () => () => {
//       if (resumeUrl) URL.revokeObjectURL(resumeUrl);
//     },
//     [resumeUrl]
//   );
//   useEffect(
//     () => () => {
//       if (studentIdPreview) URL.revokeObjectURL(studentIdPreview);
//     },
//     [studentIdPreview]
//   );

//   // Generic file handler
//   const handleFileUpload = (e, setFile, optionsOrBoolean = false) => {
//     const options =
//       typeof optionsOrBoolean === "boolean"
//         ? { isImageOnly: optionsOrBoolean }
//         : optionsOrBoolean || {};
//     const {
//       isImageOnly = false,
//       isPdfOnly = false,
//       maxMB = MAX_MB,
//       setPreview,
//       setError,
//     } = options;

//     const file = e.target.files?.[0];
//     if (!file) return;

//     if (setError) setError("");

//     if (isImageOnly && !file.type.startsWith("image/")) {
//       setError && setError(t("servitor_signup.error_image_only"));
//       return;
//     }
//     if (isPdfOnly && file.type !== "application/pdf") {
//       setError && setError(t("servitor_signup.error_pdf_only"));
//       return;
//     }

//     if (file.size > maxMB * 1024 * 1024) {
//       setError && setError(t("servitor_signup.error_file_too_large"));
//       return;
//     }

//     setFile(file);

//     if (setPreview) {
//       const objectUrl = URL.createObjectURL(file);
//       setPreview(objectUrl);
//     }

//     if (!setPreview && file.type.startsWith("image/")) {
//       const reader = new FileReader();
//       reader.onload = (ev) => setPreviewImage(ev.target.result);
//       reader.readAsDataURL(file);
//     }
//   };

//   // ================
//   // CHANGED: handleSubmit now starts OTP instead of creating immediately
//   // ================
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Requireds
//     if (
//       !firstName ||
//       !lastName ||
//       !mobile ||
//       !password ||
//       !nidPassport ||
//       !dob ||
//       !selectedGender ||
//       !selectedService ||
//       !selectedCity ||
//       !address ||
//       !area ||
//       !experience
//     ) {
//       setErrMsg(t("servitor_signup.error_messages.missing_fields"));
//       return;
//     }

//     if (!image) {
//       setErrMsg(
//         i18n.language === "bn"
//           ? "প্রোফাইল ছবি বাধ্যতামূলক"
//           : "Profile photo is required"
//       );
//       return;
//     }

//     // BD number validation (must be 11 digits, start with 01[3-9])
//     const mobileRegex = /^01[3-9]\d{8}$/;
//     if (!mobileRegex.test(mobile)) {
//       setErrMsg(t("servitor_signup.error_mobile"));
//       return;
//     }

//     if (isTutor) {
//       if (
//         !universityType ||
//         !universityName.trim() ||
//         !major.trim() ||
//         !resume ||
//         !studentIdCard
//       ) {
//         setErrMsg(t("servitor_signup.error_messages.missing_fields"));
//         return;
//       }
//     }

//     // Store what we need to finish later
//     const divisionObj = divisions.find((d) => String(d.Id) === String(selectedCity));
//     const cityName = divisionObj?.name || "";

//     pendingPayloadRef.current = {
//       firstName,
//       lastName,
//       mobile,
//       password,
//       nidPassport,
//       dob, // keep your existing dob string
//       selectedGender,
//       selectedService,
//       cityName,
//       address,
//       area,
//       experience,
//       image,
//       isTutor,
//       universityType,
//       universityName,
//       major,
//       resume,
//       studentIdCard,
//     };

//     // Start OTP
//     try {
//       setSendingOtp(true);
//       const { data } = await axios.post("http://localhost:4001/otp/start", {
//         mobile
//       });
//       setOtpId(data.otpId);          // expect { otpId, expiresIn }
//       setOtp("");
//       setOtpErr("");
//       setShowOtp(true);
//       if (typeof data.expiresIn === "number") {
//         setOtpSeconds(data.expiresIn);
//       } else {
//         setOtpSeconds(60);
//       }
//     } catch (error) {
//       console.error("OTP start failed:", error);
//       const msg = error.response?.data?.error || "Failed to send verification code.";
//       setErrMsg(msg);
//     } finally {
//       setSendingOtp(false);
//     }
//   };

//   // NEW: finalize signup after OTP verify
//   const finishSignupAfterOtp = async () => {
//     const p = pendingPayloadRef.current;
//     if (!p) return;

//     const formData = new FormData();
//     formData.append("firstName", p.firstName);
//     formData.append("lastName", p.lastName);
//     formData.append("mobile", p.mobile);
//     formData.append("password", p.password);
//     formData.append("NID", p.nidPassport);
//     formData.append("dob", p.dob);
//     formData.append("gender", p.selectedGender);
//     formData.append("service", p.selectedService);
//     formData.append("city", p.cityName);
//     formData.append("Address", p.address);
//     formData.append("area", p.area);
//     formData.append("experience", p.experience);
//     if (p.image) formData.append("image", p.image);

//     if (p.isTutor) {
//       formData.append("universityType", p.universityType.toLowerCase());
//       formData.append("universityName", p.universityName.trim());
//       formData.append("major", p.major.trim());
//       if (p.resume) formData.append("certificate", p.resume);
//       if (p.studentIdCard) formData.append("studentIdCard", p.studentIdCard);
//     }

//     // IMPORTANT: prove mobile was verified
//     if (otpId) formData.append("otpId", otpId);

//     await axios.post("http://localhost:4001/servitors", formData, {
//       headers: { "Content-Type": "multipart/form-data" },
//     });
//   };

//   // NEW: verify OTP
//   const verifyOtp = async () => {
//     if (otp.length !== 6) {
//       setOtpErr("Enter the 6-digit code.");
//       return;
//     }
//     try {
//       setVerifyingOtp(true);
//       await axios.post("http://localhost:4001/otp/verify", { otpId, code: otp });
//       await finishSignupAfterOtp();
//       setShowOtp(false);
//       navigate("/login");
//     } catch (err) {
//       console.error("OTP verify failed:", err);
//       const msg = err.response?.data?.error || "Invalid or expired code.";
//       setOtpErr(msg);
//     } finally {
//       setVerifyingOtp(false);
//     }
//   };

//   // NEW: resend OTP
//   const resendOtp = async () => {
//     if (otpSeconds > 0) return;
//     try {
//       setSendingOtp(true);
//       const { data } = await axios.post("http://localhost:4001/otp/start", { mobile });
//       setOtpId(data.otpId);
//       setOtp("");
//       setOtpErr("");
//       setOtpSeconds(typeof data.expiresIn === "number" ? data.expiresIn : 60);
//     } catch (err) {
//       console.error("Resend OTP failed:", err);
//       setOtpErr("Failed to resend code.");
//     } finally {
//       setSendingOtp(false);
//     }
//   };

//   const getServiceKey = (serviceName) =>
//     serviceName.trim().toLowerCase().replace(/\s+/g, "_");

//   const handleDragOver = (e) => {
//     e.preventDefault();
//     e.currentTarget.classList.add("servitorsignup-dragover");
//   };
//   const handleDragLeave = (e) =>
//     e.currentTarget.classList.remove("servitorsignup-dragover");
//   const handleDrop = (e, setFile, optionsOrBoolean = false) => {
//     e.preventDefault();
//     e.currentTarget.classList.remove("servitorsignup-dragover");
//     if (e.dataTransfer.files.length > 0) {
//       handleFileUpload(
//         { target: { files: e.dataTransfer.files } },
//         setFile,
//         optionsOrBoolean
//       );
//     }
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="servitorsignup-container">
//         <div className="servitorsignup-content">
//           <div className="servitorsignup-header">
//             <h1 className="servitorsignup-title">
//               {t("servitor_signup.header")}
//             </h1>
//             <div className="servitorsignup-underline"></div>
//           </div>

//           <div className="servitorsignup-card">
//             <form className="servitorsignup-form" onSubmit={handleSubmit}>
//               {/* 1. Personal */}
//               <div className="servitorsignup-section">
//                 <h2 className="servitorsignup-section-title">
//                   {i18n.language === "bn" ? "১." : "1."}{" "}
//                   {t("servitor_signup.personal_info")}
//                 </h2>

//                 <div className="servitorsignup-personal-grid">
//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.first_name")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.first_name")}
//                       value={firstName}
//                       onChange={(e) => setFirstName(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.last_name")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.last_name")}
//                       value={lastName}
//                       onChange={(e) => setLastName(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.mobile")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       // NEW: mobile is strictly 11 numeric chars
//                       type="tel"
//                       inputMode="numeric"
//                       pattern="\d{11}"
//                       maxLength={11}
//                       placeholder={t("servitor_signup.mobile_ph")}
//                       value={mobile}
//                       onChange={(e) =>
//                         setMobile(e.target.value.replace(/\D/g, "").slice(0, 11))
//                       }
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.gender.label")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <select
//                       value={selectedGender}
//                       onChange={(e) => setSelectedGender(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     >
//                       <option value="">
//                         {t("servitor_signup.select_gender")}
//                       </option>
//                       <option value="male">
//                         {t("servitor_signup.gender.male")}
//                       </option>
//                       <option value="female">
//                         {t("servitor_signup.gender.female")}
//                       </option>
//                     </select>
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.nid_passport")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.nid_ph")}
//                       value={nidPassport}
//                       onChange={(e) => setNidPassport(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.dob")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="date"
//                       value={dob}
//                       onChange={(e) => setDob(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field servitorsignup-full-width">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.password")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="password"
//                       placeholder={t("servitor_signup.password_ph")}
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* 2. Service */}
//               <div className="servitorsignup-section">
//                 <h2 className="servitorsignup-section-title">
//                   {i18n.language === "bn" ? "২." : "2."}{" "}
//                   {t("servitor_signup.service_info")}
//                 </h2>

//                 <div className="servitorsignup-grid">
//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.service")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <select
//                       value={selectedService}
//                       onChange={(e) => setSelectedService(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     >
//                       <option value="">
//                         {t("servitor_signup.select_service")}
//                       </option>
//                       {services.map((service) => {
//                         const serviceKey = getServiceKey(service.services_name);
//                         const translatedName =
//                           i18n.language === "bn"
//                             ? t(`home.services.${serviceKey}.name`, {
//                                 defaultValue: service.services_name,
//                               })
//                             : service.services_name;
//                         return (
//                           <option
//                             key={service.Id}
//                             value={service.services_name}
//                           >
//                             {translatedName}
//                           </option>
//                         );
//                       })}
//                     </select>
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.experience")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="number"
//                       placeholder={t("servitor_signup.experience_ph")}
//                       value={experience}
//                       onChange={(e) => setExperience(e.target.value)}
//                       min="0"
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   {/* CITY */}
//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.city")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <select
//                       value={selectedCity}
//                       onChange={async (e) => {
//                         const id = e.target.value;
//                         setSelectedCity(id);
//                         setArea("");
//                         setAreas([]);
//                         await loadAreas(id);
//                       }}
//                       required
//                       className="servitorsignup-input"
//                     >
//                       <option value="">
//                         {t("servitor_signup.select_city")}
//                       </option>
//                       {divisions.map((d) => (
//                         <option key={d.Id} value={String(d.Id)}>
//                           {d.name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   {/* AREA */}
//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.area")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <select
//                       value={area}
//                       onChange={(e) => setArea(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                       disabled={!selectedCity || areas.length === 0}
//                     >
//                       <option value="">
//                         {t("servitor_signup.select_area") || "Select area"}
//                       </option>
//                       {areas.map((a) => (
//                         <option key={a.Id} value={a.name}>
//                           {a.name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.address")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.address_ph")}
//                       value={address}
//                       onChange={(e) => setAddress(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* 3. Tutor info */}
//               {isTutor && (
//                 <div className="servitorsignup-section">
//                   <h2 className="servitorsignup-section-title">
//                     {i18n.language === "bn" ? "৩." : "3."}{" "}
//                     {t("tutorservice.tutor_info")}
//                   </h2>

//                   <div className="servitorsignup-grid">
//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {t("tutorservice.university_type")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <select
//                         value={universityType}
//                         onChange={(e) => setUniversityType(e.target.value)}
//                         required
//                         className="servitorsignup-input"
//                       >
//                         <option value="">
//                           {t("tutorservice.select_university_type")}
//                         </option>
//                         <option value="buet">BUET</option>
//                         <option value="medical">
//                           {t("tutorservice.medical")}
//                         </option>
//                         <option value="quran">
//                           {t("tutorservice.madrasa")}
//                         </option>
//                         <option value="du">{t("tutorservice.du")}</option>
//                         <option value="public">
//                           {t("tutorservice.public_university")}
//                         </option>
//                         <option value="private">
//                           {t("tutorservice.private_university")}
//                         </option>
//                         <option value="other">{t("tutorservice.other")}</option>
//                       </select>
//                     </div>

//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {t("tutorservice.university_name")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         placeholder={t("tutorservice.university_name_ph")}
//                         value={universityName}
//                         onChange={(e) => setUniversityName(e.target.value)}
//                         required
//                         className="servitorsignup-input"
//                       />
//                     </div>

//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {t("tutorservice.major")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         placeholder={t("tutorservice.major_ph")}
//                         value={major}
//                         onChange={(e) => setMajor(e.target.value)}
//                         required
//                         className="servitorsignup-input"
//                       />
//                     </div>
//                   </div>

//                   {/* Tutor docs */}
//                   <h3
//                     className="servitorsignup-section-title"
//                     style={{ marginTop: "1rem" }}
//                   >
//                     {t("tutorservice.student_docs")}
//                   </h3>

//                   <div className="servitorsignup-grid">
//                     {/* Resume (PDF -> certificate) */}
//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {t("tutorservice.upload_resume")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <div
//                         className="servitorsignup-upload-area"
//                         onClick={() => resumeInputRef.current?.click()}
//                         onDragOver={handleDragOver}
//                         onDragLeave={handleDragLeave}
//                         onDrop={(e) =>
//                           handleDrop(e, setResume, {
//                             isPdfOnly: true,
//                             maxMB: MAX_MB,
//                             setPreview: setResumeUrl,
//                             setError: setResumeErr,
//                           })
//                         }
//                       >
//                         {!resume ? (
//                           <div className="servitorsignup-upload-content">
//                             <svg
//                               className="servitorsignup-upload-icon"
//                               fill="none"
//                               stroke="currentColor"
//                               viewBox="0 0 24 24"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth="2"
//                                 d="M12 6v6m0 0v6m0-6h6m-6 0H6"
//                               />
//                             </svg>
//                             <p className="servitorsignup-upload-text">
//                               <span className="font-semibold">
//                                 {t("tutorservice.upload_resume")}
//                               </span>
//                             </p>
//                             <p className="servitorsignup-upload-note">
//                               {t("tutorservice.pdf_max")}
//                             </p>
//                             {resumeErr && (
//                               <div className="servitorsignup-inline-error">
//                                 {resumeErr}
//                               </div>
//                             )}
//                           </div>
//                         ) : (
//                           <div className="servitorsignup-uploaded-file">
//                             <p className="servitorsignup-file-name">
//                               {resume.name}
//                             </p>
//                             <div className="servitorsignup-doc-actions">
//                               <button
//                                 type="button"
//                                 className="servitorsignup-preview-btn"
//                                 onClick={(ev) => {
//                                   ev.stopPropagation();
//                                   if (resumeUrl)
//                                     window.open(resumeUrl, "_blank");
//                                 }}
//                               >
//                                 {t("tutorservice.preview")}
//                               </button>
//                               <button
//                                 type="button"
//                                 className="servitorsignup-change-btn"
//                                 onClick={(ev) => {
//                                   ev.stopPropagation();
//                                   setResume(null);
//                                   if (resumeUrl) URL.revokeObjectURL(resumeUrl);
//                                   setResumeUrl(null);
//                                   if (resumeInputRef.current)
//                                     resumeInputRef.current.value = null;
//                                 }}
//                               >
//                                 {t("tutorservice.change_file")}
//                               </button>
//                             </div>
//                           </div>
//                         )}
//                         <input
//                           type="file"
//                           ref={resumeInputRef}
//                           accept="application/pdf"
//                           onChange={(e) =>
//                             handleFileUpload(e, setResume, {
//                               isPdfOnly: true,
//                               maxMB: MAX_MB,
//                               setPreview: setResumeUrl,
//                               setError: setResumeErr,
//                             })
//                           }
//                           className="servitorsignup-hidden"
//                         />
//                       </div>
//                       {resumeErr && (
//                         <div className="servitorsignup-inline-error">
//                           {resumeErr}
//                         </div>
//                       )}
//                     </div>

//                     {/* Student ID Card (image) */}
//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {t("tutorservice.student_id_card")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <div
//                         className="servitorsignup-upload-area"
//                         onClick={() => idCardInputRef.current?.click()}
//                         onDragOver={handleDragOver}
//                         onDragLeave={handleDragLeave}
//                         onDrop={(e) =>
//                           handleDrop(e, setStudentIdCard, {
//                             isImageOnly: true,
//                             maxMB: MAX_MB,
//                             setPreview: setStudentIdPreview,
//                             setError: setIdErr,
//                           })
//                         }
//                       >
//                         {!studentIdCard ? (
//                           <div className="servitorsignup-upload-content">
//                             <svg
//                               className="servitorsignup-upload-icon"
//                               fill="none"
//                               stroke="currentColor"
//                               viewBox="0 0 24 24"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth="2"
//                                 d="M12 6v6m0 0v6m0-6h6m-6 0H6"
//                               />
//                             </svg>
//                             <p className="servitorsignup-upload-text">
//                               <span className="font-semibold">
//                                 {t("tutorservice.upload_id_card")}
//                               </span>
//                             </p>
//                             <p className="servitorsignup-upload-note">
//                               {t("servitor_signup.jpg_png_max")}
//                             </p>
//                             {idErr && (
//                               <div className="servitorsignup-inline-error">
//                                 {idErr}
//                               </div>
//                             )}
//                           </div>
//                         ) : (
//                           <div className="servitorsignup-uploaded-file">
//                             <p className="servitorsignup-file-name">
//                               {studentIdCard.name}
//                             </p>
//                             <div className="servitorsignup-doc-actions">
//                               <button
//                                 type="button"
//                                 className="servitorsignup-preview-btn"
//                                 onClick={(ev) => {
//                                   ev.stopPropagation();
//                                   if (studentIdPreview)
//                                     window.open(studentIdPreview, "_blank");
//                                 }}
//                               >
//                                 {t("tutorservice.preview")}
//                               </button>
//                               <button
//                                 type="button"
//                                 className="servitorsignup-change-btn"
//                                 onClick={(ev) => {
//                                   ev.stopPropagation();
//                                   setStudentIdCard(null);
//                                   if (studentIdPreview)
//                                     URL.revokeObjectURL(studentIdPreview);
//                                   setStudentIdPreview(null);
//                                   if (idCardInputRef.current)
//                                     idCardInputRef.current.value = null;
//                                 }}
//                               >
//                                 {t("tutorservice.change_file")}
//                               </button>
//                             </div>
//                           </div>
//                         )}
//                         <input
//                           type="file"
//                           ref={idCardInputRef}
//                           accept="image/*"
//                           onChange={(e) =>
//                             handleFileUpload(e, setStudentIdCard, {
//                               isImageOnly: true,
//                               maxMB: MAX_MB,
//                               setPreview: setStudentIdPreview,
//                               setError: setIdErr,
//                             })
//                           }
//                           className="servitorsignup-hidden"
//                         />
//                       </div>
//                       {idErr && (
//                         <div className="servitorsignup-inline-error">
//                           {idErr}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* 4. Profile photo */}
//               <div className="servitorsignup-section">
//                 <h2 className="servitorsignup-section-title">
//                   {i18n.language === "bn"
//                     ? isTutor
//                       ? "৪."
//                       : "৩."
//                     : isTutor
//                     ? "4."
//                     : "3."}{" "}
//                   {t("servitor_signup.profile_photo")}
//                 </h2>

//                 <div className="servitorsignup-photo-section">
//                   <div className="servitorsignup-upload-container">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.upload_recent_profile_photo")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>

//                     <div
//                       className="servitorsignup-upload-area"
//                       onClick={() => photoInputRef.current.click()}
//                       onDragOver={handleDragOver}
//                       onDragLeave={handleDragLeave}
//                       onDrop={(e) =>
//                         handleDrop(e, setImage, {
//                           isImageOnly: true,
//                           maxMB: MAX_MB,
//                           setError: setPhotoErr,
//                         })
//                       }
//                     >
//                       {!image ? (
//                         <div className="servitorsignup-upload-content">
//                           <svg
//                             className="servitorsignup-upload-icon"
//                             fill="none"
//                             stroke="currentColor"
//                             viewBox="0 0 24 24"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth="2"
//                               d="M12 6v6m0 0v6m0-6h6m-6 0H6"
//                             />
//                           </svg>
//                           <p className="servitorsignup-upload-text">
//                             <span className="font-semibold">
//                               {t("servitor_signup.upload_photo")}
//                             </span>
//                           </p>
//                           <p className="servitorsignup-upload-subtext">
//                             {t("servitor_signup.recent_photo")}
//                           </p>
//                           <p className="servitorsignup-upload-note">
//                             {t("servitor_signup.jpg_png_max")}
//                           </p>
//                           {photoErr && (
//                             <div className="servitorsignup-inline-error">
//                               {photoErr}
//                             </div>
//                           )}
//                         </div>
//                       ) : (
//                         <div className="servitorsignup-uploaded-file">
//                           <p className="servitorsignup-file-name">
//                             {image.name}
//                           </p>
//                           <button
//                             type="button"
//                             className="servitorsignup-change-btn"
//                             onClick={(ev) => {
//                               ev.stopPropagation();
//                               setImage(null);
//                               setPreviewImage(null);
//                               photoInputRef.current.value = null;
//                             }}
//                           >
//                             {t("servitor_signup.change_photo")}
//                           </button>
//                         </div>
//                       )}
//                       <input
//                         type="file"
//                         ref={photoInputRef}
//                         accept="image/*"
//                         onChange={(e) =>
//                           handleFileUpload(e, setImage, {
//                             isImageOnly: true,
//                             maxMB: MAX_MB,
//                             setError: setPhotoErr,
//                           })
//                         }
//                         className="servitorsignup-hidden"
//                       />
//                     </div>
//                   </div>

//                   {previewImage && (
//                     <div className="servitorsignup-photo-preview">
//                       <img
//                         src={previewImage}
//                         alt="Preview"
//                         className="servitorsignup-preview-image"
//                       />
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {errMsg && (
//                 <div className="servitorsignup-error-message">{errMsg}</div>
//               )}

//               <div className="servitorsignup-form-note">
//                 {t("servitor_signup.note")}
//               </div>

//               <div className="servitorsignup-submit-container">
//                 <button
//                   type="submit"
//                   className="servitorsignup-submit-btn"
//                   disabled={sendingOtp}
//                 >
//                   {sendingOtp ? "Sending code..." : t("servitor_signup.submit")}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>

//       {/* NEW: OTP Modal */}
//       {showOtp && (
//         <div className="otp-overlay">
//           <div className="otp-modal">
//             <h3 className="otp-title">Verify your phone</h3>
//             <p className="otp-sub">
//               We sent a 6-digit code to <strong>{mobile}</strong>
//             </p>

//             <input
//               className="servitorsignup-input otp-input"
//               type="tel"
//               inputMode="numeric"
//               pattern="[0-9]*"
//               maxLength={6}
//               placeholder="Enter 6-digit code"
//               value={otp}
//               onChange={(e) =>
//                 setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))
//               }
//               autoFocus
//             />

//             {otpErr && (
//               <div className="servitorsignup-inline-error">{otpErr}</div>
//             )}

//             <div className="otp-actions">
//               <button
//                 type="button"
//                 className="servitorsignup-submit-btn"
//                 onClick={verifyOtp}
//                 disabled={verifyingOtp}
//               >
//                 {verifyingOtp ? "Verifying..." : "Verify & Continue"}
//               </button>

//               <button
//                 type="button"
//                 className="otp-resend"
//                 onClick={resendOtp}
//                 disabled={sendingOtp || otpSeconds > 0}
//                 title={
//                   otpSeconds > 0 ? `Resend in ${otpSeconds}s` : "Resend code"
//                 }
//               >
//                 {otpSeconds > 0 ? `Resend in ${otpSeconds}s` : "Resend code"}
//               </button>

//               <button
//                 type="button"
//                 className="otp-cancel"
//                 onClick={() => setShowOtp(false)}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ServitorSignup;









// import React, { useState, useEffect, useMemo, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import axios from "axios";
// import Navbar from "../../Components/Navbar";
// import "./servitorsignupstyle.css";

// const MAX_MB = 2;

// const ServitorSignup = () => {
//   const { t, i18n } = useTranslation();
//   const navigate = useNavigate();

//   // Core fields
//   const [firstName, setFirstName] = useState("");
//   const [lastName, setLastName] = useState("");
//   const [mobile, setMobile] = useState("");
//   const [password, setPassword] = useState("");
//   const [nidPassport, setNidPassport] = useState("");
//   const [dob, setDob] = useState("");
//   const [selectedGender, setSelectedGender] = useState("");

//   // CITY / AREA from DB
//   const [divisions, setDivisions] = useState([]);      // [{Id, name, code}]
//   const [areas, setAreas] = useState([]);              // [{Id, name}]
//   const [selectedCity, setSelectedCity] = useState(""); // holds division Id as string
//   const [area, setArea] = useState("");                 // holds area name (string)

//   const [selectedService, setSelectedService] = useState("");
//   const [address, setAddress] = useState("");
//   const [experience, setExperience] = useState("");

//   // Files
//   const [image, setImage] = useState(null);
//   const [previewImage, setPreviewImage] = useState(null);

//   // Tutor-only files
//   const [resume, setResume] = useState(null);
//   const [resumeUrl, setResumeUrl] = useState(null);
//   const [studentIdCard, setStudentIdCard] = useState(null);
//   const [studentIdPreview, setStudentIdPreview] = useState(null);

//   // Upload errors
//   const [photoErr, setPhotoErr] = useState("");
//   const [resumeErr, setResumeErr] = useState("");
//   const [idErr, setIdErr] = useState("");

//   // Misc
//   const [services, setServices] = useState([]);
//   const [universityType, setUniversityType] = useState("");
//   const [universityName, setUniversityName] = useState("");
//   const [major, setMajor] = useState("");
//   const [errMsg, setErrMsg] = useState("");

//   // Refs
//   const photoInputRef = useRef(null);
//   const resumeInputRef = useRef(null);
//   const idCardInputRef = useRef(null);

//   const isTutor = useMemo(
//     () => (selectedService || "").toLowerCase().includes("tutor"),
//     [selectedService]
//   );

//   // ================
//   // NEW: OTP modal state
//   // ================
//   const [showOtp, setShowOtp] = useState(false);
//   const [showSuccess, setShowSuccess] = useState(false);
//   const [otpId, setOtpId] = useState(null);
//   const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
//   const [otpErr, setOtpErr] = useState("");
//   const [otpSeconds, setOtpSeconds] = useState(60);
//   const [successTimer, setSuccessTimer] = useState(5);
//   const [sendingOtp, setSendingOtp] = useState(false);
//   const [verifyingOtp, setVerifyingOtp] = useState(false);

//   // Keep a ready-to-send payload after OTP (so you don’t rebuild it twice)
//   const pendingPayloadRef = useRef(null);

//   // NEW: simple countdown for resend button
//   useEffect(() => {
//     if (!showOtp) return;
//     // setOtpSeconds(60);
//     const timer = setInterval(() => {
//       setOtpSeconds((s) => (s > 0 ? s - 1 : 0));
//     }, 1000);
//     return () => clearInterval(timer);
//   }, [showOtp]);

//   // NEW: success redirect timer
//   // useEffect(() => {
//   //   if (showSuccess) {
//   //     const interval = setInterval(() => {
//   //       setSuccessTimer((prev) => {
//   //         if (prev <= 1) {
//   //           clearInterval(interval);
//   //           navigate("/login");
//   //           return 0;
//   //         }
//   //         return prev - 1;
//   //       });
//   //     }, 1000);
//   //     return () => clearInterval(interval);
//   //   }
//   // }, [showSuccess, navigate]);


//   useEffect(() => {
//   if (!showSuccess) return;
//   setSuccessTimer(5); // reset each time success modal is shown
//   const interval = setInterval(() => {
//     setSuccessTimer((prev) => {
//       if (prev <= 1) {
//         clearInterval(interval);
//         navigate("/login");
//         return 0;
//       }
//       return prev - 1;
//     });
//   }, 1000);
//   return () => clearInterval(interval);
// }, [showSuccess, navigate]);


//   // Load services
//   useEffect(() => {
//     const fetchServices = async () => {
//       try {
//         const response = await axios.get("http://localhost:4001/services");
//         setServices(response.data);
//       } catch (error) {
//         console.error("Error fetching services:", error);
//         setErrMsg(t("servitor_signup.error_messages.service_fetch_error"));
//       }
//     };
//     fetchServices();
//   }, [t]);

//   // Load active divisions ("cities")
//   useEffect(() => {
//     const loadDivisions = async () => {
//       try {
//         const { data } = await axios.get("http://localhost:4001/locations/divisions");
//         setDivisions(Array.isArray(data) ? data : []);
//       } catch (e) {
//         console.error("Error loading divisions:", e);
//         setDivisions([]);
//       }
//     };
//     loadDivisions();
//   }, []);

//   // Load areas for a division
//   const loadAreas = async (divisionId) => {
//     if (!divisionId) {
//       setAreas([]);
//       return;
//     }
//     try {
//       const { data } = await axios.get("http://localhost:4001/locations/areas", {
//         params: { divisionId },
//       });
//       setAreas(Array.isArray(data) ? data : []);
//     } catch (e) {
//       console.error("Error loading areas:", e);
//       setAreas([]);
//     }
//   };

//   useEffect(() => {
//     if (!isTutor) {
//       setUniversityType("");
//       setUniversityName("");
//       setMajor("");
//       setStudentIdCard(null);
//       setStudentIdPreview(null);
//       setResume(null);
//       if (resumeUrl) URL.revokeObjectURL(resumeUrl);
//       setResumeUrl(null);
//       setPhotoErr("");
//       setResumeErr("");
//       setIdErr("");
//     }
//   }, [isTutor]); // eslint-disable-line

//   // cleanup object URLs
//   useEffect(
//     () => () => {
//       if (resumeUrl) URL.revokeObjectURL(resumeUrl);
//     },
//     [resumeUrl]
//   );
//   useEffect(
//     () => () => {
//       if (studentIdPreview) URL.revokeObjectURL(studentIdPreview);
//     },
//     [studentIdPreview]
//   );

//   // Generic file handler
//   const handleFileUpload = (e, setFile, optionsOrBoolean = false) => {
//     const options =
//       typeof optionsOrBoolean === "boolean"
//         ? { isImageOnly: optionsOrBoolean }
//         : optionsOrBoolean || {};
//     const {
//       isImageOnly = false,
//       isPdfOnly = false,
//       maxMB = MAX_MB,
//       setPreview,
//       setError,
//     } = options;

//     const file = e.target.files?.[0];
//     if (!file) return;

//     if (setError) setError("");

//     if (isImageOnly && !file.type.startsWith("image/")) {
//       setError && setError(t("servitor_signup.error_image_only"));
//       return;
//     }
//     if (isPdfOnly && file.type !== "application/pdf") {
//       setError && setError(t("servitor_signup.error_pdf_only"));
//       return;
//     }

//     if (file.size > maxMB * 1024 * 1024) {
//       setError && setError(t("servitor_signup.error_file_too_large"));
//       return;
//     }

//     setFile(file);

//     if (setPreview) {
//       const objectUrl = URL.createObjectURL(file);
//       setPreview(objectUrl);
//     }

//     if (!setPreview && file.type.startsWith("image/")) {
//       const reader = new FileReader();
//       reader.onload = (ev) => setPreviewImage(ev.target.result);
//       reader.readAsDataURL(file);
//     }
//   };

//   // ================
//   // CHANGED: handleSubmit now starts OTP instead of creating immediately
//   // ================
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Requireds
//     if (
//       !firstName ||
//       !lastName ||
//       !mobile ||
//       !password ||
//       !nidPassport ||
//       !dob ||
//       !selectedGender ||
//       !selectedService ||
//       !selectedCity ||
//       !address ||
//       !area ||
//       !experience
//     ) {
//       setErrMsg(t("servitor_signup.error_messages.missing_fields"));
//       return;
//     }

//     if (!image) {
//       setErrMsg(
//         i18n.language === "bn"
//           ? "প্রোফাইল ছবি বাধ্যতামূলক"
//           : "Profile photo is required"
//       );
//       return;
//     }

//     // BD number validation (must be 11 digits, start with 01[3-9])
//     const mobileRegex = /^01[3-9]\d{8}$/;
//     if (!mobileRegex.test(mobile)) {
//       setErrMsg(t("servitor_signup.error_mobile"));
//       return;
//     }

//     if (isTutor) {
//       if (
//         !universityType ||
//         !universityName.trim() ||
//         !major.trim() ||
//         !resume ||
//         !studentIdCard
//       ) {
//         setErrMsg(t("servitor_signup.error_messages.missing_fields"));
//         return;
//       }
//     }

//     // Store what we need to finish later
//     const divisionObj = divisions.find((d) => String(d.Id) === String(selectedCity));
//     const cityName = divisionObj?.name || "";

//     pendingPayloadRef.current = {
//       firstName,
//       lastName,
//       mobile,
//       password,
//       nidPassport,
//       dob, // keep your existing dob string
//       selectedGender,
//       selectedService,
//       cityName,
//       address,
//       area,
//       experience,
//       image,
//       isTutor,
//       universityType,
//       universityName,
//       major,
//       resume,
//       studentIdCard,
//     };

//     // Start OTP
//     try {
//       setSendingOtp(true);
//       const { data } = await axios.post("http://localhost:4001/otp/start", {
//         mobile
//       });
//       setOtpId(data.otpId);          // expect { otpId, expiresIn }
//       setOtpDigits(["", "", "", "", "", ""]);
//       setOtpErr("");
//       setShowOtp(true);
//       if (typeof data.expiresIn === "number") {
//         setOtpSeconds(data.expiresIn);
//       } else {
//         setOtpSeconds(60);
//       }
//     } catch (error) {
//       console.error("OTP start failed:", error);
//       const msg = error.response?.data?.error || "Failed to send verification code.";
//       setErrMsg(msg);
//     } finally {
//       setSendingOtp(false);
//     }
//   };

//   // NEW: finalize signup after OTP verify
//   const finishSignupAfterOtp = async () => {
//     const p = pendingPayloadRef.current;
//     if (!p) return;

//     const formData = new FormData();
//     formData.append("firstName", p.firstName);
//     formData.append("lastName", p.lastName);
//     formData.append("mobile", p.mobile);
//     formData.append("password", p.password);
//     formData.append("NID", p.nidPassport);
//     formData.append("dob", p.dob);
//     formData.append("gender", p.selectedGender);
//     formData.append("service", p.selectedService);
//     formData.append("city", p.cityName);
//     formData.append("Address", p.address);
//     formData.append("area", p.area);
//     formData.append("experience", p.experience);
//     if (p.image) formData.append("image", p.image);

//     if (p.isTutor) {
//       formData.append("universityType", p.universityType.toLowerCase());
//       formData.append("universityName", p.universityName.trim());
//       formData.append("major", p.major.trim());
//       if (p.resume) formData.append("certificate", p.resume);
//       if (p.studentIdCard) formData.append("studentIdCard", p.studentIdCard);
//     }

//     // IMPORTANT: prove mobile was verified
//     if (otpId) formData.append("otpId", otpId);

//     await axios.post("http://localhost:4001/servitors", formData, {
//       headers: { "Content-Type": "multipart/form-data" },
//     });
//   };

//   // NEW: OTP change handler
//   // const handleOtpChange = (e, index) => {
//   //   const value = e.target.value.replace(/\D/g, "");
//   //   if (value) {
//   //     const newDigits = [...otpDigits];
//   //     newDigits[index] = value;
//   //     setOtpDigits(newDigits);
//   //     if (index < 5) {
//   //       const nextInput = document.querySelector(`input[data-index="${index + 1}"]`);
//   //       nextInput?.focus();
//   //     }
//   //     if (newDigits.every((d) => d)) {
//   //       verifyOtp(newDigits.join(""));
//   //     }
//   //   }
//   // };

//   const handleOtpChange = (e, index) => {
//   const value = e.target.value.replace(/\D/g, "").slice(0, 1); // force single digit
//   const newDigits = [...otpDigits];
//   newDigits[index] = value;
//   setOtpDigits(newDigits);

//   // move focus forward when a digit is entered
//   if (value && index < 5) {
//     const nextInput = document.querySelector(`input[data-index="${index + 1}"]`);
//     nextInput?.focus();
//   }

//   // auto-verify when all 6 boxes are filled
//   if (newDigits.every((d) => d.length === 1)) {
//     verifyOtp(newDigits.join(""));
//   }
// };


//   // NEW: OTP keydown handler
//   // const handleOtpKeyDown = (e, index) => {
//   //   if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
//   //     const prevInput = document.querySelector(`input[data-index="${index - 1}"]`);
//   //     prevInput?.focus();
//   //   }
//   // };

//   const handleOtpKeyDown = (e, index) => {
//   if (e.key === "Backspace") {
//     e.preventDefault();
//     const newDigits = [...otpDigits];

//     if (newDigits[index]) {
//       // if current has a value, clear it
//       newDigits[index] = "";
//       setOtpDigits(newDigits);
//     } else if (index > 0) {
//       // if current empty, clear previous and focus it
//       newDigits[index - 1] = "";
//       setOtpDigits(newDigits);
//       const prevInput = document.querySelector(`input[data-index="${index - 1}"]`);
//       prevInput?.focus();
//     }
//   }
// };


//   // NEW: OTP paste handler
//   const handleOtpPaste = (e, index) => {
//     e.preventDefault();
//     const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
//     if (!pasted) return;

//     const newDigits = [...otpDigits];
//     pasted.split("").forEach((char, i) => {
//       if (index + i < 6) {
//         newDigits[index + i] = char;
//       }
//     });
//     setOtpDigits(newDigits);
//     const lastFilled = index + pasted.length - 1;
//     const focusIndex = Math.min(lastFilled, 5);
//     const focusInput = document.querySelector(`input[data-index="${focusIndex}"]`);
//     focusInput?.focus();
//     if (newDigits.every((d) => d)) {
//       verifyOtp(newDigits.join(""));
//     }
//   };

//   // NEW: verify OTP
//   // const verifyOtp = async (code) => {
//   //   if (code.length !== 6) {
//   //     setOtpErr("Enter the 6-digit code.");
//   //     return;
//   //   }
//   //   try {
//   //     setVerifyingOtp(true);
//   //     await axios.post("http://localhost:4001/otp/verify", { otpId, code });
//   //     await finishSignupAfterOtp();
//   //     setShowOtp(false);
//   //     setShowSuccess(true);
//   //   } catch (err) {
//   //     console.error("OTP verify failed:", err);
//   //     const msg = err.response?.data?.error || "Invalid or expired code.";
//   //     setOtpErr(msg);
//   //     setOtpDigits(["", "", "", "", "", ""]);

//   //     setTimeout(() => {
//   //       const first = document.querySelector('input[data-index="0"]');
//   //       first?.focus();
//   //     }, 0);
//   //   } finally {
//   //     setVerifyingOtp(false);
//   //   }
//   // };

//     const verifyOtp = async (code) => {
//     if (code.length !== 6) {
//       setOtpErr("Enter the 6-digit code.");
//       return;
//     }

//     setVerifyingOtp(true);
//     try {
//       // 1) Verify OTP first
//       await axios.post("http://localhost:4001/otp/verify", { otpId, code });
//     } catch (err) {
//       console.error("OTP verify failed:", err);
//       const msg = err.response?.data?.error || "Invalid or expired code.";
//       setOtpErr(msg);
//       setOtpDigits(["", "", "", "", "", ""]);
//       setTimeout(() => {
//         const first = document.querySelector('input[data-index="0"]');
//         first?.focus();
//       }, 0);
//       return; // stop here—don't try to finish signup
//     } finally {
//       setVerifyingOtp(false);
//     }

//     // 2) OTP ok — now finish signup
//     try {
//       setVerifyingOtp(true);
//       await finishSignupAfterOtp();
//       setShowOtp(false);
//       setShowSuccess(true);
//     } catch (err) {
//       console.error("Signup finalize failed:", err);
//       const msg = err.response?.data?.error || "Registration failed. Please try again.";
//       setOtpErr(msg);
//       // keep digits so user can retry without retyping the OTP
//     } finally {
//       setVerifyingOtp(false);
//     }
//   };



  

//   // NEW: resend OTP
//   // const resendOtp = async () => {
//   //   if (otpSeconds > 0) return;
//   //   try {
//   //     setSendingOtp(true);
//   //     const { data } = await axios.post("http://localhost:4001/otp/start", { mobile });
//   //     setOtpId(data.otpId);
//   //     setOtpDigits(["", "", "", "", "", ""]);
//   //     setOtpErr("");
//   //     setOtpSeconds(typeof data.expiresIn === "number" ? data.expiresIn : 60);
//   //   } catch (err) {
//   //     console.error("Resend OTP failed:", err);
//   //     setOtpErr("Failed to resend code.");
//   //   } finally {
//   //     setSendingOtp(false);
//   //   }
//   // };


//   const resendOtp = async () => {
//   if (otpSeconds > 0) return;
//   try {
//     setSendingOtp(true);
//     const { data } = await axios.post("http://localhost:4001/otp/start", { mobile });
//     setOtpId(data.otpId);
//     setOtpDigits(["", "", "", "", "", ""]);
//     setOtpErr("");
//     setOtpSeconds(typeof data.expiresIn === "number" ? data.expiresIn : 60);

//     // NEW: focus first input right away
//     setTimeout(() => {
//       const first = document.querySelector('input[data-index="0"]');
//       first?.focus();
//     }, 0);
//   } catch (err) {
//     console.error("Resend OTP failed:", err);
//     setOtpErr("Failed to resend code.");
//   } finally {
//     setSendingOtp(false);
//   }
// };


//   const getServiceKey = (serviceName) =>
//     serviceName.trim().toLowerCase().replace(/\s+/g, "_");

//   const handleDragOver = (e) => {
//     e.preventDefault();
//     e.currentTarget.classList.add("servitorsignup-dragover");
//   };
//   const handleDragLeave = (e) =>
//     e.currentTarget.classList.remove("servitorsignup-dragover");
//   const handleDrop = (e, setFile, optionsOrBoolean = false) => {
//     e.preventDefault();
//     e.currentTarget.classList.remove("servitorsignup-dragover");
//     if (e.dataTransfer.files.length > 0) {
//       handleFileUpload(
//         { target: { files: e.dataTransfer.files } },
//         setFile,
//         optionsOrBoolean
//       );
//     }
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="servitorsignup-container">
//         <div className="servitorsignup-content">
//           <div className="servitorsignup-header">
//             <h1 className="servitorsignup-title">
//               {t("servitor_signup.header")}
//             </h1>
//             <div className="servitorsignup-underline"></div>
//           </div>

//           <div className="servitorsignup-card">
//             <form className="servitorsignup-form" onSubmit={handleSubmit}>
//               {/* 1. Personal */}
//               <div className="servitorsignup-section">
//                 <h2 className="servitorsignup-section-title">
//                   {i18n.language === "bn" ? "১." : "1."}{" "}
//                   {t("servitor_signup.personal_info")}
//                 </h2>

//                 <div className="servitorsignup-personal-grid">
//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.first_name")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.first_name")}
//                       value={firstName}
//                       onChange={(e) => setFirstName(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.last_name")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.last_name")}
//                       value={lastName}
//                       onChange={(e) => setLastName(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.mobile")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       // NEW: mobile is strictly 11 numeric chars
//                       type="tel"
//                       inputMode="numeric"
//                       pattern="\d{11}"
//                       maxLength={11}
//                       placeholder={t("servitor_signup.mobile_ph")}
//                       value={mobile}
//                       onChange={(e) =>
//                         setMobile(e.target.value.replace(/\D/g, "").slice(0, 11))
//                       }
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.gender.label")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <select
//                       value={selectedGender}
//                       onChange={(e) => setSelectedGender(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     >
//                       <option value="">
//                         {t("servitor_signup.select_gender")}
//                       </option>
//                       <option value="male">
//                         {t("servitor_signup.gender.male")}
//                       </option>
//                       <option value="female">
//                         {t("servitor_signup.gender.female")}
//                       </option>
//                     </select>
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.nid_passport")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.nid_ph")}
//                       value={nidPassport}
//                       onChange={(e) => setNidPassport(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.dob")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="date"
//                       value={dob}
//                       onChange={(e) => setDob(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   <div className="servitorsignup-field servitorsignup-full-width">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.password")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="password"
//                       placeholder={t("servitor_signup.password_ph")}
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* 2. Service */}
//               <div className="servitorsignup-section">
//                 <h2 className="servitorsignup-section-title">
//                   {i18n.language === "bn" ? "২." : "2."}{" "}
//                   {t("servitor_signup.service_info")}
//                 </h2>

//                 <div className="servitorsignup-grid">
//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.service")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <select
//                       value={selectedService}
//                       onChange={(e) => setSelectedService(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     >
//                       <option value="">
//                         {t("servitor_signup.select_service")}
//                       </option>
//                       {services.map((service) => {
//                         const serviceKey = getServiceKey(service.services_name);
//                         const translatedName =
//                           i18n.language === "bn"
//                             ? t(`home.services.${serviceKey}.name`, {
//                                 defaultValue: service.services_name,
//                               })
//                             : service.services_name;
//                         return (
//                           <option
//                             key={service.Id}
//                             value={service.services_name}
//                           >
//                             {translatedName}
//                           </option>
//                         );
//                       })}
//                     </select>
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.experience")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="number"
//                       placeholder={t("servitor_signup.experience_ph")}
//                       value={experience}
//                       onChange={(e) => setExperience(e.target.value)}
//                       min="0"
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>

//                   {/* CITY */}
//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.city")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <select
//                       value={selectedCity}
//                       onChange={async (e) => {
//                         const id = e.target.value;
//                         setSelectedCity(id);
//                         setArea("");
//                         setAreas([]);
//                         await loadAreas(id);
//                       }}
//                       required
//                       className="servitorsignup-input"
//                     >
//                       <option value="">
//                         {t("servitor_signup.select_city")}
//                       </option>
//                       {divisions.map((d) => (
//                         <option key={d.Id} value={String(d.Id)}>
//                           {d.name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   {/* AREA */}
//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.area")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <select
//                       value={area}
//                       onChange={(e) => setArea(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                       disabled={!selectedCity || areas.length === 0}
//                     >
//                       <option value="">
//                         {t("servitor_signup.select_area") || "Select area"}
//                       </option>
//                       {areas.map((a) => (
//                         <option key={a.Id} value={a.name}>
//                           {a.name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   <div className="servitorsignup-field">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.address")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={t("servitor_signup.address_ph")}
//                       value={address}
//                       onChange={(e) => setAddress(e.target.value)}
//                       required
//                       className="servitorsignup-input"
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* 3. Tutor info */}
//               {isTutor && (
//                 <div className="servitorsignup-section">
//                   <h2 className="servitorsignup-section-title">
//                     {i18n.language === "bn" ? "৩." : "3."}{" "}
//                     {t("tutorservice.tutor_info")}
//                   </h2>

//                   <div className="servitorsignup-grid">
//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {t("tutorservice.university_type")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <select
//                         value={universityType}
//                         onChange={(e) => setUniversityType(e.target.value)}
//                         required
//                         className="servitorsignup-input"
//                       >
//                         <option value="">
//                           {t("tutorservice.select_university_type")}
//                         </option>
//                         <option value="buet">BUET</option>
//                         <option value="medical">
//                           {t("tutorservice.medical")}
//                         </option>
//                         <option value="quran">
//                           {t("tutorservice.madrasa")}
//                         </option>
//                         <option value="du">{t("tutorservice.du")}</option>
//                         <option value="public">
//                           {t("tutorservice.public_university")}
//                         </option>
//                         <option value="private">
//                           {t("tutorservice.private_university")}
//                         </option>
//                         <option value="other">{t("tutorservice.other")}</option>
//                       </select>
//                     </div>

//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {t("tutorservice.university_name")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         placeholder={t("tutorservice.university_name_ph")}
//                         value={universityName}
//                         onChange={(e) => setUniversityName(e.target.value)}
//                         required
//                         className="servitorsignup-input"
//                       />
//                     </div>

//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {t("tutorservice.major")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         placeholder={t("tutorservice.major_ph")}
//                         value={major}
//                         onChange={(e) => setMajor(e.target.value)}
//                         required
//                         className="servitorsignup-input"
//                       />
//                     </div>
//                   </div>

//                   {/* Tutor docs */}
//                   <h3
//                     className="servitorsignup-section-title"
//                     style={{ marginTop: "1rem" }}
//                   >
//                     {t("tutorservice.student_docs")}
//                   </h3>

//                   <div className="servitorsignup-grid">
//                     {/* Resume (PDF -> certificate) */}
//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {t("tutorservice.upload_resume")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <div
//                         className="servitorsignup-upload-area"
//                         onClick={() => resumeInputRef.current?.click()}
//                         onDragOver={handleDragOver}
//                         onDragLeave={handleDragLeave}
//                         onDrop={(e) =>
//                           handleDrop(e, setResume, {
//                             isPdfOnly: true,
//                             maxMB: MAX_MB,
//                             setPreview: setResumeUrl,
//                             setError: setResumeErr,
//                           })
//                         }
//                       >
//                         {!resume ? (
//                           <div className="servitorsignup-upload-content">
//                             <svg
//                               className="servitorsignup-upload-icon"
//                               fill="none"
//                               stroke="currentColor"
//                               viewBox="0 0 24 24"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth="2"
//                                 d="M12 6v6m0 0v6m0-6h6m-6 0H6"
//                               />
//                             </svg>
//                             <p className="servitorsignup-upload-text">
//                               <span className="font-semibold">
//                                 {t("tutorservice.upload_resume")}
//                               </span>
//                             </p>
//                             <p className="servitorsignup-upload-note">
//                               {t("tutorservice.pdf_max")}
//                             </p>
//                             {resumeErr && (
//                               <div className="servitorsignup-inline-error">
//                                 {resumeErr}
//                               </div>
//                             )}
//                           </div>
//                         ) : (
//                           <div className="servitorsignup-uploaded-file">
//                             <p className="servitorsignup-file-name">
//                               {resume.name}
//                             </p>
//                             <div className="servitorsignup-doc-actions">
//                               <button
//                                 type="button"
//                                 className="servitorsignup-preview-btn"
//                                 onClick={(ev) => {
//                                   ev.stopPropagation();
//                                   if (resumeUrl)
//                                     window.open(resumeUrl, "_blank");
//                                 }}
//                               >
//                                 {t("tutorservice.preview")}
//                               </button>
//                               <button
//                                 type="button"
//                                 className="servitorsignup-change-btn"
//                                 onClick={(ev) => {
//                                   ev.stopPropagation();
//                                   setResume(null);
//                                   if (resumeUrl) URL.revokeObjectURL(resumeUrl);
//                                   setResumeUrl(null);
//                                   if (resumeInputRef.current)
//                                     resumeInputRef.current.value = null;
//                                 }}
//                               >
//                                 {t("tutorservice.change_file")}
//                               </button>
//                             </div>
//                           </div>
//                         )}
//                         <input
//                           type="file"
//                           ref={resumeInputRef}
//                           accept="application/pdf"
//                           onChange={(e) =>
//                             handleFileUpload(e, setResume, {
//                               isPdfOnly: true,
//                               maxMB: MAX_MB,
//                               setPreview: setResumeUrl,
//                               setError: setResumeErr,
//                             })
//                           }
//                           className="servitorsignup-hidden"
//                         />
//                       </div>
//                       {resumeErr && (
//                         <div className="servitorsignup-inline-error">
//                           {resumeErr}
//                         </div>
//                       )}
//                     </div>

//                     {/* Student ID Card (image) */}
//                     <div className="servitorsignup-field">
//                       <label className="servitorsignup-label">
//                         {t("tutorservice.student_id_card")}{" "}
//                         <span className="required-asterisk">*</span>
//                       </label>
//                       <div
//                         className="servitorsignup-upload-area"
//                         onClick={() => idCardInputRef.current?.click()}
//                         onDragOver={handleDragOver}
//                         onDragLeave={handleDragLeave}
//                         onDrop={(e) =>
//                           handleDrop(e, setStudentIdCard, {
//                             isImageOnly: true,
//                             maxMB: MAX_MB,
//                             setPreview: setStudentIdPreview,
//                             setError: setIdErr,
//                           })
//                         }
//                       >
//                         {!studentIdCard ? (
//                           <div className="servitorsignup-upload-content">
//                             <svg
//                               className="servitorsignup-upload-icon"
//                               fill="none"
//                               stroke="currentColor"
//                               viewBox="0 0 24 24"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth="2"
//                                 d="M12 6v6m0 0v6m0-6h6m-6 0H6"
//                               />
//                             </svg>
//                             <p className="servitorsignup-upload-text">
//                               <span className="font-semibold">
//                                 {t("tutorservice.upload_id_card")}
//                               </span>
//                             </p>
//                             <p className="servitorsignup-upload-note">
//                               {t("servitor_signup.jpg_png_max")}
//                             </p>
//                             {idErr && (
//                               <div className="servitorsignup-inline-error">
//                                 {idErr}
//                               </div>
//                             )}
//                           </div>
//                         ) : (
//                           <div className="servitorsignup-uploaded-file">
//                             <p className="servitorsignup-file-name">
//                               {studentIdCard.name}
//                             </p>
//                             <div className="servitorsignup-doc-actions">
//                               <button
//                                 type="button"
//                                 className="servitorsignup-preview-btn"
//                                 onClick={(ev) => {
//                                   ev.stopPropagation();
//                                   if (studentIdPreview)
//                                     window.open(studentIdPreview, "_blank");
//                                 }}
//                               >
//                                 {t("tutorservice.preview")}
//                               </button>
//                               <button
//                                 type="button"
//                                 className="servitorsignup-change-btn"
//                                 onClick={(ev) => {
//                                   ev.stopPropagation();
//                                   setStudentIdCard(null);
//                                   if (studentIdPreview)
//                                     URL.revokeObjectURL(studentIdPreview);
//                                   setStudentIdPreview(null);
//                                   if (idCardInputRef.current)
//                                     idCardInputRef.current.value = null;
//                                 }}
//                               >
//                                 {t("tutorservice.change_file")}
//                               </button>
//                             </div>
//                           </div>
//                         )}
//                         <input
//                           type="file"
//                           ref={idCardInputRef}
//                           accept="image/*"
//                           onChange={(e) =>
//                             handleFileUpload(e, setStudentIdCard, {
//                               isImageOnly: true,
//                               maxMB: MAX_MB,
//                               setPreview: setStudentIdPreview,
//                               setError: setIdErr,
//                             })
//                           }
//                           className="servitorsignup-hidden"
//                         />
//                       </div>
//                       {idErr && (
//                         <div className="servitorsignup-inline-error">
//                           {idErr}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* 4. Profile photo */}
//               <div className="servitorsignup-section">
//                 <h2 className="servitorsignup-section-title">
//                   {i18n.language === "bn"
//                     ? isTutor
//                       ? "৪."
//                       : "৩."
//                     : isTutor
//                     ? "4."
//                     : "3."}{" "}
//                   {t("servitor_signup.profile_photo")}
//                 </h2>

//                 <div className="servitorsignup-photo-section">
//                   <div className="servitorsignup-upload-container">
//                     <label className="servitorsignup-label">
//                       {t("servitor_signup.upload_recent_profile_photo")}{" "}
//                       <span className="required-asterisk">*</span>
//                     </label>

//                     <div
//                       className="servitorsignup-upload-area"
//                       onClick={() => photoInputRef.current.click()}
//                       onDragOver={handleDragOver}
//                       onDragLeave={handleDragLeave}
//                       onDrop={(e) =>
//                         handleDrop(e, setImage, {
//                           isImageOnly: true,
//                           maxMB: MAX_MB,
//                           setError: setPhotoErr,
//                         })
//                       }
//                     >
//                       {!image ? (
//                         <div className="servitorsignup-upload-content">
//                           <svg
//                             className="servitorsignup-upload-icon"
//                             fill="none"
//                             stroke="currentColor"
//                             viewBox="0 0 24 24"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth="2"
//                               d="M12 6v6m0 0v6m0-6h6m-6 0H6"
//                             />
//                           </svg>
//                           <p className="servitorsignup-upload-text">
//                             <span className="font-semibold">
//                               {t("servitor_signup.upload_photo")}
//                             </span>
//                           </p>
//                           <p className="servitorsignup-upload-subtext">
//                             {t("servitor_signup.recent_photo")}
//                           </p>
//                           <p className="servitorsignup-upload-note">
//                             {t("servitor_signup.jpg_png_max")}
//                           </p>
//                           {photoErr && (
//                             <div className="servitorsignup-inline-error">
//                               {photoErr}
//                             </div>
//                           )}
//                         </div>
//                       ) : (
//                         <div className="servitorsignup-uploaded-file">
//                           <p className="servitorsignup-file-name">
//                             {image.name}
//                           </p>
//                           <button
//                             type="button"
//                             className="servitorsignup-change-btn"
//                             onClick={(ev) => {
//                               ev.stopPropagation();
//                               setImage(null);
//                               setPreviewImage(null);
//                               photoInputRef.current.value = null;
//                             }}
//                           >
//                             {t("servitor_signup.change_photo")}
//                           </button>
//                         </div>
//                       )}
//                       <input
//                         type="file"
//                         ref={photoInputRef}
//                         accept="image/*"
//                         onChange={(e) =>
//                           handleFileUpload(e, setImage, {
//                             isImageOnly: true,
//                             maxMB: MAX_MB,
//                             setError: setPhotoErr,
//                           })
//                         }
//                         className="servitorsignup-hidden"
//                       />
//                     </div>
//                   </div>

//                   {previewImage && (
//                     <div className="servitorsignup-photo-preview">
//                       <img
//                         src={previewImage}
//                         alt="Preview"
//                         className="servitorsignup-preview-image"
//                       />
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {errMsg && (
//                 <div className="servitorsignup-error-message">{errMsg}</div>
//               )}

//               <div className="servitorsignup-form-note">
//                 {t("servitor_signup.note")}
//               </div>

//               <div className="servitorsignup-submit-container">
//                 <button
//                   type="submit"
//                   className="servitorsignup-submit-btn"
//                   disabled={sendingOtp}
//                 >
//                   {sendingOtp ? "Sending code..." : t("servitor_signup.submit")}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>

//       {/* NEW: OTP Modal */}
//       {showOtp && (
//         <div className="servitorsignupotp-overlay"
//         //  onClick={() => setShowOtp(false)}
//          >
//           <div className="servitorsignupotp-modal" onClick={(e) => e.stopPropagation()}>
//             {/* Header */}
//             <div className="servitorsignupotp-header">
//               <div className="servitorsignupotp-header-content">
//                 <div className="servitorsignupotp-icon-container">
//                   <div className="servitorsignupotp-icon-bg">
//                     <svg className="servitorsignupotp-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
//                     </svg>
//                   </div>
//                   <div className="servitorsignupotp-pulse-ring" />
//                 </div>
//                 <div>
//                   <h2 className="servitorsignupotp-title">Verify Your Phone</h2>
//                   <p className="servitorsignupotp-sub">Enter the 6-digit code sent to <strong>{mobile}</strong></p>
//                 </div>
//               </div>
//               <button className="servitorsignupotp-close" onClick={() => setShowOtp(false)}>
//                 <svg className="servitorsignupotp-close-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
//                 </svg>
//               </button>
//             </div>
//             {/* OTP Input Section */}
//             <div className="servitorsignupotp-body">
//               <div className="servitorsignupotp-input-section">
//                 <label className="servitorsignupotp-label">
//                   Verification Code
//                 </label>
//                 <div className="servitorsignupotp-inputs">
//                   {otpDigits.map((digit, index) => (
//                     <input
//                       key={index}
//                       type="text"
//                       inputMode="numeric"

//                       autoComplete={index === 0 ? "one-time-code" : undefined}
                      
//                       maxLength="1"
//                       className="servitorsignupotp-input"
//                       value={digit}
//                       onChange={(e) => handleOtpChange(e, index)}
//                       onKeyDown={(e) => handleOtpKeyDown(e, index)}
//                       onPaste={(e) => handleOtpPaste(e, index)}
//                       onFocus={(e) => e.target.select()}
//                       autoFocus={index === 0}
//                       data-index={index}
//                       disabled={verifyingOtp || sendingOtp}
//                     />
//                   ))}
//                 </div>
//               </div>
//               {otpErr && (
//                 <div className="servitorsignup-inline-error">{otpErr}</div>
//               )}
//               {/* Timer and Resend */}
//               <div className="servitorsignupotp-timer-section">
//                 <div className="servitorsignupotp-timer-content">
//                   <svg className="servitorsignupotp-timer-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
//                   </svg>
//                   <span className="servitorsignupotp-timer-text">
//                     {otpSeconds > 0 ? (
//                       <>Resend code in <span className="servitorsignupotp-timer-count">{otpSeconds}</span>s</>
//                     ) : (
//                       "Didn't receive the code?"
//                     )}
//                   </span>
//                 </div>
//                 {otpSeconds === 0 && (
//                   <button
//                     className="servitorsignupotp-resend"
//                     onClick={resendOtp}
//                     disabled={sendingOtp || verifyingOtp}
//                   >
//                     Resend Code
//                   </button>
//                 )}
//               </div>
//               {/* Action Buttons */}
//               <div className="servitorsignupotp-actions">
//                 <button
//                   className="servitorsignupotp-verify-btn"
//                   onClick={() => verifyOtp(otpDigits.join(""))}
//                   disabled={verifyingOtp || sendingOtp || !otpDigits.every((d) => d)}
//                 >
//                   {verifyingOtp ? "Verifying..." : "Verify Code"}
//                 </button>
//                 {/* Comment out cancel button */}
//                 {/* <button
//                   className="servitorsignupotp-cancel-btn"
//                   onClick={() => setShowOtp(false)}
//                 >
//                   Cancel
//                 </button> */}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* NEW: Success Modal */}
//       {showSuccess && (
//         <div className="servitorsignupotp-overlay" 
//           // onClick={() => setShowSuccess(false)}
//           >
//           <div className="servitorsignupotp-success-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="servitorsignupotp-success-icon-container">
//               <div className="servitorsignupotp-success-icon-bg">
//                 <svg className="servitorsignupotp-success-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
//                 </svg>
//               </div>
//             </div>
//             <h3 className="servitorsignupotp-success-title">Verification Successful!</h3>
//             <p className="servitorsignupotp-success-sub">Your registration is complete. Please login to continue.</p>
//             <p className="servitorsignupotp-success-timer">Redirecting to login in {successTimer} seconds...</p>
//             <button
//               className="servitorsignupotp-success-btn"
//               onClick={() => navigate("/login")}
//             >
//               Continue to Login
//             </button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ServitorSignup;







import React, { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Navbar from "../../Components/Navbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "./servitorsignupstyle.css";
import { URL as API_URL } from "../../config";

// const MAX_MB = 3;
const MAX_MB = 10;

// For save or store what user fillup form
  const DRAFT_KEY = "helpnao_servitor_signup_draft_v1";

  const safeJsonParse = (v) => {
    try { return JSON.parse(v); } catch { return null; }
  };

const ServitorSignup = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  // Core fields
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [nidPassport, setNidPassport] = useState("");
  const [dob, setDob] = useState("");
  const [selectedGender, setSelectedGender] = useState("");
  const [showPassword, setShowPassword] = useState(false);


  // CITY / AREA from DB
  const [divisions, setDivisions] = useState([]);      // [{Id, name, code}]
  const [areas, setAreas] = useState([]);              // [{Id, name}]
  const [selectedCity, setSelectedCity] = useState(""); // holds division Id as string
  const [area, setArea] = useState("");                 // holds area name (string)

  const [selectedService, setSelectedService] = useState("");
  const [address, setAddress] = useState("");
  const [experience, setExperience] = useState("");

  // Files
  const [image, setImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  // Tutor-only files
  const [resume, setResume] = useState(null);
  const [resumeUrl, setResumeUrl] = useState(null);
  const [studentIdCard, setStudentIdCard] = useState(null);
  const [studentIdPreview, setStudentIdPreview] = useState(null);

  // Upload errors
  const [photoErr, setPhotoErr] = useState("");
  const [resumeErr, setResumeErr] = useState("");
  const [idErr, setIdErr] = useState("");

  // Misc
  const [services, setServices] = useState([]);
  const [universityType, setUniversityType] = useState("");
  const [universityName, setUniversityName] = useState("");
  const [major, setMajor] = useState("");
  const [errMsg, setErrMsg] = useState("");

  // Refs
  const photoInputRef = useRef(null);
  const resumeInputRef = useRef(null);
  const idCardInputRef = useRef(null);

  // NEW: field refs for scrolling
  const firstNameRef = useRef(null);
  const lastNameRef = useRef(null);
  const mobileRef = useRef(null);
  const genderRef = useRef(null);
  const nidRef = useRef(null);
  const dobRef = useRef(null);
  const passwordRef = useRef(null);

  const serviceRef = useRef(null);
  const experienceRef = useRef(null);
  const cityRef = useRef(null);
  const areaRef = useRef(null);
  const addressRef = useRef(null);

  const photoBlockRef = useRef(null);

  // Tutor-only refs
  const universityTypeRef = useRef(null);
  const universityNameRef = useRef(null);
  const majorRef = useRef(null);
  const resumeBlockRef = useRef(null);
  const idCardBlockRef = useRef(null);

  const agreeRef = useRef(null);



  const isTutor = useMemo(
    () => (selectedService || "").toLowerCase().includes("tutor"),
    [selectedService]
  );

  // ================
  // NEW: OTP modal state
  // ================
  const [showOtp, setShowOtp] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [otpId, setOtpId] = useState(null);
  const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
  const [otpErr, setOtpErr] = useState("");
  const [otpSeconds, setOtpSeconds] = useState(60);
  const [successTimer, setSuccessTimer] = useState(5);
  const [sendingOtp, setSendingOtp] = useState(false);
  const [verifyingOtp, setVerifyingOtp] = useState(false);

  const [agree, setAgree] = useState(false);


  const isSubmitting = sendingOtp || verifyingOtp;


  // Keep a ready-to-send payload after OTP (so you don’t rebuild it twice)
  const pendingPayloadRef = useRef(null);

  // For save or store what user fillup form
  // Restore saved draft on first render
  useEffect(() => {
    const raw = localStorage.getItem(DRAFT_KEY);
    const draft = safeJsonParse(raw);
    if (!draft) return;

    // Core (safe) fields
    setFirstName(draft.firstName || "");
    setLastName(draft.lastName || "");
    setMobile(draft.mobile || "");
    setNidPassport(draft.nidPassport || "");
    setDob(draft.dob || "");
    setSelectedGender(draft.selectedGender || "");
    setSelectedService(draft.selectedService || "");
    setAddress(draft.address || "");
    setExperience(draft.experience || "");
    setAgree(!!draft.agree);

    // Tutor fields (safe text only)
    setUniversityType(draft.universityType || "");
    setUniversityName(draft.universityName || "");
    setMajor(draft.major || "");

    // City/Area
    if (draft.selectedCity) {
      setSelectedCity(String(draft.selectedCity));
      // load areas then restore selected area
      (async () => {
        await loadAreas(String(draft.selectedCity));
        setArea(draft.area || "");
      })();
    } else {
      setSelectedCity("");
      setAreas([]);
      setArea("");
    }

    // We DO NOT restore files
    setImage(null);
    setPreviewImage(null);
    setResume(null);
    if (resumeUrl) URL.revokeObjectURL(resumeUrl);
    setResumeUrl(null);
    setStudentIdCard(null);
    if (studentIdPreview) URL.revokeObjectURL(studentIdPreview);
    setStudentIdPreview(null);
    setPhotoErr("");
    setResumeErr("");
    setIdErr("");
    // eslint-disable-next-line
  }, []);

  //  Auto-save draft (debounced)
  useEffect(() => {
    const timer = setTimeout(() => {
      const draft = {
        // safe fields only
        firstName,
        lastName,
        mobile,
        nidPassport,
        dob,
        selectedGender,
        selectedService,
        experience,
        selectedCity,
        area,
        address,
        agree,

        // tutor safe fields
        universityType,
        universityName,
        major,
      };

      localStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
    }, 300); // debounce

    return () => clearTimeout(timer);
  }, [
    firstName,
    lastName,
    mobile,
    nidPassport,
    dob,
    selectedGender,
    selectedService,
    experience,
    selectedCity,
    area,
    address,
    agree,
    universityType,
    universityName,
    major,
  ]);



  // NEW: simple countdown for resend button
  useEffect(() => {
    if (!showOtp) return;
    const timer = setInterval(() => {
      setOtpSeconds((s) => (s > 0 ? s - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, [showOtp]);

  // NEW: success redirect timer
  useEffect(() => {
    if (!showSuccess) return;
    setSuccessTimer(5); // reset each time success modal is shown
    const interval = setInterval(() => {
      setSuccessTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          navigate("/login");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [showSuccess, navigate]);

  // Load services
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axios.get(`${API_URL}/services`);
        setServices(response.data);
      } catch (error) {
        console.error("Error fetching services:", error);
        setErrMsg(t("servitor_signup.error_messages.service_fetch_error") || "Error fetching services");
      }
    };
    fetchServices();
  }, [t]);

  // Load active divisions ("cities")
  useEffect(() => {
    const loadDivisions = async () => {
      try {
        const { data } = await axios.get(`${API_URL}/locations/divisions`);
        setDivisions(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error("Error loading divisions:", e);
        setDivisions([]);
      }
    };
    loadDivisions();
  }, []);

  // Load areas for a division
  const loadAreas = async (divisionId) => {
    if (!divisionId) {
      setAreas([]);
      return;
    }
    try {
      const { data } = await axios.get(`${API_URL}/locations/areas`, {
        params: { divisionId },
      });
      setAreas(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error("Error loading areas:", e);
      setAreas([]);
    }
  };

  useEffect(() => {
    if (!isTutor) {
      setUniversityType("");
      setUniversityName("");
      setMajor("");
      setStudentIdCard(null);
      setStudentIdPreview(null);
      setResume(null);
      if (resumeUrl) URL.revokeObjectURL(resumeUrl);
      setResumeUrl(null);
      setPhotoErr("");
      setResumeErr("");
      setIdErr("");
    }
  }, [isTutor]); // eslint-disable-line

  // cleanup object URLs
  useEffect(
    () => () => {
      if (resumeUrl) URL.revokeObjectURL(resumeUrl);
    },
    [resumeUrl]
  );
  useEffect(
    () => () => {
      if (studentIdPreview) URL.revokeObjectURL(studentIdPreview);
    },
    [studentIdPreview]
  );

  // Generic file handler
  const handleFileUpload = (e, setFile, optionsOrBoolean = false) => {
    const options =
      typeof optionsOrBoolean === "boolean"
        ? { isImageOnly: optionsOrBoolean }
        : optionsOrBoolean || {};
    const {
      isImageOnly = false,
      isPdfOnly = false,
      maxMB = MAX_MB,
      setPreview,
      setError,
    } = options;

    const file = e.target.files?.[0];
    if (!file) return;

    if (setError) setError("");

    if (isImageOnly && !file.type.startsWith("image/")) {
      setError && setError(t("servitor_signup.error_image_only") || "Please select only image file");
      return;
    }
    if (isPdfOnly && file.type !== "application/pdf") {
      setError && setError(t("servitor_signup.error_pdf_only") || "Please select a PDF file");
      return;
    }

    if (file.size > maxMB * 1024 * 1024) {
      // setError && setError(t("servitor_signup.error_file_too_large") || "File is too large. Max 3MB");
      setError && setError(
        t("servitor_signup.error_file_too_large", { maxMB }) ||
        `File is too large. Max ${maxMB}MB`
      );

      return;
    }

    setFile(file);

    if (setPreview) {
      const objectUrl = URL.createObjectURL(file);
      setPreview(objectUrl);
    }

    if (!setPreview && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (ev) => setPreviewImage(ev.target.result);
      reader.readAsDataURL(file);
    }
  };


    const scrollToField = (ref) => {
    if (!ref?.current) return;

    // Scroll the field into view (centered)
    ref.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });

    // Try to focus input/select/textarea inside
    if (typeof ref.current.focus === "function") {
      ref.current.focus();
    } else {
      const inner = ref.current.querySelector("input, select, textarea, button");
      inner?.focus();
    }
  };


  // ================
  // CHANGED: handleSubmit now starts OTP instead of creating immediately
  // ================
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   // Requireds
  //   if (
  //     !firstName ||
  //     !lastName ||
  //     !mobile ||
  //     !password ||
  //     !nidPassport ||
  //     !dob ||
  //     !selectedGender ||
  //     !selectedService ||
  //     !selectedCity ||
  //     !address ||
  //     !area ||
  //     !experience
  //   ) {
  //     setErrMsg(t("servitor_signup.error_messages.missing_fields") || "Please fill out all required fields");
  //     return;
  //   }

  //   if (!image) {
  //     setErrMsg(
  //       i18n.language === "bn"
  //         ? t("servitor_signup.profile_photo_required_bn") || "প্রোফাইল ছবি বাধ্যতামূলক"
  //         : t("servitor_signup.profile_photo_required") || "Profile photo is required"
  //     );
  //     return;
  //   }

  //   // BD number validation (must be 11 digits, start with 01[3-9])
  //   const mobileRegex = /^01[3-9]\d{8}$/;
  //   if (!mobileRegex.test(mobile)) {
  //     setErrMsg(t("servitor_signup.error_mobile") || "Enter valid mobile number (01XXXXXXXXX)");
  //     return;
  //   }

  //   if (isTutor) {
  //     if (
  //       !universityType ||
  //       !universityName.trim() ||
  //       !major.trim() ||
  //       !resume ||
  //       !studentIdCard
  //     ) {
  //       setErrMsg(t("servitor_signup.error_messages.missing_fields") || "Please fill out all required fields");
  //       return;
  //     }
  //   }

  //   // Store what we need to finish later
  //   const divisionObj = divisions.find((d) => String(d.Id) === String(selectedCity));
  //   const cityName = divisionObj?.name || "";

  //   pendingPayloadRef.current = {
  //     firstName,
  //     lastName,
  //     mobile,
  //     password,
  //     nidPassport,
  //     dob, // keep your existing dob string
  //     selectedGender,
  //     selectedService,
  //     cityName,
  //     address,
  //     area,
  //     experience,
  //     image,
  //     isTutor,
  //     universityType,
  //     universityName,
  //     major,
  //     resume,
  //     studentIdCard,
  //   };

  //   // Start OTP
  //   try {
  //     setSendingOtp(true);
  //     await axios.post(`${API_URL}/servitors/precheck`, {
  //       mobile,
  //       NID: nidPassport,
  //     });

  //     const { data } = await axios.post(`${API_URL}/otp/start`, {
  //       mobile
  //     });
  //     setOtpId(data.otpId);          // expect { otpId, expiresIn }
  //     setOtpDigits(["", "", "", "", "", ""]);
  //     setOtpErr("");
  //     setShowOtp(true);
  //     if (typeof data.expiresIn === "number") {
  //       setOtpSeconds(data.expiresIn);
  //     } else {
  //       setOtpSeconds(60);
  //     }
  //   } catch (error) {
  //     console.error("OTP start failed:", error);
  //     // const msg = error.response?.data?.error || t("servitor_signup.otp.failed_to_send") || "Failed to send verification code.";
  //     // setErrMsg(msg);
  //     const status = error.response?.status;
  //     const backendMsg = (error.response?.data?.error || "").toLowerCase();
  //     const body = error.response?.data;

  //     if (status === 429) {
  //       const wait = body?.retryAfter;
  //       setErrMsg(wait ? `Please wait ${wait}s before requesting another code.` : "Too many OTP requests. Try again later.");
  //       return;
  //     }
      

  //     if (status === 409 && backendMsg.includes("mobile")) {
  //       setErrMsg(t("servitor_signup.error_mobile_duplicate"));
  //     } else if (status === 409 && backendMsg.includes("nid")) {
  //       setErrMsg(t("servitor_signup.error_nid_max"));
  //     } else if (status === 400 && (backendMsg.includes("nid") || backendMsg.includes("national"))) {
  //       setErrMsg(t("servitor_signup.error_invalid_nid_format"));
  //     } else if (status === 400 && (backendMsg.includes("mobile") || backendMsg.includes("phone"))) {
  //       setErrMsg(t("servitor_signup.error_invalid_mobile_format"));
  //     } else {
  //       const msg =
  //         error.response?.data?.error ||
  //         t("servitor_signup.otp.failed_to_send") ||
  //         "Failed to send verification code.";
  //       setErrMsg(msg);
  //     }
  //   } finally {
  //     setSendingOtp(false);
  //   }
  // };




    const handleSubmit = async (e) => {
    e.preventDefault();

    const missingMsg =
      t("servitor_signup.error_messages.missing_fields") ||
      "Please fill out all required fields";

    // === Required field checks (scroll to first missing) ===
    if (!firstName.trim()) {
      setErrMsg(missingMsg);
      scrollToField(firstNameRef);
      return;
    }

    if (!lastName.trim()) {
      setErrMsg(missingMsg);
      scrollToField(lastNameRef);
      return;
    }

    if (!mobile.trim()) {
      setErrMsg(missingMsg);
      scrollToField(mobileRef);
      return;
    }

    if (!selectedGender) {
      setErrMsg(missingMsg);
      scrollToField(genderRef);
      return;
    }

    if (!nidPassport.trim()) {
      setErrMsg(missingMsg);
      scrollToField(nidRef);
      return;
    }

    if (!dob) {
      setErrMsg(missingMsg);
      scrollToField(dobRef);
      return;
    }

    if (!password) {
      setErrMsg(missingMsg);
      scrollToField(passwordRef);
      return;
    }

    if (!selectedService) {
      setErrMsg(missingMsg);
      scrollToField(serviceRef);
      return;
    }

    if (!experience) {
      setErrMsg(missingMsg);
      scrollToField(experienceRef);
      return;
    }

    if (!selectedCity) {
      setErrMsg(missingMsg);
      scrollToField(cityRef);
      return;
    }

    if (!area) {
      setErrMsg(missingMsg);
      scrollToField(areaRef);
      return;
    }

    if (!address.trim()) {
      setErrMsg(missingMsg);
      scrollToField(addressRef);
      return;
    }

    if (!agree) {
      setErrMsg(
        t("servitor_signup.error_agree") ||
          "Please read and agree to the Servitor Agreement."
      );
      scrollToField(agreeRef);   // scrolls to checkbox
      return;
    }

    if (!image) {
      setErrMsg(
        i18n.language === "bn"
          ? t("servitor_signup.profile_photo_required_bn") ||
            "প্রোফাইল ছবি বাধ্যতামূলক"
          : t("servitor_signup.profile_photo_required") ||
            "Profile photo is required"
      );
      scrollToField(photoBlockRef);
      return;
    }

    // === Extra validation: mobile format ===
    const mobileRegex = /^01[3-9]\d{8}$/;
    if (!mobileRegex.test(mobile)) {
      setErrMsg(
        t("servitor_signup.error_mobile") ||
          "Enter valid mobile number (01XXXXXXXXX)"
      );
      scrollToField(mobileRef);
      return;
    }

    // === Tutor-only validations ===
    if (isTutor) {
      if (!universityType) {
        setErrMsg(missingMsg);
        scrollToField(universityTypeRef);
        return;
      }
      if (!universityName.trim()) {
        setErrMsg(missingMsg);
        scrollToField(universityNameRef);
        return;
      }
      if (!major.trim()) {
        setErrMsg(missingMsg);
        scrollToField(majorRef);
        return;
      }
      if (!resume) {
        setErrMsg(missingMsg);
        scrollToField(resumeBlockRef);
        return;
      }
      if (!studentIdCard) {
        setErrMsg(missingMsg);
        scrollToField(idCardBlockRef);
        return;
      }
    }

    // === if we reach here -> all required fields OK ===

    const divisionObj = divisions.find(
      (d) => String(d.Id) === String(selectedCity)
    );
    const cityName = divisionObj?.name || "";

    pendingPayloadRef.current = {
      firstName,
      lastName,
      mobile,
      password,
      nidPassport,
      dob,
      selectedGender,
      selectedService,
      cityName,
      address,
      area,
      experience,
      image,
      isTutor,
      universityType,
      universityName,
      major,
      resume,
      studentIdCard,
      termsAccepted: true,
    };

    try {
      setSendingOtp(true);

      await axios.post(`${API_URL}/servitors/precheck`, {
        mobile,
        NID: nidPassport,
      });

      // const { data } = await axios.post(`${API_URL}/otp/start`, {
      //   mobile,
      // });

      const { data } = await axios.post(`${API_URL}/otp/start`, { mobile, purpose: "signup_servitor" });

      setOtpId(data.otpId);
      setOtpDigits(["", "", "", "", "", ""]);
      setOtpErr("");
      setShowOtp(true);
      setOtpSeconds(
        typeof data.expiresIn === "number" ? data.expiresIn : 60
      );
    } catch (error) {
      console.error("OTP start failed:", error);
      const status = error.response?.status;
      const backendMsg = (error.response?.data?.error || "").toLowerCase();
      const body = error.response?.data;

      if (status === 429) {
        const wait = body?.retryAfter;
        setErrMsg(
          wait
            ? `Please wait ${wait}s before requesting another code.`
            : "Too many OTP requests. Try again later."
        );
        return;
      }

      if (status === 409 && backendMsg.includes("mobile")) {
        setErrMsg(t("servitor_signup.error_mobile_duplicate"));
      } else if (status === 409 && backendMsg.includes("nid")) {
        setErrMsg(t("servitor_signup.error_nid_max"));
      } else if (
        status === 400 &&
        (backendMsg.includes("nid") || backendMsg.includes("national"))
      ) {
        setErrMsg(t("servitor_signup.error_invalid_nid_format"));
      } else if (
        status === 400 &&
        (backendMsg.includes("mobile") || backendMsg.includes("phone"))
      ) {
        setErrMsg(t("servitor_signup.error_invalid_mobile_format"));
      } else {
        const msg =
          error.response?.data?.error ||
          t("servitor_signup.otp.failed_to_send") ||
          "Failed to send verification code.";
        setErrMsg(msg);
      }
    } finally {
      setSendingOtp(false);
    }
  };



  // NEW: finalize signup after OTP verify
  const finishSignupAfterOtp = async () => {
    const p = pendingPayloadRef.current;
    if (!p) return;

    const formData = new FormData();
    formData.append("firstName", p.firstName);
    formData.append("lastName", p.lastName);
    formData.append("mobile", p.mobile);
    formData.append("password", p.password);
    formData.append("NID", p.nidPassport);
    formData.append("dob", p.dob);
    formData.append("gender", p.selectedGender);
    formData.append("service", p.selectedService);
    formData.append("city", p.cityName);
    formData.append("Address", p.address);
    formData.append("area", p.area);
    formData.append("experience", p.experience);
    formData.append("termsAccepted", p.termsAccepted ? "true" : "false");
    
    if (p.image) formData.append("image", p.image);

    if (p.isTutor) {
      formData.append("universityType", p.universityType.toLowerCase());
      formData.append("universityName", p.universityName.trim());
      formData.append("major", p.major.trim());
      if (p.resume) formData.append("resume", p.resume);
      if (p.studentIdCard) formData.append("studentIdCard", p.studentIdCard);
    }

    // IMPORTANT: prove mobile was verified
    if (otpId) formData.append("otpId", otpId);

    await axios.post(`${API_URL}/servitors`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  };

  // NEW: OTP change handler
  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 1); // force single digit
    const newDigits = [...otpDigits];
    newDigits[index] = value;
    setOtpDigits(newDigits);

    // move focus forward when a digit is entered
    if (value && index < 5) {
      const nextInput = document.querySelector(`input[data-index="${index + 1}"]`);
      nextInput?.focus();
    }

    // auto-verify when all 6 boxes are filled
    if (newDigits.every((d) => d.length === 1)) {
      verifyOtp(newDigits.join(""));
    }
  };

  // NEW: OTP keydown handler
  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newDigits = [...otpDigits];

      if (newDigits[index]) {
        // if current has a value, clear it
        newDigits[index] = "";
        setOtpDigits(newDigits);
      } else if (index > 0) {
        // if current empty, clear previous and focus it
        newDigits[index - 1] = "";
        setOtpDigits(newDigits);
        const prevInput = document.querySelector(`input[data-index="${index - 1}"]`);
        prevInput?.focus();
      }
    }
  };

  // NEW: OTP paste handler
  const handleOtpPaste = (e, index) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (!pasted) return;

    const newDigits = [...otpDigits];
    pasted.split("").forEach((char, i) => {
      if (index + i < 6) {
        newDigits[index + i] = char;
      }
    });
    setOtpDigits(newDigits);
    const lastFilled = index + pasted.length - 1;
    const focusIndex = Math.min(lastFilled, 5);
    const focusInput = document.querySelector(`input[data-index="${focusIndex}"]`);
    focusInput?.focus();
    if (newDigits.every((d) => d)) {
      verifyOtp(newDigits.join(""));
    }
  };

  // NEW: verify OTP
  const verifyOtp = async (code) => {
    if (code.length !== 6) {
      setOtpErr(t("servitor_signup.otp.error_enter_code") || "Enter the 6-digit code.");
      return;
    }

    setVerifyingOtp(true);
    try {
      // 1) Verify OTP first
      // await axios.post(`${API_URL}/otp/verify`, { otpId, code });
      await axios.post(`${API_URL}/otp/verify`, { otpId, code, purpose: "signup_servitor" });
    } catch (err) {
      console.error("OTP verify failed:", err);
      const msg = err.response?.data?.error || t("servitor_signup.otp.error_invalid") || "Invalid or expired code.";
      setOtpErr(msg);
      setOtpDigits(["", "", "", "", "", ""]);
      setTimeout(() => {
        const first = document.querySelector('input[data-index="0"]');
        first?.focus();
      }, 0);
      return; // stop here—don't try to finish signup
    } finally {
      setVerifyingOtp(false);
    }

    // 2) OTP ok — now finish signup
    try {
      setVerifyingOtp(true);
      await finishSignupAfterOtp();
      localStorage.removeItem(DRAFT_KEY);
      setShowOtp(false);
      setShowSuccess(true);
    } catch (err) {
      console.error("Signup finalize failed:", err);
      // const msg = err.response?.data?.error || t("servitor_signup.error_messages.internal_server_error") || "Registration failed. Please try again.";
      // setOtpErr(msg);

      const status = err.response?.status;
      const backendMsg = err.response?.data?.error || "";

      if (status === 409 && /mobile/i.test(backendMsg)) {
        // Mobile already registered
        setOtpErr(t("servitor_signup.error_mobile_duplicate"));
      } else if (status === 409 && /nid/i.test(backendMsg)) {
        // NID used 2 times already
        setOtpErr(t("servitor_signup.error_nid_max"));
      } else {
        setOtpErr(
          backendMsg ||
          (t("servitor_signup.error_messages.internal_server_error") ||
            "Registration failed. Please try again.")
        );
      }
      // keep digits so user can retry without retyping the OTP
    } finally {
      setVerifyingOtp(false);
    }
  };

  // NEW: resend OTP
  const resendOtp = async () => {
    if (otpSeconds > 0) return;
    try {
      setSendingOtp(true);
      // const { data } = await axios.post(`${API_URL}/otp/start`, { mobile });
      const { data } = await axios.post(`${API_URL}/otp/start`, {
        mobile,
        purpose: "signup_servitor",
      });

      setOtpId(data.otpId);
      setOtpDigits(["", "", "", "", "", ""]);
      setOtpErr("");
      setOtpSeconds(typeof data.expiresIn === "number" ? data.expiresIn : 60);

      // NEW: focus first input right away
      setTimeout(() => {
        const first = document.querySelector('input[data-index="0"]');
        first?.focus();
      }, 0);
    } catch (err) {
      console.error("Resend OTP failed:", err);
      setOtpErr(t("servitor_signup.otp.failed_to_resend") || "Failed to resend code.");
    } finally {
      setSendingOtp(false);
    }
  };

  const getServiceKey = (serviceName) =>
    serviceName.trim().toLowerCase().replace(/\s+/g, "_");

  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.classList.add("servitorsignup-dragover");
  };
  const handleDragLeave = (e) =>
    e.currentTarget.classList.remove("servitorsignup-dragover");
  const handleDrop = (e, setFile, optionsOrBoolean = false) => {
    e.preventDefault();
    e.currentTarget.classList.remove("servitorsignup-dragover");
    if (e.dataTransfer.files.length > 0) {
      handleFileUpload(
        { target: { files: e.dataTransfer.files } },
        setFile,
        optionsOrBoolean
      );
    }
  };



  // ---- Local DOB Picker (no imports/exports) ----
const DOB_MONTH_FULL = [
  "January","February","March","April","May","June",
  "July","August","September","October","November","December"
];
const DOB_MONTH_SHORT = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const dobPad2 = (n) => String(n).padStart(2, "0");
function dobParseYMD(ymd) {
  if (!ymd) return null;
  const m = String(ymd).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return null;
  return { y: +m[1], m: +m[2], d: +m[3] };
}
function dobDaysInMonth(y, m) { return new Date(y, m, 0).getDate(); }
function dobFirstDow(y, m) { return new Date(y, m - 1, 1).getDay(); }
function dobPretty(ymd) {
  const p = dobParseYMD(ymd);
  return p ? `${p.d}-${DOB_MONTH_SHORT[p.m - 1]}-${p.y}` : "";
}

function DOBPicker({
  value,                 // "YYYY-MM-DD" or ""
  onChange,              // (ymd) => void
  placeholder = "Select date of birth",
  minYear = 1940,
  maxYear = new Date().getFullYear(),
}) {
  const today = new Date();
  const parsed = dobParseYMD(value);
  const [open, setOpen] = React.useState(false);
  const [viewY, setViewY] = React.useState(parsed?.y ?? 1995);
  const [viewM, setViewM] = React.useState(parsed?.m ?? 1);
  const ref = React.useRef(null);

  React.useEffect(() => {
    const onDocClick = (e) => {
      if (!ref.current) return;
      if (!ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  // grid
  const dim = dobDaysInMonth(viewY, viewM);
  const start = dobFirstDow(viewY, viewM);
  const cells = [];
  for (let i = 0; i < start; i++) cells.push(null);
  for (let d = 1; d <= dim; d++) cells.push(d);

  const selected = dobParseYMD(value);
  const label = value ? dobPretty(value) : placeholder;

  const goPrevMonth = () => {
    let y = viewY, m = viewM - 1;
    if (m === 0) { m = 12; y--; }
    setViewY(y); setViewM(m);
  };
  const goNextMonth = () => {
    let y = viewY, m = viewM + 1;
    if (m === 13) { m = 1; y++; }
    setViewY(y); setViewM(m);
  };

  const years = [];
  for (let y = maxYear; y >= minYear; y--) years.push(y);

  return (
    <div className="dob-picker" ref={ref}>
      <button
        type="button"
        className="servitorsignup-input dob-trigger"
        onClick={() => setOpen(v => !v)}
        aria-haspopup="dialog"
        aria-expanded={open}
      >
        {label}
      </button>

      {open && (
        <div className="dob-popover" role="dialog" aria-label="Select date of birth">
          <div className="dob-header">
            <button type="button" className="dob-nav" onClick={goPrevMonth} aria-label="Previous month">‹</button>

            <div className="dob-selects">
              <select
                className="dob-select"
                value={viewM}
                onChange={(e) => setViewM(Number(e.target.value))}
                aria-label="Select month"
              >
                {DOB_MONTH_FULL.map((m, i) => (
                  <option key={m} value={i + 1}>{m}</option>
                ))}
              </select>

              <select
                className="dob-select"
                value={viewY}
                onChange={(e) => setViewY(Number(e.target.value))}
                aria-label="Select year"
              >
                {years.map((y) => <option key={y} value={y}>{y}</option>)}
              </select>
            </div>

            <button type="button" className="dob-nav" onClick={goNextMonth} aria-label="Next month">›</button>
          </div>

          <div className="dob-weekdays">
            {["Su","Mo","Tu","We","Th","Fr","Sa"].map((d) => (
              <div key={d} className="dob-wd">{d}</div>
            ))}
          </div>

          <div className="dob-grid">
            {cells.map((d, i) => {
              const isBlank = d === null;
              const isActive = !!selected && selected.y === viewY && selected.m === viewM && selected.d === d;
              const isToday =
                viewY === today.getFullYear() &&
                viewM === today.getMonth() + 1 &&
                d === today.getDate();

              return isBlank ? (
                <div key={`b-${i}`} className="dob-cell is-blank" />
              ) : (
                <button
                  key={d}
                  type="button"
                  className={`dob-cell${isActive ? " is-active" : ""}${isToday ? " is-today" : ""}`}
                  onClick={() => {
                    const ymd = `${viewY}-${dobPad2(viewM)}-${dobPad2(d)}`;
                    onChange?.(ymd);
                    setOpen(false);
                  }}
                >
                  {d}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}


  return (
    <>
      <Navbar />
      <div className="servitorsignup-container">
        <div className="servitorsignup-content">
          <div className="servitorsignup-header">
            <h1 className="servitorsignup-title">
              {t("servitor_signup.header") || "Service Provider Registration"}
            </h1>
            <div className="servitorsignup-underline"></div>
          </div>

          <div className="servitorsignup-card">
            <form className="servitorsignup-form" onSubmit={handleSubmit}>
              {/* 1. Personal */}
              <div className="servitorsignup-section">
                <h2 className="servitorsignup-section-title">
                  {i18n.language === "bn" ? "১." : "1."}{" "}
                  {t("servitor_signup.personal_info") || "Personal Information"}
                </h2>

                <div className="servitorsignup-personal-grid">
                  <div className="servitorsignup-field">
                    <label className="servitorsignup-label">
                      {t("servitor_signup.first_name") || "First Name"}{" "}
                      <span className="required-asterisk">*</span>
                    </label>
                    <input
                      ref={firstNameRef}
                      type="text"
                      placeholder={t("servitor_signup.first_name") || "First Name"}
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      required
                      className="servitorsignup-input"
                    />
                  </div>

                  <div className="servitorsignup-field">
                    <label className="servitorsignup-label">
                      {t("servitor_signup.last_name") || "Last Name"}{" "}
                      <span className="required-asterisk">*</span>
                    </label>
                    <input
                      ref={lastNameRef}
                      type="text"
                      placeholder={t("servitor_signup.last_name") || "Last Name"}
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      required
                      className="servitorsignup-input"
                    />
                  </div>

                  <div className="servitorsignup-field">
                    <label className="servitorsignup-label">
                      {t("servitor_signup.mobile") || "Mobile Number"}{" "}
                      <span className="required-asterisk">*</span>
                    </label>
                    <input
                      ref={mobileRef}
                      type="tel"
                      inputMode="numeric"
                      autoComplete="tel"          // add
                      pattern="[0-9]{11}"         
                      // pattern="\d{11}"
                      maxLength={11}
                      placeholder={t("servitor_signup.mobile_ph") || "01XXXXXXXXX"}
                      value={mobile}
                      onChange={(e) =>
                        setMobile(e.target.value.replace(/\D/g, "").slice(0, 11))
                      }
                      required
                      className="servitorsignup-input"
                    />
                  </div>

                  <div className="servitorsignup-field">
                    <label className="servitorsignup-label">
                      {t("servitor_signup.gender.label") || "Gender"}{" "}
                      <span className="required-asterisk">*</span>
                    </label>
                    <select
                      ref={genderRef}
                      value={selectedGender}
                      onChange={(e) => setSelectedGender(e.target.value)}
                      required
                      className="servitorsignup-input"
                    >
                      <option value="">
                        {t("servitor_signup.select_gender") || "Select gender"}
                      </option>
                      <option value="male">
                        {t("servitor_signup.gender.male") || "Male"}
                      </option>
                      <option value="female">
                        {t("servitor_signup.gender.female") || "Female"}
                      </option>
                    </select>
                  </div>

                  <div className="servitorsignup-field">
                    <label className="servitorsignup-label">
                      {t("servitor_signup.nid_passport") || "NID/Passport"}{" "}
                      <span className="required-asterisk">*</span>
                    </label>
                    <input
                      ref={nidRef}
                      type="text"
                      placeholder={t("servitor_signup.nid_ph") || "10 or 13-digit NID"}
                      value={nidPassport}
                      onChange={(e) => setNidPassport(e.target.value)}
                      required
                      className="servitorsignup-input"
                    />
                  </div>

                  {/* <div className="servitorsignup-field">
                    <label className="servitorsignup-label">
                      {t("servitor_signup.dob") || "Date of Birth"}{" "}
                      <span className="required-asterisk">*</span>
                    </label>
                    <input
                      type="date"
                      value={dob}
                      onChange={(e) => setDob(e.target.value)}
                      required
                      className="servitorsignup-input"
                    />
                  </div> */}


                  <div className="servitorsignup-field" ref={dobRef}>
  <label className="servitorsignup-label">
    {t("servitor_signup.dob") || "Date of Birth"}{" "}
    <span className="required-asterisk">*</span>
  </label>

  <DOBPicker
    value={dob}
    onChange={(ymd) => setDob(ymd)}
    placeholder={t("servitor_signup.dob_ph") || "Select date of birth"}
    minYear={1940}
    maxYear={new Date().getFullYear()}
  />
</div>


                  <div className="servitorsignup-field servitorsignup-full-width">
                    <label className="servitorsignup-label">
                      {t("servitor_signup.password") || "Password"}{" "}
                      <span className="required-asterisk">*</span>
                    </label>
                    <div className="servitorsignup-password-wrap">
                    <input
                      ref={passwordRef}
                      // type="password"
                      type={showPassword ? "text" : "password"}
                      placeholder={t("servitor_signup.password_ph") || "Set Password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      className="servitorsignup-input"
                      autoComplete="new-password"
                    />
                    <button
                        type="button"
                        className="servitorsignup-password-toggle-btn"
                        onClick={() => setShowPassword((s) => !s)}
                        disabled={isSubmitting || showOtp}   // disables while OTP flow
                        aria-label={showPassword ? "Hide password" : "Show password"}
                        aria-pressed={showPassword}
                      >
                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* 2. Service */}
              <div className="servitorsignup-section">
                <h2 className="servitorsignup-section-title">
                  {i18n.language === "bn" ? "২." : "2."}{" "}
                  {t("servitor_signup.service_info") || "Service Information"}
                </h2>

                <div className="servitorsignup-grid">
                  <div className="servitorsignup-field">
                    <label className="servitorsignup-label">
                      {t("servitor_signup.service") || "Service"}{" "}
                      <span className="required-asterisk">*</span>
                    </label>
                    <select
                      ref={serviceRef}
                      value={selectedService}
                      onChange={(e) => setSelectedService(e.target.value)}
                      required
                      className="servitorsignup-input"
                    >
                      <option value="">
                        {t("servitor_signup.select_service") || "Select service"}
                      </option>
                      {services.map((service) => {
                        const serviceKey = getServiceKey(service.services_name);
                        const translatedName =
                          i18n.language === "bn"
                            ? t(`home.services.${serviceKey}.name`, {
                                defaultValue: service.services_name,
                              })
                            : service.services_name;
                        return (
                          <option
                            key={service.Id}
                            value={service.services_name}
                          >
                            {translatedName}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="servitorsignup-field">
                    <label className="servitorsignup-label">
                      {t("servitor_signup.experience") || "Experience"}{" "}
                      <span className="required-asterisk">*</span>
                    </label>
                    <input
                      ref={experienceRef}
                      type="number"
                      placeholder={t("servitor_signup.experience_ph") || "Years"}
                      value={experience}
                      onChange={(e) => setExperience(e.target.value)}
                      min="0"
                      required
                      className="servitorsignup-input"
                    />
                  </div>

                  {/* CITY */}
                  <div className="servitorsignup-field">
                    <label className="servitorsignup-label">
                      {t("servitor_signup.city") || "City"}{" "}
                      <span className="required-asterisk">*</span>
                    </label>
                    <select
                      ref={cityRef}
                      value={selectedCity}
                      onChange={async (e) => {
                        const id = e.target.value;
                        setSelectedCity(id);
                        setArea("");
                        setAreas([]);
                        await loadAreas(id);
                      }}
                      required
                      className="servitorsignup-input"
                    >
                      <option value="">
                        {t("servitor_signup.select_city") || "Select city"}
                      </option>
                      {divisions.map((d) => (
                        <option key={d.Id} value={String(d.Id)}>
                          {d.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* AREA */}
                  <div className="servitorsignup-field">
                    <label className="servitorsignup-label">
                      {t("servitor_signup.area") || "Area"}{" "}
                      <span className="required-asterisk">*</span>
                    </label>
                    <select
                      ref={areaRef}
                      value={area}
                      onChange={(e) => setArea(e.target.value)}
                      required
                      className="servitorsignup-input"
                      disabled={!selectedCity || areas.length === 0}
                    >
                      <option value="">
                        {t("servitor_signup.select_area") || "Select area"}
                      </option>
                      {areas.map((a) => (
                        <option key={a.Id} value={a.name}>
                          {a.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="servitorsignup-field">
                    <label className="servitorsignup-label">
                      {t("servitor_signup.address") || "Address"}{" "}
                      <span className="required-asterisk">*</span>
                    </label>
                    <input
                      ref={addressRef}
                      type="text"
                      placeholder={t("servitor_signup.address_ph") || "e.g., Dhanmondi, Gulshan"}
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      required
                      className="servitorsignup-input"
                    />
                  </div>
                </div>
              </div>

              {/* 3. Tutor info */}
              {isTutor && (
                <div className="servitorsignup-section">
                  <h2 className="servitorsignup-section-title">
                    {i18n.language === "bn" ? "৩." : "3."}{" "}
                    {t("tutorservice.tutor_info") || "Tutor Information"}
                  </h2>

                  <div className="servitorsignup-grid">
                    <div className="servitorsignup-field">
                      <label className="servitorsignup-label">
                        {t("tutorservice.university_type") || "University Type"}{" "}
                        <span className="required-asterisk">*</span>
                      </label>
                      <select
                        ref={universityTypeRef}
                        value={universityType}
                        onChange={(e) => setUniversityType(e.target.value)}
                        required
                        className="servitorsignup-input"
                      >
                        <option value="">
                          {t("tutorservice.select_university_type") || "Select university type"}
                        </option>
                        <option value="buet">BUET</option>
                        <option value="medical">
                          {t("tutorservice.medical") || "Medical"}
                        </option>
                        <option value="quran">
                          {t("tutorservice.madrasa") || "Quran/Islamic Education"}
                        </option>
                        <option value="du">{t("tutorservice.du") || "Dhaka University"}</option>
                        <option value="public">
                          {t("tutorservice.public_university") || "Public University"}
                        </option>
                        <option value="private">
                          {t("tutorservice.private_university") || "Private University"}
                        </option>
                        <option value="other">{t("tutorservice.other") || "Other"}</option>
                      </select>
                    </div>

                    <div className="servitorsignup-field">
                      <label className="servitorsignup-label">
                        {t("tutorservice.university_name") || "University Name"}{" "}
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        ref={universityNameRef}
                        type="text"
                        placeholder={t("tutorservice.university_name_ph") || "e.g., BUET / DU / AUST / NSU"}
                        value={universityName}
                        onChange={(e) => setUniversityName(e.target.value)}
                        required
                        className="servitorsignup-input"
                      />
                    </div>

                    <div className="servitorsignup-field">
                      <label className="servitorsignup-label">
                        {t("tutorservice.major") || "Major / Department"}{" "}
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        ref={majorRef}
                        type="text"
                        placeholder={t("tutorservice.major_ph") || "e.g., CSE / EEE / BBA"}
                        value={major}
                        onChange={(e) => setMajor(e.target.value)}
                        required
                        className="servitorsignup-input"
                      />
                    </div>
                  </div>

                  {/* Tutor docs */}
                  <h3
                    className="servitorsignup-section-title"
                    style={{ marginTop: "1rem" }}
                  >
                    {t("tutorservice.student_docs") || "Student Documents"}
                  </h3>

                  <div className="servitorsignup-grid">
                    {/* Resume (PDF -> certificate) */}
                    <div className="servitorsignup-field" ref={resumeBlockRef}>
                      <label className="servitorsignup-label">
                        {t("tutorservice.upload_resume") || "Upload Resume (PDF)"}{" "}
                        <span className="required-asterisk">*</span>
                      </label>
                      <div
                        className="servitorsignup-upload-area"
                        onClick={() => resumeInputRef.current?.click()}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={(e) =>
                          handleDrop(e, setResume, {
                            isPdfOnly: true,
                            maxMB: MAX_MB,
                            setPreview: setResumeUrl,
                            setError: setResumeErr,
                          })
                        }
                      >
                        {!resume ? (
                          <div className="servitorsignup-upload-content">
                            <svg
                              className="servitorsignup-upload-icon"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                              />
                            </svg>
                            <p className="servitorsignup-upload-text">
                              <span className="font-semibold">
                                {t("tutorservice.upload_resume") || "Upload Resume"}
                              </span>
                            </p>
                            <p className="servitorsignup-upload-note">
                              {t("tutorservice.pdf_max", { maxMB: MAX_MB }) || `PDF (max ${MAX_MB}MB)`}
                            </p>
                            {resumeErr && (
                              <div className="servitorsignup-inline-error">
                                {resumeErr}
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="servitorsignup-uploaded-file">
                            <p className="servitorsignup-file-name">
                              {resume.name}
                            </p>
                            <div className="servitorsignup-doc-actions">
                              <button
                                type="button"
                                className="servitorsignup-preview-btn"
                                onClick={(ev) => {
                                  ev.stopPropagation();
                                  if (resumeUrl)
                                    window.open(resumeUrl, "_blank");
                                }}
                              >
                                {t("tutorservice.preview") || "Preview"}
                              </button>
                              <button
                                type="button"
                                className="servitorsignup-change-btn"
                                onClick={(ev) => {
                                  ev.stopPropagation();
                                  setResume(null);
                                  if (resumeUrl) URL.revokeObjectURL(resumeUrl);
                                  setResumeUrl(null);
                                  if (resumeInputRef.current)
                                    resumeInputRef.current.value = null;
                                }}
                              >
                                {t("tutorservice.change_file") || "Change file"}
                              </button>
                            </div>
                          </div>
                        )}
                        <input
                          type="file"
                          ref={resumeInputRef}
                          accept="application/pdf"
                          onChange={(e) =>
                            handleFileUpload(e, setResume, {
                              isPdfOnly: true,
                              maxMB: MAX_MB,
                              setPreview: setResumeUrl,
                              setError: setResumeErr,
                            })
                          }
                          className="servitorsignup-hidden"
                        />
                      </div>
                      {resumeErr && (
                        <div className="servitorsignup-inline-error">
                          {resumeErr}
                        </div>
                      )}
                    </div>

                    {/* Student ID Card (image) */}
                    <div className="servitorsignup-field" ref={idCardBlockRef}>
                      <label className="servitorsignup-label">
                        {t("tutorservice.student_id_card") || "Student ID Card"}{" "}
                        <span className="required-asterisk">*</span>
                      </label>
                      <div
                        className="servitorsignup-upload-area"
                        onClick={() => idCardInputRef.current?.click()}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={(e) =>
                          handleDrop(e, setStudentIdCard, {
                            isImageOnly: true,
                            maxMB: MAX_MB,
                            setPreview: setStudentIdPreview,
                            setError: setIdErr,
                          })
                        }
                      >
                        {!studentIdCard ? (
                          <div className="servitorsignup-upload-content">
                            <svg
                              className="servitorsignup-upload-icon"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                              />
                            </svg>
                            <p className="servitorsignup-upload-text">
                              <span className="font-semibold">
                                {t("tutorservice.upload_id_card") || "Upload Student ID Card"}
                              </span>
                            </p>
                            <p className="servitorsignup-upload-note">
                              {t("servitor_signup.jpg_png_max") || "JPG, PNG (max 3MB)"}
                            </p>
                            {idErr && (
                              <div className="servitorsignup-inline-error">
                                {idErr}
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="servitorsignup-uploaded-file">
                            <p className="servitorsignup-file-name">
                              {studentIdCard.name}
                            </p>
                            <div className="servitorsignup-doc-actions">
                              <button
                                type="button"
                                className="servitorsignup-preview-btn"
                                onClick={(ev) => {
                                  ev.stopPropagation();
                                  if (studentIdPreview)
                                    window.open(studentIdPreview, "_blank");
                                }}
                              >
                                {t("tutorservice.preview") || "Preview"}
                              </button>
                              <button
                                type="button"
                                className="servitorsignup-change-btn"
                                onClick={(ev) => {
                                  ev.stopPropagation();
                                  setStudentIdCard(null);
                                  if (studentIdPreview)
                                    URL.revokeObjectURL(studentIdPreview);
                                  setStudentIdPreview(null);
                                  if (idCardInputRef.current)
                                    idCardInputRef.current.value = null;
                                }}
                              >
                                {t("tutorservice.change_file") || "Change file"}
                              </button>
                            </div>
                          </div>
                        )}
                        <input
                          type="file"
                          ref={idCardInputRef}
                          accept="image/*"
                          onChange={(e) =>
                            handleFileUpload(e, setStudentIdCard, {
                              isImageOnly: true,
                              maxMB: MAX_MB,
                              setPreview: setStudentIdPreview,
                              setError: setIdErr,
                            })
                          }
                          className="servitorsignup-hidden"
                        />
                      </div>
                      {idErr && (
                        <div className="servitorsignup-inline-error">
                          {idErr}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* 4. Profile photo */}
              <div className="servitorsignup-section" ref={photoBlockRef}>
                <h2 className="servitorsignup-section-title">
                  {i18n.language === "bn"
                    ? isTutor
                      ? "৪."
                      : "৩."
                    : isTutor
                    ? "4."
                    : "3."}{" "}
                  {t("servitor_signup.profile_photo") || "Profile Photo"}
                </h2>

                <div className="servitorsignup-photo-section">
                  <div className="servitorsignup-upload-container">
                    <label className="servitorsignup-label">
                      {t("servitor_signup.upload_recent_profile_photo") || "Upload Recent Profile Photo"}{" "}
                      <span className="required-asterisk">*</span>
                    </label>

                    <div
                      className="servitorsignup-upload-area"
                      onClick={() => photoInputRef.current.click()}
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={(e) =>
                        handleDrop(e, setImage, {
                          isImageOnly: true,
                          maxMB: MAX_MB,
                          setError: setPhotoErr,
                        })
                      }
                    >
                      {!image ? (
                        <div className="servitorsignup-upload-content">
                          <svg
                            className="servitorsignup-upload-icon"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                            />
                          </svg>
                          <p className="servitorsignup-upload-text">
                            <span className="font-semibold">
                              {t("servitor_signup.upload_photo") || "Upload Photo"}
                            </span>
                          </p>
                          <p className="servitorsignup-upload-subtext">
                            {t("servitor_signup.recent_photo") || "Recent photo where face is clearly visible"}
                          </p>
                          <p className="servitorsignup-upload-note">
                            {t("servitor_signup.jpg_png_max") || "JPG, PNG (max 3MB)"}
                          </p>
                          {photoErr && (
                            <div className="servitorsignup-inline-error">
                              {photoErr}
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="servitorsignup-uploaded-file">
                          <p className="servitorsignup-file-name">
                            {image.name}
                          </p>
                          <button
                            type="button"
                            className="servitorsignup-change-btn"
                            onClick={(ev) => {
                              ev.stopPropagation();
                              setImage(null);
                              setPreviewImage(null);
                              photoInputRef.current.value = null;
                            }}
                          >
                            {t("servitor_signup.change_photo") || "Change Photo"}
                          </button>
                        </div>
                      )}
                      <input
                        type="file"
                        ref={photoInputRef}
                        accept="image/*"
                        onChange={(e) =>
                          handleFileUpload(e, setImage, {
                            isImageOnly: true,
                            maxMB: MAX_MB,
                            setError: setPhotoErr,
                          })
                        }
                        className="servitorsignup-hidden"
                      />
                    </div>
                  </div>

                  {previewImage && (
                    <div className="servitorsignup-photo-preview">
                      <img
                        src={previewImage}
                        alt="Preview"
                        className="servitorsignup-preview-image"
                      />
                    </div>
                  )}
                </div>
              </div>

              {errMsg && (
                <div className="servitorsignup-error-message">{errMsg}</div>
              )}

              {/* <div className="servitorsignup-form-note">
                {t("servitor_signup.note") || "Note: Your registration will be reviewed by admin"}
              </div> */}


              {/* Agreement Checkbox */}
              <div className="servitorsignup-agreement-row" ref={agreeRef}>
                <label className="servitorsignup-agreement-label">
                  <input
                    type="checkbox"
                    checked={agree}
                    onChange={() => setAgree(!agree)}
                    className="servitorsignup-agreement-checkbox"
                  />
                  <span className="servitorsignup-agreement-text">
                    {t("servitor_signup.agree_text_prefix") || "I have read and agree to the"}&nbsp;
                    <Link
                      to="/servitor-agreement"
                      className="servitorsignup-agreement-link"
                      // target="_blank"
                    >
                      {t("servitor_signup.agreement_link") || "HelpNao Servitor Agreement"}
                    </Link>
                  </span>
                </label>
              </div>



              <div className="servitorsignup-submit-container">
                <button
                  type="submit"
                  // className="servitorsignup-submit-btn"
                  className={`servitorsignup-submit-btn ${isSubmitting ? "is-loading" : ""}`}
                  // disabled={sendingOtp}
                  disabled={ isSubmitting  || sendingOtp || verifyingOtp || showOtp }
                  aria-busy={isSubmitting}
                  aria-live="polite"
                >
                  {/* {sendingOtp ? (t("servitor_signup.sending_code") || "Sending code...") : t("servitor_signup.submit") || "Complete Registration"} */}
                  {isSubmitting && (
                      <span className="servitorsignupbtn-spinner" aria-hidden="true" />
                    )}
                    <span className="servitorsignupbtn-text">
                      {isSubmitting
                        ? (t("servitor_signup.sending_code") || "Sending code...")
                        : (t("servitor_signup.submit") || "Complete Registration")}
                    </span>

                </button>

                 {/* Legal line under the button */}
                  <p className="servitorsignup-legal-note">
                    {t("signup.legal.prefix") || "By signing up, you agree to our"}{" "}
                    <strong>
                      {/* <a
                        href="/legal/terms-and-privacy"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="legal-link"
                      >
                        {t("signup.legal.link") || "Terms & Privacy Policy"}
                      </a> */}
                      <Link to="/legal/terms-and-privacy" className="legal-link">
                        {t("signup.legal.link") || "Terms & Privacy Policy"}
                      </Link>
                    </strong>
                    .
                  </p>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* NEW: OTP Modal */}
      {showOtp && (
        <div className="servitorsignupotp-overlay">
          <div className="servitorsignupotp-modal" onClick={(e) => e.stopPropagation()}>
            {/* Header */}
            <div className="servitorsignupotp-header">
              <div className="servitorsignupotp-header-content">
                <div className="servitorsignupotp-icon-container">
                  <div className="servitorsignupotp-icon-bg">
                    <svg className="servitorsignupotp-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                  </div>
                  <div className="servitorsignupotp-pulse-ring" />
                </div>
                <div>
                  <h2 className="servitorsignupotp-title">{t("servitor_signup.otp.title") || "Verify Your Phone"}</h2>
                  <p className="servitorsignupotp-sub">
                    {t("servitor_signup.otp.sub", { mobile }) || `Enter the 6-digit code sent to ${mobile}`}
                  </p>
                </div>
              </div>
              <button className="servitorsignupotp-close" onClick={() => setShowOtp(false)}>
                <svg className="servitorsignupotp-close-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            {/* OTP Input Section */}
            <div className="servitorsignupotp-body">
              <div className="servitorsignupotp-input-section">
                <label className="servitorsignupotp-label">
                  {t("servitor_signup.otp.label") || "Verification Code"}
                </label>
                <div className="servitorsignupotp-inputs">
                  {otpDigits.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      inputMode="numeric"

                      autoComplete={index === 0 ? "one-time-code" : undefined}

                      maxLength="1"
                      className="servitorsignupotp-input"
                      value={digit}
                      onChange={(e) => handleOtpChange(e, index)}
                      onKeyDown={(e) => handleOtpKeyDown(e, index)}
                      onPaste={(e) => handleOtpPaste(e, index)}
                      onFocus={(e) => e.target.select()}
                      autoFocus={index === 0}
                      data-index={index}
                      disabled={verifyingOtp || sendingOtp}
                    />
                  ))}
                </div>
              </div>
              {otpErr && (
                <div className="servitorsignup-inline-error">{otpErr}</div>
              )}
              {/* Timer and Resend */}
              <div className="servitorsignupotp-timer-section">
                <div className="servitorsignupotp-timer-content">
                  <svg className="servitorsignupotp-timer-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="servitorsignupotp-timer-text">
                    {otpSeconds > 0 ? (
                      <>{t("servitor_signup.otp.timer_text", { seconds: otpSeconds }) || `Resend code in ${otpSeconds}s`}</>
                    ) : (
                      t("servitor_signup.otp.no_code") || "Didn't receive the code?"
                    )}
                  </span>
                </div>
                {otpSeconds === 0 && (
                  <button
                    className="servitorsignupotp-resend"
                    onClick={resendOtp}
                    disabled={sendingOtp || verifyingOtp}
                  >
                    {t("servitor_signup.otp.resend") || "Resend Code"}
                  </button>
                )}
              </div>
              {/* Action Buttons */}
              <div className="servitorsignupotp-actions">
                <button
                  className="servitorsignupotp-verify-btn"
                  onClick={() => verifyOtp(otpDigits.join(""))}
                  disabled={verifyingOtp || sendingOtp || !otpDigits.every((d) => d)}
                >
                  {verifyingOtp ? (t("servitor_signup.otp.verifying") || "Verifying...") : t("servitor_signup.otp.verify") || "Verify Code"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* NEW: Success Modal */}
      {showSuccess && (
        <div className="servitorsignupotp-overlay">
          <div className="servitorsignupotp-success-modal" onClick={(e) => e.stopPropagation()}>
            <div className="servitorsignupotp-success-icon-container">
              <div className="servitorsignupotp-success-icon-bg">
                <svg className="servitorsignupotp-success-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>
            <h3 className="servitorsignupotp-success-title">{t("servitor_signup.success.title") || "Verification Successful!"}</h3>
            <p className="servitorsignupotp-success-sub">{t("servitor_signup.success.sub") || "Your registration is complete. Please login to continue."}</p>
            <p className="servitorsignupotp-success-timer">
              {t("servitor_signup.success.redirect", { seconds: successTimer }) || `Redirecting to login in ${successTimer} seconds...`}
            </p>
            <button
              className="servitorsignupotp-success-btn"
              onClick={() => navigate("/login")}
            >
              {t("servitor_signup.success.continue") || "Continue to Login"}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ServitorSignup;